import * as React from "react";
import wrapIcon from "../utils/wrapIcon";

const PersonMail20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18v-1a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.27A2 2 0 0111 11H4zm10.51 4.93l-4.5-2.63c.1-.73.73-1.3 1.49-1.3h6c.83 0 1.5.67 1.5 1.5l-4.49 2.43zm.23 1.01l4.26-2.3v2.86c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3.05l4.25 2.48c.15.09.33.1.49.01z",
    fill: primaryFill
  }));
};

export const PersonMail20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonMail20RegularIcon, 'PersonMail20Regular');

const PersonMail24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 15.5c0-.56.19-1.08.5-1.5H5.25C4.01 14 3 15 3 16.25v.92c0 .57.18 1.13.51 1.6C5.06 20.92 7.58 22 11 22h.05a2.51 2.51 0 01-.05-.5v-6zM11 2a5 5 0 110 10 5 5 0 010-10zm6.51 16.93l-5.5-3.2a2 2 0 012-1.73H21a2 2 0 012 1.97l-5.49 2.96zm.23 1.01L23 17.11V21a2 2 0 01-2 2h-7a2 2 0 01-2-2v-4.13l5.25 3.06c.15.09.33.1.49.01z",
    fill: primaryFill
  }));
};

export const PersonMail24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonMail24FilledIcon, 'PersonMail24Filled');

const PersonMail24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 15.5c0-.56.19-1.08.5-1.5H5.25C4.01 14 3 15 3 16.25v.58c0 .89.32 1.75.9 2.43C5.47 21.1 7.85 22 11 22h.05a2.51 2.51 0 01-.05-.5v-1c-2.74 0-4.7-.74-5.96-2.21-.34-.4-.54-.93-.54-1.46v-.58c0-.41.34-.75.75-.75H11zM11 2a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm6.51 15.43l-5.5-3.2a2 2 0 012-1.73H21a2 2 0 012 1.97l-5.49 2.96zm.23 1.01L23 17.11V21a2 2 0 01-2 2h-7a2 2 0 01-2-2v-4.13l5.25 3.06c.15.09.33.1.49.01z",
    fill: primaryFill
  }));
};

export const PersonMail24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonMail24RegularIcon, 'PersonMail24Regular');

const PersonMail28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.17 26a3 3 0 01-.17-1v-7c0-.77.29-1.47.76-2H6a3 3 0 00-3 3v.71C3 23.43 7.21 26 13 26h.17zM19 8A6 6 0 107 8a6 6 0 0012 0zm-2.5 8a2.5 2.5 0 00-2.5 2.5v.2l6.5 3.24L27 18.7v-.19a2.5 2.5 0 00-2.5-2.5h-8zM27 19.8l-6.28 3.15a.5.5 0 01-.44 0L14 19.8v4.69a2.5 2.5 0 002.5 2.5h8a2.5 2.5 0 002.5-2.5v-4.7z",
    fill: primaryFill
  }));
};

export const PersonMail28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonMail28FilledIcon, 'PersonMail28Filled');

const PersonMail28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 25a3 3 0 00.17 1H13c-5.79 0-10-2.57-10-6.29V19a3 3 0 013-3h7.76c-.37.41-.62.93-.72 1.5H6c-.78 0-1.42.6-1.5 1.36v.85c0 2.68 3.39 4.79 8.5 4.79v.5zm0-23a6 6 0 110 12 6 6 0 010-12zm0 1.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm1 15a2.5 2.5 0 012.5-2.5h8a2.5 2.5 0 012.5 2.5v.2l-6.5 3.24L14 18.7v-.19zm6.72 4.45L27 19.8v4.69a2.5 2.5 0 01-2.5 2.5h-8a2.5 2.5 0 01-2.5-2.5v-4.7l6.28 3.15c.14.07.3.07.44 0z",
    fill: primaryFill
  }));
};

export const PersonMail28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonMail28RegularIcon, 'PersonMail28Regular');

const PersonMail48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 4a10 10 0 100 20 10 10 0 000-20zM10.25 28A4.25 4.25 0 006 32.25V33c0 3.76 1.94 6.57 4.92 8.38C13.85 43.16 17.79 44 22 44V30c0-.73.2-1.41.54-2H10.25zM24 31a3 3 0 013-3h16a3 3 0 013 3v.79l-11 5.1-11-5.1V31zm11.42 7.9L46 34v9a3 3 0 01-3 3H27a3 3 0 01-3-3v-9l10.58 4.9a1 1 0 00.84 0z",
    fill: primaryFill
  }));
};

export const PersonMail48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonMail48FilledIcon, 'PersonMail48Filled');

const PersonMail48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 4a10 10 0 100 20 10 10 0 000-20zm-7.5 10a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0zm-4.25 14A4.25 4.25 0 006 32.25V33c0 3.76 1.94 6.57 4.92 8.38C13.85 43.16 17.79 44 22 44v-2.5c-3.93 0-7.37-.79-9.78-2.26C9.86 37.81 8.5 35.74 8.5 33v-.75c0-.97.78-1.75 1.75-1.75H22V30c0-.73.2-1.41.54-2H10.25zM24 31a3 3 0 013-3h16a3 3 0 013 3v.79l-11 5.1-11-5.1V31zm11.42 7.9L46 34v9a3 3 0 01-3 3H27a3 3 0 01-3-3v-9l10.58 4.9a1 1 0 00.84 0z",
    fill: primaryFill
  }));
};

export const PersonMail48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonMail48RegularIcon, 'PersonMail48Regular');

const PersonMoney20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A8.46 8.46 0 009 17.96V14c0-1.1.9-2 2-2h5.73A2 2 0 0015 11H5zm14 3.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5zm-1 3v-1c-.83 0-1.5.67-1.5 1.5h1c0-.28.22-.5.5-.5zm0-3a.5.5 0 01-.5-.5h-1c0 .83.67 1.5 1.5 1.5v-1zm-6.5-.5a.5.5 0 01-.5.5v1c.83 0 1.5-.67 1.5-1.5h-1zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5v1zm3.5-3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const PersonMoney20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonMoney20FilledIcon, 'PersonMoney20Filled');

const PersonMoney20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zM7 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A8.46 8.46 0 009 17.96v-1a7.42 7.42 0 01-3.33-1A3.36 3.36 0 014 13a1 1 0 011-1h11.73A2 2 0 0015 11H5zm14 3.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5zm-1 3v-1c-.83 0-1.5.67-1.5 1.5h1c0-.28.22-.5.5-.5zm0-3a.5.5 0 01-.5-.5h-1c0 .83.67 1.5 1.5 1.5v-1zm-6.5-.5a.5.5 0 01-.5.5v1c.83 0 1.5-.67 1.5-1.5h-1zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5v1zm3.5-3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const PersonMoney20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonMoney20RegularIcon, 'PersonMoney20Regular');

const PersonMoney24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 14c.78 0 1.47.4 1.87 1H13.5a2.5 2.5 0 00-2.5 2.5v4c0 .16.02.32.04.47-2.93-.18-5.13-1.25-6.53-3.2a2.75 2.75 0 01-.5-1.6v-.92C4 15 5 14 6.24 14h11.5zM12 2a5 5 0 110 10 5 5 0 010-10zm0 15.5c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 01-1.5-1.5v-4zm10 .5a1 1 0 01-1-1h-1c0 1.1.9 2 2 2v-1zm0 2a2 2 0 00-2 2h1a1 1 0 011-1v-1zm-8-3a1 1 0 01-1 1v1a2 2 0 002-2h-1zm1 5a2 2 0 00-2-2v1a1 1 0 011 1h1zm4.25-2.5a1.75 1.75 0 10-3.5 0 1.75 1.75 0 003.5 0z",
    fill: primaryFill
  }));
};

export const PersonMoney24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonMoney24FilledIcon, 'PersonMoney24Filled');

const PersonMoney24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 14c.78 0 1.47.4 1.87 1H13.5c-.56 0-1.08.19-1.5.5H6.25a.75.75 0 00-.75.75v.58c0 .53.2 1.05.54 1.46 1.1 1.28 2.74 2.01 4.96 2.18v1.03c0 .16.02.32.04.47-2.67-.17-4.73-1.06-6.14-2.7a3.75 3.75 0 01-.9-2.44v-.58C4 15 5.01 14 6.25 14h11.5zM12 2a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm0 14c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 01-1.5-1.5v-4zm10 .5a1 1 0 01-1-1h-1c0 1.1.9 2 2 2v-1zm0 2a2 2 0 00-2 2h1a1 1 0 011-1v-1zm-8-3a1 1 0 01-1 1v1a2 2 0 002-2h-1zm1 5a2 2 0 00-2-2v1a1 1 0 011 1h1zm4.25-2.5a1.75 1.75 0 10-3.5 0 1.75 1.75 0 003.5 0z",
    fill: primaryFill
  }));
};

export const PersonMoney24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonMoney24RegularIcon, 'PersonMoney24Regular');

const PersonNote16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 10v3.93c-2.53-.38-4-2.18-4-3.93v-.5C2 8.67 2.67 8 3.5 8h3.26A2.99 2.99 0 006 10zm1-8.5A2.75 2.75 0 117 7a2.75 2.75 0 010-5.5zM9 8a2 2 0 00-2 2v4c0 1.1.9 2 2 2h5a2 2 0 002-2v-4a2 2 0 00-2-2H9zm.5 5h4a.5.5 0 110 1h-4a.5.5 0 010-1zM9 10.5c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PersonNote16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonNote16FilledIcon, 'PersonNote16Filled');

const PersonNote16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 12.91v1.02c-2.53-.38-4-2.18-4-3.93v-.5C2 8.67 2.67 8 3.5 8h3.26a3 3 0 00-.59 1H3.5a.5.5 0 00-.5.5v.5c0 1.24 1.06 2.57 3 2.91zM7 1.5A2.75 2.75 0 117 7a2.75 2.75 0 010-5.5zm0 1A1.75 1.75 0 107 6a1.75 1.75 0 000-3.5zM9 8a2 2 0 00-2 2v4c0 1.1.9 2 2 2h5a2 2 0 002-2v-4a2 2 0 00-2-2H9zm.5 5h4a.5.5 0 110 1h-4a.5.5 0 010-1zM9 10.5c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PersonNote16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonNote16RegularIcon, 'PersonNote16Regular');

const PersonNote20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8 1.1.69 2.5 1.07 4.03 1.17A3 3 0 019 17v-4c0-.77.29-1.47.76-2H5.01zm5 2c0-1.1.9-2 2-2h5a2 2 0 012 2v4a2 2 0 01-2 2h-5a2 2 0 01-2-2v-4zm6.5 3h-4a.5.5 0 100 1h4a.5.5 0 100-1zm-4-3a.5.5 0 100 1h4a.5.5 0 100-1h-4z",
    fill: primaryFill
  }));
};

export const PersonNote20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonNote20FilledIcon, 'PersonNote20Filled');

const PersonNote20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zM7 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8 1.1.69 2.5 1.07 4.03 1.17A3 3 0 019 17v-.04a7.42 7.42 0 01-3.33-1A3.36 3.36 0 014 13a1 1 0 011-1h4.17a3 3 0 01.6-1H5zm5 2c0-1.1.9-2 2-2h5a2 2 0 012 2v4a2 2 0 01-2 2h-5a2 2 0 01-2-2v-4zm6.5 3h-4a.5.5 0 100 1h4a.5.5 0 100-1zm-4-3a.5.5 0 100 1h4a.5.5 0 100-1h-4z",
    fill: primaryFill
  }));
};

export const PersonNote20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonNote20RegularIcon, 'PersonNote20Regular');

const PersonNote24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 15a3 3 0 01.17-1H4.25C3.01 14 2 15 2 16.25v.92c0 .57.18 1.13.51 1.6C4.06 20.92 6.58 22 10 22c.4 0 .78-.01 1.16-.04A3 3 0 0111 21v-6zM10 2a5 5 0 110 10 5 5 0 010-10zm2 13c0-1.1.9-2 2-2h7a2 2 0 012 2v6a2 2 0 01-2 2h-7a2 2 0 01-2-2v-6zm2.5 1a.5.5 0 100 1h6a.5.5 0 100-1h-6zm0 3a.5.5 0 100 1h6a.5.5 0 100-1h-6z",
    fill: primaryFill
  }));
};

export const PersonNote24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonNote24FilledIcon, 'PersonNote24Filled');

const PersonNote24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 15a3 3 0 01.17-1H4.25C3.01 14 2 15 2 16.25v.58c0 .89.32 1.75.9 2.43C4.47 21.1 6.85 22 10 22c.4 0 .78-.01 1.16-.04A3 3 0 0111 21v-.53c-.32.02-.65.03-1 .03-2.74 0-4.7-.74-5.96-2.21-.34-.4-.54-.93-.54-1.46v-.58c0-.41.34-.75.75-.75H11V15zM10 2a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM12 15c0-1.1.9-2 2-2h7a2 2 0 012 2v6a2 2 0 01-2 2h-7a2 2 0 01-2-2v-6zm2.5 1a.5.5 0 100 1h6a.5.5 0 100-1h-6zm0 3a.5.5 0 100 1h6a.5.5 0 100-1h-6z",
    fill: primaryFill
  }));
};

export const PersonNote24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonNote24RegularIcon, 'PersonNote24Regular');

const PersonPill20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zm2.88 9l-2.94 2.94a3.62 3.62 0 00-.75 4.03 8.59 8.59 0 01-4.06-1.17A4.35 4.35 0 013 13a2 2 0 012-2h7.88zm5.47-.35a2.62 2.62 0 00-3.7 0l-4 4a2.62 2.62 0 003.7 3.7l4-4a2.62 2.62 0 000-3.7zm-3 .7a1.62 1.62 0 112.3 2.3L16 15.29 13.7 13l1.65-1.65zm-1.5 4.3c.2.2.2.5 0 .7l-1 1a.5.5 0 01-.7-.7l1-1c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const PersonPill20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonPill20FilledIcon, 'PersonPill20Filled');

const PersonPill20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zM7 6a3 3 0 116 0 3 3 0 01-6 0zm5.88 5H5A2 2 0 003 13c0 1.7.83 2.97 2.13 3.8 1.1.7 2.52 1.08 4.06 1.17a3.61 3.61 0 01-.28-1.02 7.35 7.35 0 01-3.24-1A3.36 3.36 0 014 13a1 1 0 011-1h6.88l1-1zm5.47-.35a2.62 2.62 0 00-3.7 0l-4 4a2.62 2.62 0 003.7 3.7l4-4a2.62 2.62 0 000-3.7zm-3 .7a1.62 1.62 0 112.3 2.3L16 15.29 13.7 13l1.65-1.65zm-1.5 4.3c.2.2.2.5 0 .7l-1 1a.5.5 0 01-.7-.7l1-1c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const PersonPill20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonPill20RegularIcon, 'PersonPill20Regular');

const PersonPill24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.68 22c-.9-1.5-.7-3.45.58-4.74L15.53 14H6.25C5.01 14 4 15 4 16.25v.92c0 .57.18 1.13.51 1.6 1.5 2.1 3.91 3.16 7.17 3.23zM17 7A5 5 0 107 7a5 5 0 0010 0zm.97 5.97a2.87 2.87 0 014.06 4.06l-5 5a2.87 2.87 0 01-4.06-4.06l5-5zm3 1.06a1.37 1.37 0 00-1.94 0L17.06 16 19 17.94l1.97-1.97c.54-.54.54-1.4 0-1.94zm-3.94 6a.75.75 0 10-1.06-1.06l-1 1a.75.75 0 101.06 1.06l1-1z",
    fill: primaryFill
  }));
};

export const PersonPill24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonPill24FilledIcon, 'PersonPill24Filled');

const PersonPill24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.16 20.48c.06.53.24 1.05.52 1.52-2.99-.06-5.26-.97-6.78-2.74a3.75 3.75 0 01-.9-2.43v-.58C4 15 5.01 14 6.25 14h9.28l-1.5 1.5H6.25a.75.75 0 00-.75.75v.58c0 .53.2 1.05.54 1.46 1.12 1.3 2.81 2.04 5.12 2.19zM12 2a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm10.03 9.47a2.87 2.87 0 00-4.06 0l-5 5a2.87 2.87 0 004.06 4.06l5-5a2.87 2.87 0 000-4.06zm-3 1.06a1.37 1.37 0 111.94 1.94L19 17.94 17.06 16l1.97-1.97zm-2 4.94c.3.3.3.77 0 1.06l-1 1a.75.75 0 01-1.06-1.06l1-1c.3-.3.77-.3 1.06 0z",
    fill: primaryFill
  }));
};

export const PersonPill24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonPill24RegularIcon, 'PersonPill24Regular');

const PersonProhibited16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 15a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2.8-2.4l4.9-4.9a3.5 3.5 0 00-4.9 4.9zm.7.7a3.5 3.5 0 004.9-4.9l-4.9 4.9zm1.23-8.23a5.5 5.5 0 00-3.3 1.85 2.75 2.75 0 113.3-1.85zM5.6 8a5.48 5.48 0 00.62 5.96C3.55 13.66 2 11.8 2 10v-.5C2 8.67 2.67 8 3.5 8h2.1z",
    fill: primaryFill
  }));
};

export const PersonProhibited16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonProhibited16FilledIcon, 'PersonProhibited16Filled');

const PersonProhibited16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 15a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2.8-2.4l4.9-4.9a3.5 3.5 0 00-4.9 4.9zm.7.7a3.5 3.5 0 004.9-4.9l-4.9 4.9zm-2.18.66C3.55 13.66 2 11.8 2 10v-.5C2 8.67 2.67 8 3.5 8h2.1c-.16.32-.3.65-.4 1H3.5a.5.5 0 00-.5.5v.5c0 1.13.88 2.33 2.5 2.8.2.42.44.8.72 1.16zm3.4-8.9a2.75 2.75 0 10-3.3 1.86c.32-.37.68-.7 1.08-.97a1.76 1.76 0 01-2.15-1.7 1.75 1.75 0 113 1.23c.43-.2.89-.33 1.38-.41z",
    fill: primaryFill
  }));
};

export const PersonProhibited16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonProhibited16RegularIcon, 'PersonProhibited16Regular');

const PersonProhibited20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06a5.48 5.48 0 01.05-6.94H4zm6 3.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm2.4 2.8l4.9-4.9a3.5 3.5 0 01-4.9 4.9zm-.7-.7a3.5 3.5 0 014.9-4.9l-4.9 4.9z",
    fill: primaryFill
  }));
};

export const PersonProhibited20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonProhibited20FilledIcon, 'PersonProhibited20Filled');

const PersonProhibited20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 019.6 17 12 12 0 019 17a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.6c.18-.36.4-.7.66-1H4zm6 3.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm2.4 2.8l4.9-4.9a3.5 3.5 0 01-4.9 4.9zm-.7-.7a3.5 3.5 0 014.9-4.9l-4.9 4.9z",
    fill: primaryFill
  }));
};

export const PersonProhibited20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonProhibited20RegularIcon, 'PersonProhibited20Regular');

const PersonProhibited24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm-5.48 2a6.47 6.47 0 00.6 7.79c-.8.14-1.68.21-2.62.21-2.89 0-5.13-.66-6.7-2A3.75 3.75 0 012 17.16v-.91C2 15.01 3.01 14 4.25 14h7.77zm8.79 1.25l-5.56 5.56a4 4 0 005.56-5.56zM17.5 13.5a4 4 0 00-3.3 6.25l5.55-5.56a3.98 3.98 0 00-2.25-.69zM10 2a5 5 0 110 10 5 5 0 010-10z",
    fill: primaryFill
  }));
};

export const PersonProhibited24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonProhibited24FilledIcon, 'PersonProhibited24Filled');

const PersonProhibited24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm-5.48 2c-.3.46-.53.97-.7 1.5H4.24a.75.75 0 00-.75.75v.9c0 .66.29 1.29.79 1.71C5.55 19.95 7.44 20.5 10 20.5c.6 0 1.16-.03 1.69-.09.25.5.56.96.93 1.38-.8.14-1.68.21-2.62.21-2.89 0-5.13-.66-6.7-2A3.75 3.75 0 012 17.16v-.91C2 15.01 3.01 14 4.25 14h7.77zm8.79 1.25l-5.56 5.56a4 4 0 005.56-5.56zM17.5 13.5a4 4 0 00-3.3 6.25l5.55-5.56a3.98 3.98 0 00-2.25-.69zM10 2a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7z",
    fill: primaryFill
  }));
};

export const PersonProhibited24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonProhibited24RegularIcon, 'PersonProhibited24Regular');

const PersonProhibited28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.11 25.72A7.48 7.48 0 0114.5 16H5a3 3 0 00-3 3v.71C2 23.43 6.21 26 12 26c1.1 0 2.14-.1 3.11-.28zM18 8A6 6 0 106 8a6 6 0 0012 0zm9 12.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-1.5 0c0-1.11-.36-2.14-.97-2.97l-7 7a5 5 0 007.97-4.03zm-9.03 2.97l7-7a5 5 0 00-7 7z",
    fill: primaryFill
  }));
};

export const PersonProhibited28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonProhibited28FilledIcon, 'PersonProhibited28Filled');

const PersonProhibited28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.11 25.72c-.4-.4-.74-.86-1.04-1.35-.65.08-1.34.13-2.07.13-5.11 0-8.5-2.11-8.5-4.79v-.85A1.5 1.5 0 015 17.5h8.62c.24-.54.53-1.04.88-1.5H5a3 3 0 00-3 3v.71C2 23.43 6.21 26 12 26c1.1 0 2.14-.1 3.11-.28zM18 8A6 6 0 106 8a6 6 0 0012 0zM7.5 8a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM27 20.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-1.5 0c0-1.11-.36-2.14-.97-2.97l-7 7a5 5 0 007.97-4.03zm-9.03 2.97l7-7a5 5 0 00-7 7z",
    fill: primaryFill
  }));
};

export const PersonProhibited28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonProhibited28RegularIcon, 'PersonProhibited28Regular');

const PersonQuestionMark16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 9c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4-3.14 0-5-2.03-5-4v-.5C1 9.67 1.67 9 2.5 9h7zM13 7a.75.75 0 110 1.5.75.75 0 010-1.5zM6 2.5A2.75 2.75 0 116 8a2.75 2.75 0 010-5.5zM13 1a2 2 0 012 2c0 .73-.21 1.14-.75 1.7l-.27.28c-.38.4-.48.6-.48 1.02a.5.5 0 01-1 0c0-.73.21-1.14.75-1.7l.27-.28c.38-.4.48-.6.48-1.02a1 1 0 10-2 0 .5.5 0 01-1 0c0-1.1.9-2 2-2z",
    fill: primaryFill
  }));
};

export const PersonQuestionMark16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonQuestionMark16FilledIcon, 'PersonQuestionMark16Filled');

const PersonQuestionMark16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 9c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4-3.14 0-5-2.03-5-4v-.5C1 9.67 1.67 9 2.5 9h7zm0 1h-7a.5.5 0 00-.5.5v.5c0 1.44 1.43 3 4 3 2.57 0 4-1.56 4-3v-.5a.5.5 0 00-.5-.5zM13 7a.75.75 0 110 1.5.75.75 0 010-1.5zM6 2.5A2.75 2.75 0 116 8a2.75 2.75 0 010-5.5zm0 1A1.75 1.75 0 106 7a1.75 1.75 0 000-3.5zM13 1a2 2 0 012 2c0 .73-.21 1.14-.75 1.7l-.27.28c-.38.4-.48.6-.48 1.02a.5.5 0 01-1 0c0-.73.21-1.14.75-1.7l.27-.28c.38-.4.48-.6.48-1.02a1 1 0 10-2 0 .5.5 0 01-1 0c0-1.1.9-2 2-2z",
    fill: primaryFill
  }));
};

export const PersonQuestionMark16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonQuestionMark16RegularIcon, 'PersonQuestionMark16Regular');

const PersonQuestionMark20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.62-2a.62.62 0 11-1.24 0 .62.62 0 011.24 0zm1.23-3.55c0 .59-.21.91-.72 1.32l-.28.22c-.25.19-.33.3-.35.44v.16a.5.5 0 01-1-.09c0-.57.21-.88.72-1.29l.27-.21c.3-.23.36-.35.36-.55 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 11-1 0c-.01-1.13.8-1.95 1.85-1.95 1.03 0 1.85.85 1.85 1.95zM9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06a5.48 5.48 0 01.05-6.94H4z",
    fill: primaryFill
  }));
};

export const PersonQuestionMark20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonQuestionMark20FilledIcon, 'PersonQuestionMark20Filled');

const PersonQuestionMark20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 019.6 17 12 12 0 019 17a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.6c.18-.36.4-.7.66-1H4zm10.5 8a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm.62-2a.62.62 0 10-1.24 0 .62.62 0 001.24 0zm1.23-3.55c0-1.1-.82-1.95-1.85-1.95-1.05 0-1.86.82-1.85 1.96a.5.5 0 101-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 001 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32z",
    fill: primaryFill
  }));
};

export const PersonQuestionMark20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonQuestionMark20RegularIcon, 'PersonQuestionMark20Regular');

const PersonQuestionMark24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.02 14a6.47 6.47 0 00.57 7.76c-.8.16-1.66.24-2.59.24-3.42 0-5.94-1.07-7.49-3.24a2.75 2.75 0 01-.5-1.6v-.91C2 15 3 14 4.24 14h7.77zm5.48-2a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm0 7.75a.62.62 0 100 1.25.62.62 0 000-1.25zm0-5.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 001-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.05.35-.22.57l-.1.11-.1.11-.26.3-.14.15c-.38.46-.53.8-.53 1.31a.5.5 0 101 0c0-.2.06-.36.24-.59l.08-.1.1-.12.27-.29.14-.15c.37-.45.52-.79.52-1.3 0-1.1-.82-1.95-1.85-1.95zM10 2a5 5 0 110 10 5 5 0 010-10z",
    fill: primaryFill
  }));
};

export const PersonQuestionMark24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonQuestionMark24FilledIcon, 'PersonQuestionMark24Filled');

const PersonQuestionMark24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm0 7.75a.62.62 0 100 1.25.62.62 0 000-1.25zm0-5.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 001-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.05.35-.22.57l-.1.11-.1.11-.26.3-.14.15c-.38.46-.53.8-.53 1.31a.5.5 0 101 0c0-.2.06-.36.24-.59l.08-.1.1-.12.27-.29.14-.15c.37-.45.52-.79.52-1.3 0-1.1-.82-1.95-1.85-1.95zm-5.48.13c-.3.46-.53.97-.7 1.5H4.24a.75.75 0 00-.75.75v.58c0 .53.2 1.05.54 1.46C5.3 19.76 7.26 20.5 10 20.5c.6 0 1.16-.03 1.68-.1.25.49.55.95.91 1.36-.8.16-1.66.24-2.59.24-3.15 0-5.53-.9-7.1-2.74a3.75 3.75 0 01-.9-2.43v-.58C2 15 3.01 14 4.25 14h7.77zM10 2a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7z",
    fill: primaryFill
  }));
};

export const PersonQuestionMark24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonQuestionMark24RegularIcon, 'PersonQuestionMark24Regular');

const PersonRunning20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 4.5a2 2 0 112.61 1.9l1.6 1.6h1.79a1.5 1.5 0 010 3h-3.22c-.63 0-1.24-.25-1.68-.7l-.1-.1-1.04 1.05 1.4 1.4c.09.09.14.22.14.35v3.5a1.5 1.5 0 01-3 0v-1.8l-1.55-1.54-1 .75c-.5.38-1.13.59-1.76.59H2.5a1.5 1.5 0 010-3h4.25c1.24 0 2.25-1 2.25-2.25V8h1a.5.5 0 000-1H8.5a.5.5 0 00-.5.5v1.75a1.25 1.25 0 11-2.5 0V7A2.5 2.5 0 018 4.5h3.5z",
    fill: primaryFill
  }));
};

export const PersonRunning20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonRunning20FilledIcon, 'PersonRunning20Filled');

const PersonRunning20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 6a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm1.33.62A2.5 2.5 0 1011 4.5H8A2.5 2.5 0 005.5 7v1.75c0 .69.4 1.28.97 1.57L5.8 11H2.75a1.75 1.75 0 100 3.5h2.94c.63 0 1.25-.2 1.76-.59l1-.75L10 14.71v1.54a1.75 1.75 0 103.5 0V13a.5.5 0 00-.15-.35L11.71 11l.79-.8.1.1c.44.45 1.05.7 1.68.7h2.97a1.75 1.75 0 100-3.5h-1.54l-.88-.88zm-1.05.36l1.37 1.37c.09.1.22.15.35.15h1.75a.75.75 0 010 1.5h-2.97c-.37 0-.72-.15-.98-.4l-.45-.45a.5.5 0 00-.7 0l-1.5 1.5a.5.5 0 000 .7l1.85 1.86v3.04a.75.75 0 01-1.5 0V14.5a.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.65-.05l-1.35 1.01c-.33.25-.74.39-1.16.39H2.75a.75.75 0 010-1.5H6a.5.5 0 00.35-.15l1.44-1.44C8.5 10.2 9 9.53 9 8.75V8h1a.5.5 0 000-1H8.5a.5.5 0 00-.5.5v1.25a.75.75 0 01-1.5 0V7c0-.83.67-1.5 1.5-1.5h3.2a2.5 2.5 0 002.58 1.48z",
    fill: primaryFill
  }));
};

export const PersonRunning20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonRunning20RegularIcon, 'PersonRunning20Regular');

const PersonSettings16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.63 5.07a5.5 5.5 0 00-3.3 1.85 2.75 2.75 0 113.3-1.85zM5.6 8a5.48 5.48 0 00.62 5.96C3.55 13.66 2 11.8 2 10v-.5C2 8.67 2.67 8 3.5 8h2.1zm1.03 1.92a2 2 0 001.44-2.48L7.9 6.9c.25-.2.53-.37.82-.5l.34.36a2 2 0 002.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 001.46 2.52l.35.09a4.7 4.7 0 010 1.01l-.45.12a2 2 0 00-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 00-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.35-.09a4.7 4.7 0 010-1.01l.45-.12zm4.87.58a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const PersonSettings16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSettings16FilledIcon, 'PersonSettings16Filled');

const PersonSettings16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.22 13.96C3.55 13.66 2 11.8 2 10v-.5C2 8.67 2.67 8 3.5 8h2.1c-.16.32-.3.65-.4 1H3.5a.5.5 0 00-.5.5v.5c0 1.13.88 2.33 2.5 2.8.2.42.44.8.72 1.16zm3.4-8.9a2.75 2.75 0 10-3.3 1.86c.32-.37.68-.7 1.08-.97a1.76 1.76 0 01-2.15-1.7 1.75 1.75 0 113 1.23c.43-.2.89-.33 1.38-.41zM6.64 9.93a2 2 0 001.44-2.48L7.9 6.9c.25-.2.53-.37.82-.5l.34.36a2 2 0 002.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 001.46 2.52l.35.09a4.7 4.7 0 010 1.01l-.45.12a2 2 0 00-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 00-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.35-.09a4.7 4.7 0 010-1.01l.45-.12zm4.87.58a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const PersonSettings16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSettings16RegularIcon, 'PersonSettings16Regular');

const PersonSettings20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06a5.48 5.48 0 01.05-6.94H4zm6.64 2.92a2 2 0 001.43-2.48l-.16-.55c.25-.2.53-.37.82-.5l.34.36a2 2 0 002.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 001.46 2.52l.35.09a4.7 4.7 0 010 1.01l-.45.12a2 2 0 00-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 00-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.35-.09a4.71 4.71 0 010-1.01l.46-.12zm4.86.58a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const PersonSettings20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSettings20FilledIcon, 'PersonSettings20Filled');

const PersonSettings20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 019.6 17 12 12 0 019 17a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.6c.18-.36.4-.7.66-1H4zm6.64 2.92a2 2 0 001.43-2.48l-.16-.55c.25-.2.53-.37.82-.5l.34.36a2 2 0 002.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 001.46 2.52l.35.09a4.7 4.7 0 010 1.01l-.45.12a2 2 0 00-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 00-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.35-.09a4.71 4.71 0 010-1.01l.46-.12zm4.86.58a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const PersonSettings20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSettings20RegularIcon, 'PersonSettings20Regular');

const PersonSquare20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm7-1a2 2 0 100 4 2 2 0 000-4zm2.5 5h-5c-.83 0-1.5.67-1.5 1.5 0 1.12.46 2.01 1.21 2.61.74.6 1.74.89 2.79.89s2.05-.29 2.79-.89c.75-.6 1.21-1.5 1.21-2.61 0-.83-.67-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const PersonSquare20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSquare20FilledIcon, 'PersonSquare20Filled');

const PersonSquare20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5a2 2 0 100 4 2 2 0 000-4zm2.5 5h-5c-.83 0-1.5.67-1.5 1.5 0 1.12.46 2.01 1.21 2.61.74.6 1.74.89 2.79.89s2.05-.29 2.79-.89c.75-.6 1.21-1.5 1.21-2.61 0-.83-.67-1.5-1.5-1.5zM6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zM4 6c0-1.1.9-2 2-2h8a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V6z",
    fill: primaryFill
  }));
};

export const PersonSquare20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSquare20RegularIcon, 'PersonSquare20Regular');

const PersonSquare24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25A3.25 3.25 0 003 6.25zM15.5 12c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4-3.14 0-5-2.03-5-4v-.5c0-.83.67-1.5 1.5-1.5h7zM12 5.5a2.75 2.75 0 110 5.5 2.75 2.75 0 010-5.5z",
    fill: primaryFill
  }));
};

export const PersonSquare24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSquare24FilledIcon, 'PersonSquare24Filled');

const PersonSquare24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.5 12c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4-3.14 0-5-2.03-5-4v-.5c0-.83.67-1.5 1.5-1.5h7zM12 5.5a2.75 2.75 0 110 5.5 2.75 2.75 0 010-5.5zM6.25 3A3.25 3.25 0 003 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25zM4.5 6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v11.5c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75V6.25z",
    fill: primaryFill
  }));
};

export const PersonSquare24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSquare24RegularIcon, 'PersonSquare24Regular');

const PersonStar16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.33 6.92a5.5 5.5 0 013.3-1.85 2.75 2.75 0 10-3.3 1.85zM5 10.5c0-.9.22-1.75.6-2.5H3.5C2.67 8 2 8.67 2 9.5v.5c0 1.8 1.55 3.65 4.22 3.96A5.48 5.48 0 015 10.5zm10 0a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.02-2.64a.5.5 0 00-.96 0L9.55 9.4H8c-.48 0-.68.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54l-.47-1.53z",
    fill: primaryFill
  }));
};

export const PersonStar16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStar16FilledIcon, 'PersonStar16Filled');

const PersonStar16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10c0 1.8 1.55 3.65 4.22 3.96a5.5 5.5 0 01-.72-1.16C3.88 12.33 3 11.13 3 10v-.5c0-.28.22-.5.5-.5h1.7c.1-.35.24-.68.4-1H3.5C2.67 8 2 8.67 2 9.5v.5zm7.75-5.75c0 .29-.04.56-.12.82-.49.08-.95.22-1.39.41A1.74 1.74 0 007 2.5a1.75 1.75 0 10.4 3.45c-.4.28-.76.6-1.07.97a2.75 2.75 0 113.42-2.67zM15 10.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.02-2.64a.5.5 0 00-.96 0L9.55 9.4H8c-.48 0-.68.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54l-.47-1.53z",
    fill: primaryFill
  }));
};

export const PersonStar16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStar16RegularIcon, 'PersonStar16Regular');

const PersonStar20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06a5.48 5.48 0 01.05-6.94H4zm15 3.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.02-2.64a.5.5 0 00-.96 0l-.47 1.53H12c-.48 0-.69.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54l-.47-1.53z",
    fill: primaryFill
  }));
};

export const PersonStar20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStar20FilledIcon, 'PersonStar20Filled');

const PersonStar20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 019.6 17 12 12 0 019 17a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.6c.18-.36.4-.7.66-1H4zm15 3.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.02-2.64a.5.5 0 00-.96 0l-.47 1.53H12c-.48 0-.69.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54l-.47-1.53z",
    fill: primaryFill
  }));
};

export const PersonStar20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStar20RegularIcon, 'PersonStar20Regular');

const PersonStar24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 17.5c0-1.29.38-2.49 1.02-3.5H5.25C4.01 14 3 15 3 16.25v.92c0 .57.18 1.13.51 1.6C5.06 20.92 7.58 22 11 22c.6 0 1.17-.03 1.72-.1A6.48 6.48 0 0111 17.5zM11 2a5 5 0 110 10 5 5 0 010-10zm12 15.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-4.94-3.08a.58.58 0 00-1.12 0l-.55 1.79h-1.8c-.57 0-.8.75-.35 1.1l1.46 1.1-.56 1.79c-.17.56.44 1.03.9.68l1.46-1.1 1.46 1.1c.46.35 1.07-.12.9-.68l-.56-1.79 1.46-1.1c.46-.35.22-1.1-.35-1.1h-1.8l-.55-1.79z",
    fill: primaryFill
  }));
};

export const PersonStar24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStar24FilledIcon, 'PersonStar24Filled');

const PersonStar24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.31 15.5c.18-.53.42-1.04.71-1.5H5.25C4.01 14 3 15 3 16.25v.58c0 .89.32 1.75.9 2.43C5.47 21.1 7.85 22 11 22c.6 0 1.17-.03 1.72-.1-.4-.42-.73-.9-1-1.42l-.72.02c-2.74 0-4.7-.75-5.96-2.21-.34-.41-.54-.93-.54-1.46v-.58c0-.42.34-.75.75-.75h6.06zM11 2a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm12 14a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-4.94-3.08a.58.58 0 00-1.12 0l-.55 1.79h-1.8c-.57 0-.8.75-.35 1.1l1.46 1.1-.56 1.79c-.17.56.44 1.03.9.68l1.46-1.1 1.46 1.1c.46.35 1.07-.12.9-.68l-.56-1.79 1.46-1.1c.46-.35.22-1.1-.35-1.1h-1.8l-.55-1.79z",
    fill: primaryFill
  }));
};

export const PersonStar24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStar24RegularIcon, 'PersonStar24Regular');

const PersonStar28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 20.5c0 2.1.86 4 2.25 5.36-.72.1-1.47.14-2.25.14-5.79 0-10-2.57-10-6.29V19a3 3 0 013-3h8.5a7.47 7.47 0 00-1.5 4.5zM13 2a6 6 0 110 12 6 6 0 010-12zm14 18.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-5.79-3.96a.74.74 0 00-1.42 0l-.72 2.3h-2.32c-.73 0-1.03.97-.44 1.41l1.88 1.42-.72 2.3c-.23.72.57 1.32 1.16.88l1.87-1.42 1.88 1.42c.58.44 1.38-.16 1.15-.88l-.72-2.3 1.88-1.42c.59-.44.29-1.41-.44-1.41h-2.32l-.72-2.3z",
    fill: primaryFill
  }));
};

export const PersonStar28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStar28FilledIcon, 'PersonStar28Filled');

const PersonStar28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.13 24.46c.32.51.7.98 1.12 1.4-.72.1-1.47.14-2.25.14-5.79 0-10-2.57-10-6.29V19a3 3 0 013-3h8.5c-.35.46-.64.96-.88 1.5H6c-.78 0-1.42.6-1.5 1.36v.85c0 2.68 3.39 4.79 8.5 4.79.39 0 .76-.01 1.13-.04zM13 2a6 6 0 110 12 6 6 0 010-12zm0 1.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm14 17a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-5.79-3.96a.74.74 0 00-1.42 0l-.72 2.3h-2.32c-.73 0-1.03.97-.44 1.41l1.88 1.42-.72 2.3c-.23.72.57 1.32 1.16.88l1.87-1.42 1.88 1.42c.58.44 1.38-.16 1.15-.88l-.72-2.3 1.88-1.42c.59-.44.29-1.41-.44-1.41h-2.32l-.72-2.3z",
    fill: primaryFill
  }));
};

export const PersonStar28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStar28RegularIcon, 'PersonStar28Regular');

const PersonStar32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 16a7 7 0 100-14 7 7 0 000 14zm-8.5 2A3.5 3.5 0 003 21.5v.5c0 2.4 1.52 4.42 3.68 5.8A15.67 15.67 0 0015 30c.74 0 1.47-.04 2.19-.13A8.98 8.98 0 0115.52 18H6.5zm24 5a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zm-8.21-4.86l-.94 2.83h-3a.75.75 0 00-.43 1.36l2.4 1.7-.92 2.8a.75.75 0 001.14.84L23 25.93l2.46 1.74a.75.75 0 001.14-.84l-.93-2.8 2.41-1.7a.75.75 0 00-.43-1.36h-3l-.94-2.83a.75.75 0 00-1.42 0z",
    fill: primaryFill
  }));
};

export const PersonStar32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStar32FilledIcon, 'PersonStar32Filled');

const PersonStar32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 9A7 7 0 118 9a7 7 0 0114 0zm-2 0a5 5 0 10-10 0 5 5 0 0010 0zM6.5 18A3.5 3.5 0 003 21.5v.5c0 2.4 1.52 4.42 3.68 5.8A15.67 15.67 0 0015 30c.74 0 1.47-.04 2.19-.13a9.05 9.05 0 01-1.68-1.88L15 28c-2.88 0-5.43-.74-7.24-1.9C5.94 24.96 5 23.48 5 22v-.5c0-.83.67-1.5 1.5-1.5h8.01c.25-.71.6-1.38 1-2H6.5zm24 5a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zm-8.21-4.86l-.94 2.83h-3a.75.75 0 00-.43 1.36l2.4 1.7-.92 2.8a.75.75 0 001.14.84L23 25.93l2.46 1.74a.75.75 0 001.14-.84l-.93-2.8 2.41-1.7a.75.75 0 00-.43-1.36h-3l-.94-2.83a.75.75 0 00-1.42 0z",
    fill: primaryFill
  }));
};

export const PersonStar32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStar32RegularIcon, 'PersonStar32Regular');

const PersonStar48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 4a10 10 0 100 20 10 10 0 000-20zM12.25 28A4.25 4.25 0 008 32.25V33c0 3.76 1.94 6.57 4.92 8.38C15.85 43.16 19.79 44 24 44c.53 0 1.06-.01 1.58-.04A12.96 12.96 0 0124.04 28H12.25zM46 35a11 11 0 11-22 0 11 11 0 0122 0zm-9.81-6.6c-.37-1.2-2-1.2-2.38 0l-1.2 3.83h-3.86c-1.2 0-1.71 1.62-.73 2.36l3.12 2.37-1.2 3.83c-.37 1.2.95 2.2 1.94 1.45L35 39.88l3.12 2.36c.99.75 2.3-.25 1.93-1.45l-1.2-3.83 3.13-2.37c.98-.74.48-2.36-.73-2.36h-3.87L36.2 28.4z",
    fill: primaryFill
  }));
};

export const PersonStar48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStar48FilledIcon, 'PersonStar48Filled');

const PersonStar48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 4a10 10 0 100 20 10 10 0 000-20zm-7.5 10a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0zm-4.25 14A4.25 4.25 0 008 32.25V33c0 3.76 1.94 6.57 4.92 8.38C15.85 43.16 19.79 44 24 44c.53 0 1.06-.01 1.58-.04-.7-.74-1.33-1.57-1.84-2.46-3.82-.04-7.16-.82-9.52-2.26-2.36-1.43-3.72-3.5-3.72-6.24v-.75c0-.97.78-1.75 1.75-1.75H22.8c.33-.88.74-1.72 1.24-2.5H12.25zM46 35a11 11 0 11-22 0 11 11 0 0122 0zm-9.81-6.6c-.37-1.2-2-1.2-2.38 0l-1.2 3.83h-3.86c-1.2 0-1.71 1.62-.73 2.36l3.12 2.37-1.2 3.83c-.37 1.2.95 2.2 1.94 1.45L35 39.88l3.12 2.36c.99.75 2.3-.25 1.93-1.45l-1.2-3.83 3.13-2.37c.98-.74.48-2.36-.73-2.36h-3.87L36.2 28.4z",
    fill: primaryFill
  }));
};

export const PersonStar48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStar48RegularIcon, 'PersonStar48Regular');

const PersonStarburst20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.96 2.67c.4-.9 1.68-.9 2.08 0 .3.66 1.13.89 1.72.46.8-.57 1.9.07 1.8 1.05-.06.72.54 1.32 1.26 1.25.98-.1 1.62 1.01 1.05 1.81-.43.59-.2 1.42.46 1.72.9.4.9 1.68 0 2.08-.66.3-.89 1.13-.46 1.72.57.8-.07 1.9-1.05 1.8a1.15 1.15 0 00-1.25 1.26c.1.98-1.01 1.62-1.81 1.05a1.15 1.15 0 00-1.72.46c-.4.9-1.68.9-2.08 0a1.15 1.15 0 00-1.72-.46c-.8.57-1.9-.07-1.8-1.05a1.15 1.15 0 00-1.26-1.25c-.98.1-1.62-1.01-1.05-1.81.43-.59.2-1.42-.46-1.72-.9-.4-.9-1.68 0-2.08.66-.3.89-1.13.46-1.72-.57-.8.07-1.9 1.05-1.8.72.06 1.32-.54 1.25-1.26-.1-.98 1.01-1.62 1.81-1.05.59.43 1.42.2 1.72-.46zM10 5a2 2 0 100 4 2 2 0 000-4zm2.5 5h-5c-.83 0-1.5.67-1.5 1.5 0 1.11.45 2 1.2 2.61.75.6 1.74.89 2.8.89 1.05 0 2.04-.3 2.78-.89.76-.6 1.22-1.5 1.22-2.61 0-.83-.68-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const PersonStarburst20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStarburst20FilledIcon, 'PersonStarburst20Filled');

const PersonStarburst20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 7a2 2 0 114 0 2 2 0 01-4 0zm-.5 3h5c.82 0 1.5.67 1.5 1.5 0 1.11-.46 2-1.22 2.61-.74.6-1.73.89-2.78.89a4.43 4.43 0 01-2.8-.89A3.25 3.25 0 016 11.5c0-.83.67-1.5 1.5-1.5zm3.94-7.07a1.57 1.57 0 00-2.88 0 .57.57 0 01-.85.23 1.57 1.57 0 00-2.49 1.43.57.57 0 01-.63.63 1.57 1.57 0 00-1.43 2.49c.2.3.1.7-.23.85a1.57 1.57 0 000 2.88c.33.14.44.56.23.85a1.57 1.57 0 001.43 2.49c.36-.04.67.27.63.63a1.57 1.57 0 002.49 1.43c.3-.2.7-.1.85.23a1.57 1.57 0 002.88 0 .57.57 0 01.85-.23c1.1.8 2.62-.08 2.49-1.43a.57.57 0 01.63-.63 1.57 1.57 0 001.43-2.49.57.57 0 01.23-.85 1.57 1.57 0 000-2.88.57.57 0 01-.23-.85 1.57 1.57 0 00-1.43-2.49.57.57 0 01-.63-.63 1.57 1.57 0 00-2.49-1.43c-.3.2-.7.1-.85-.23zm-1.96.4a.57.57 0 011.04 0c.41.91 1.55 1.22 2.36.64.4-.29.95.03.9.52-.1 1 .74 1.82 1.73 1.73.49-.05.81.5.52.9-.58.81-.27 1.95.63 2.36.45.2.45.84 0 1.04a1.57 1.57 0 00-.63 2.36c.29.4-.03.95-.52.9-1-.1-1.82.74-1.73 1.73.05.49-.5.81-.9.52a1.57 1.57 0 00-2.36.63.57.57 0 01-1.04 0 1.57 1.57 0 00-2.36-.63.57.57 0 01-.9-.52c.1-1-.74-1.82-1.73-1.73a.57.57 0 01-.52-.9c.58-.81.27-1.95-.63-2.36a.57.57 0 010-1.04c.9-.41 1.2-1.55.63-2.36a.57.57 0 01.52-.9c1 .1 1.82-.74 1.73-1.73-.05-.49.5-.81.9-.52.81.58 1.95.27 2.36-.63z",
    fill: primaryFill
  }));
};

export const PersonStarburst20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStarburst20RegularIcon, 'PersonStarburst20Regular');

const PersonStarburst24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.49 3.05a1.43 1.43 0 00-2.61 0c-.38.82-1.41 1.1-2.15.57-1-.72-2.38.08-2.26 1.3.1.9-.66 1.66-1.56 1.57A1.43 1.43 0 003.6 8.76c.53.73.25 1.76-.57 2.14a1.43 1.43 0 000 2.6c.82.38 1.1 1.42.57 2.15-.72 1 .08 2.38 1.3 2.26.9-.09 1.66.67 1.57 1.57a1.43 1.43 0 002.26 1.3 1.43 1.43 0 012.15.58 1.43 1.43 0 002.6 0c.38-.82 1.42-1.1 2.15-.57 1 .72 2.38-.08 2.26-1.3-.09-.9.67-1.67 1.57-1.58a1.43 1.43 0 001.3-2.26 1.43 1.43 0 01.58-2.14 1.43 1.43 0 000-2.61 1.43 1.43 0 01-.57-2.14c.72-1-.08-2.39-1.31-2.27-.9.1-1.66-.66-1.57-1.56a1.43 1.43 0 00-2.26-1.31c-.73.53-1.77.25-2.14-.57zM9.77 8.58a2.41 2.41 0 114.83 0 2.41 2.41 0 01-4.83 0zm-.6 3.62h6.03c1 0 1.81.81 1.81 1.81 0 1.35-.55 2.43-1.46 3.16-.9.72-2.1 1.07-3.37 1.07a5.35 5.35 0 01-3.36-1.07 3.92 3.92 0 01-1.47-3.16c0-1 .82-1.8 1.82-1.8z",
    fill: primaryFill
  }));
};

export const PersonStarburst24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStarburst24FilledIcon, 'PersonStarburst24Filled');

const PersonStarburst24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.1 3.22a2.08 2.08 0 013.8 0c.14.33.56.44.85.23a2.08 2.08 0 013.28 1.9c-.04.35.27.66.63.62a2.08 2.08 0 011.89 3.28c-.21.3-.1.7.23.86a2.08 2.08 0 010 3.78.58.58 0 00-.23.86 2.08 2.08 0 01-1.9 3.28.58.58 0 00-.62.63 2.08 2.08 0 01-3.28 1.89.58.58 0 00-.86.23 2.08 2.08 0 01-3.78 0 .58.58 0 00-.86-.23 2.08 2.08 0 01-3.28-1.9.58.58 0 00-.63-.62 2.08 2.08 0 01-1.89-3.28c.21-.3.1-.7-.23-.86a2.08 2.08 0 010-3.78.58.58 0 00.23-.86 2.08 2.08 0 011.9-3.28c.35.04.66-.27.62-.63a2.08 2.08 0 013.28-1.89c.3.21.7.1.86-.23zm2.42.62a.58.58 0 00-1.04 0 2.08 2.08 0 01-3.1.83.58.58 0 00-.92.52C7.6 6.5 6.5 7.6 5.2 7.46a.58.58 0 00-.52.91 2.08 2.08 0 01-.83 3.1.58.58 0 000 1.05c1.2.54 1.6 2.04.83 3.1-.29.4.03.96.52.92 1.3-.13 2.4.96 2.27 2.27-.04.49.51.8.91.52a2.08 2.08 0 013.1.83c.21.45.85.45 1.05 0a2.08 2.08 0 013.1-.83c.4.29.96-.03.92-.52-.13-1.3.96-2.4 2.27-2.27.49.04.8-.51.52-.91a2.08 2.08 0 01.83-3.1.58.58 0 000-1.05 2.08 2.08 0 01-.83-3.1.58.58 0 00-.52-.92c-1.3.13-2.4-.96-2.27-2.27a.58.58 0 00-.91-.52 2.08 2.08 0 01-3.1-.83zM12 5.97a2.41 2.41 0 100 4.82 2.41 2.41 0 000-4.82zM15.02 12H8.98c-1 0-1.8.81-1.8 1.81 0 1.35.55 2.43 1.46 3.16.89.71 2.09 1.07 3.36 1.07s2.47-.36 3.36-1.07c.91-.73 1.47-1.81 1.47-3.16 0-1-.81-1.81-1.81-1.81z",
    fill: primaryFill
  }));
};

export const PersonStarburst24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonStarburst24RegularIcon, 'PersonStarburst24Regular');

const PersonSubtract16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.63 5.07a5.5 5.5 0 00-3.3 1.85 2.75 2.75 0 113.3-1.85zM5.6 8a5.48 5.48 0 00.62 5.96C3.55 13.66 2 11.8 2 10v-.5C2 8.67 2.67 8 3.5 8h2.1zm4.9 7a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-2.12-5h4.24a.5.5 0 110 1H8.38a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const PersonSubtract16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSubtract16FilledIcon, 'PersonSubtract16Filled');

const PersonSubtract16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.22 13.96C3.55 13.66 2 11.8 2 10v-.5C2 8.67 2.67 8 3.5 8h2.1c-.16.32-.3.65-.4 1H3.5a.5.5 0 00-.5.5v.5c0 1.13.88 2.33 2.5 2.8.2.42.44.8.72 1.16zm3.4-8.9a2.75 2.75 0 10-3.3 1.86c.32-.37.68-.7 1.08-.97a1.76 1.76 0 01-2.15-1.7 1.75 1.75 0 113 1.23c.43-.2.89-.33 1.38-.41zM10.5 15a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-2.12-5h4.24a.5.5 0 110 1H8.38a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const PersonSubtract16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSubtract16RegularIcon, 'PersonSubtract16Regular');

const PersonSubtract20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8a9.14 9.14 0 005.13 1.2 5.48 5.48 0 010-7H5zm14 3.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-7 0c0 .28.22.5.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PersonSubtract20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSubtract20FilledIcon, 'PersonSubtract20Filled');

const PersonSubtract20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a4 4 0 100 8 4 4 0 000-8zM7 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8a9.14 9.14 0 005.13 1.2 5.5 5.5 0 01-.66-1 7.87 7.87 0 01-3.93-1.05A3.36 3.36 0 014 13a1 1 0 011-1h4.6c.18-.36.4-.7.66-1H5zm14 3.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-7 0c0 .28.22.5.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PersonSubtract20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSubtract20RegularIcon, 'PersonSubtract20Regular');

const PersonSupport16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 9.75c0-.83-.67-1.5-1.5-1.5h-7c-.83 0-1.5.67-1.5 1.5v.5c0 1.97 1.86 4 5 4 3.14 0 5-2.03 5-4v-.5zM10.75 4.5A2.75 2.75 0 005.69 3H4a.5.5 0 00-.5.5v2a.5.5 0 000 .05v.95C3.5 7.33 4.17 8 5 8h.38a.61.61 0 10-.46-1 .5.5 0 01-.42-.5V6h.25c.3 0 .57-.09.8-.24a2.75 2.75 0 005.2-1.26zm-5.5 0a.5.5 0 01-.5.5H4.5V4h.75v.5z",
    fill: primaryFill
  }));
};

export const PersonSupport16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSupport16FilledIcon, 'PersonSupport16Filled');

const PersonSupport16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 9.75c0-.83-.67-1.5-1.5-1.5h-7c-.83 0-1.5.67-1.5 1.5v.5c0 1.97 1.86 4 5 4 3.14 0 5-2.03 5-4v-.5zm-9 0c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v.5c0 1.44-1.43 3-4 3-2.57 0-4-1.56-4-3v-.5zm6.75-5.25A2.75 2.75 0 005.69 3H4a.5.5 0 00-.5.5v2a.5.5 0 000 .05v.95C3.5 7.33 4.17 8 5 8h.38a.61.61 0 10-.46-1 .5.5 0 01-.42-.5V6h.25c.3 0 .57-.09.8-.24a2.75 2.75 0 005.2-1.26zm-4.5 0a1.75 1.75 0 113.5 0 1.75 1.75 0 01-3.5 0zm-1 0a.5.5 0 01-.5.5H4.5V4h.75v.5z",
    fill: primaryFill
  }));
};

export const PersonSupport16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSupport16RegularIcon, 'PersonSupport16Regular');

const PersonSupport20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.53 4a4 4 0 11-.14 3.72A1.5 1.5 0 015.5 8H5v.26c0 .19.07.36.2.5A.75.75 0 115.67 10 1.74 1.74 0 014 8.26V4.5c0-.28.23-.5.5-.5h2.03zM5 7h.5a.5.5 0 00.5-.5v-.37a4.08 4.08 0 010-.26V5H5v2zm-2 6a2 2 0 012-2h10a2 2 0 012 2c0 1.7-.83 2.97-2.13 3.8A9.14 9.14 0 0110 18a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 013 13z",
    fill: primaryFill
  }));
};

export const PersonSupport20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSupport20FilledIcon, 'PersonSupport20Filled');

const PersonSupport20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.53 4a4 4 0 11-.14 3.72A1.5 1.5 0 015.5 8H5v.26c0 .19.07.36.2.5A.75.75 0 115.67 10 1.74 1.74 0 014 8.26V4.5c0-.28.23-.5.5-.5h2.03zM7 6.13a3 3 0 100-.24v.24zm-1-.26v-.85H5v2h.5a.5.5 0 00.5-.5v-.37a4.08 4.08 0 010-.28zM3 13a2 2 0 012-2h10a2 2 0 012 2c0 1.7-.83 2.97-2.13 3.8A9.14 9.14 0 0110 18a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 013 13zm2-1a1 1 0 00-1 1c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 0010 17c1.74 0 3.26-.36 4.33-1.05A3.36 3.36 0 0016 13a1 1 0 00-1-1H5z",
    fill: primaryFill
  }));
};

export const PersonSupport20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSupport20RegularIcon, 'PersonSupport20Regular');

const PersonSupport24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20 16.25C20 15 19 14 17.75 14H6.25C5 14 4 15 4 16.25v.92c0 .57.18 1.13.51 1.6C6.05 20.92 8.58 22 12 22s5.94-1.07 7.49-3.24c.33-.46.51-1.02.51-1.6v-.91zM17 7a5 5 0 00-9.03-2.97.75.75 0 00-.22-.03h-2.5a.75.75 0 00-.75.75v5.5A2.75 2.75 0 007.25 13h.26a1 1 0 10-.79-1.62c-.42-.2-.72-.63-.72-1.13V10h.75c.38 0 .73-.12 1.02-.33A5 5 0 0017 7zM7 6.9a5.11 5.11 0 000 .2v1.15c0 .14-.11.25-.25.25H6v-3h1v1.4z",
    fill: primaryFill
  }));
};

export const PersonSupport24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSupport24FilledIcon, 'PersonSupport24Filled');

const PersonSupport24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20 16.25C20 15 19 14 17.75 14H6.25C5 14 4 15 4 16.25v.57c0 .9.32 1.76.9 2.44C6.46 21.09 8.85 22 12 22c3.14 0 5.53-.9 7.1-2.74.58-.68.9-1.54.9-2.44v-.57zM6.25 15.5h11.5c.41 0 .75.33.75.75v.57c0 .54-.2 1.06-.54 1.46-1.26 1.47-3.23 2.22-5.96 2.22-2.74 0-4.7-.75-5.96-2.22-.35-.4-.54-.92-.54-1.46v-.57c0-.42.34-.75.75-.75zM17 7a5 5 0 00-9.03-2.97.75.75 0 00-.22-.03h-2.5a.75.75 0 00-.75.75v5.5A2.75 2.75 0 007.25 13h.26a1 1 0 10-.79-1.62c-.42-.2-.72-.63-.72-1.13V10h.75c.38 0 .73-.12 1.02-.33A5 5 0 0017 7zM7 6.9a5.11 5.11 0 000 .2v1.15c0 .14-.11.25-.25.25H6v-3h1v1.4zm1.5.2V6.9a3.5 3.5 0 110 .18z",
    fill: primaryFill
  }));
};

export const PersonSupport24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSupport24RegularIcon, 'PersonSupport24Regular');

const PersonSwap16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.44 12.56l1.7 1.69H8c-3.14 0-5-2.03-5-4v-.5c0-.83.67-1.5 1.5-1.5h4.17a1.5 1.5 0 00-.23.19l-2 2a1.5 1.5 0 000 2.12zM8 1.75a2.75 2.75 0 110 5.5 2.75 2.75 0 010-5.5zM8.71 12h4.58l-1.14 1.14a.5.5 0 10.7.7l2-1.99a.5.5 0 000-.7l-2-2a.5.5 0 00-.7.7L13.29 11H8.71l1.15-1.15a.5.5 0 00-.71-.7l-2 2a.5.5 0 000 .7l2 2a.5.5 0 00.7-.7L8.72 12z",
    fill: primaryFill
  }));
};

export const PersonSwap16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSwap16FilledIcon, 'PersonSwap16Filled');

const PersonSwap16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.75 4.5a2.75 2.75 0 10-5.5 0 2.75 2.75 0 005.5 0zm-4.5 0a1.75 1.75 0 113.5 0 1.75 1.75 0 01-3.5 0zm.8 8.67l1.08 1.08H8c-3.14 0-5-2.03-5-4v-.5c0-.83.67-1.5 1.5-1.5h4.18a1.5 1.5 0 00-.24.2l-.8.8H4.5a.5.5 0 00-.5.5v.5c0 1.25 1.08 2.6 3.05 2.92zm.1-1.31a.5.5 0 010-.71l2-2a.5.5 0 11.7.7L8.72 11h4.58l-1.14-1.14a.5.5 0 11.7-.7l2 1.99a.5.5 0 010 .7l-2 2a.5.5 0 11-.7-.7L13.29 12H8.71l1.15 1.15a.5.5 0 01-.71.7l-2-2z",
    fill: primaryFill
  }));
};

export const PersonSwap16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSwap16RegularIcon, 'PersonSwap16Regular');

const PersonSwap20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.29 0 .57 0 .85-.03l-1.41-1.4a1.5 1.5 0 010-2.13l2-2A1.5 1.5 0 0112.9 14h1.18a1.5 1.5 0 011.65-1.98A2 2 0 0014 11H4zm7.85 6.85a.5.5 0 01-.7 0l-2-2a.5.5 0 010-.7l2-2a.5.5 0 01.7.7L10.71 15h5.58l-1.14-1.15a.5.5 0 01.7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7-.7L16.29 16h-5.58l1.14 1.15c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const PersonSwap20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSwap20FilledIcon, 'PersonSwap20Filled');

const PersonSwap20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.29 0 .57 0 .85-.03L8.88 17a8.07 8.07 0 01-4.2-1.05A3.36 3.36 0 013 13a1 1 0 011-1h10a1 1 0 01.67.25c.32-.21.7-.3 1.07-.23A2 2 0 0014 11H4zm7.85 6.85a.5.5 0 01-.7 0l-2-2a.5.5 0 010-.7l2-2a.5.5 0 01.7.7L10.71 15h5.58l-1.14-1.15a.5.5 0 01.7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7-.7L16.29 16h-5.58l1.14 1.15c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const PersonSwap20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSwap20RegularIcon, 'PersonSwap20Regular');

const PersonSwap24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 14C17 14 18 15 18 16.25v.91c0 .29-.04.57-.13.84h-2.03A1.75 1.75 0 0013 16.02l-2.5 2.5a1.75 1.75 0 000 2.48l.94.93c-.47.05-.95.07-1.45.07-3.42 0-5.95-1.07-7.49-3.24a2.75 2.75 0 01-.51-1.6v-.91C2 15 3 14 4.25 14h11.5zM10 2a5 5 0 110 10 5 5 0 010-10zm4.78 15.78a.75.75 0 00-1.06-1.06l-2.5 2.5a.75.75 0 000 1.06l2.5 2.5a.75.75 0 001.06-1.06l-1.22-1.22h6.88l-1.22 1.22a.75.75 0 001.06 1.06l2.5-2.5a.75.75 0 000-1.06l-2.5-2.5a.75.75 0 10-1.06 1.06L20.44 19h-6.88l1.22-1.22z",
    fill: primaryFill
  }));
};

export const PersonSwap24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSwap24FilledIcon, 'PersonSwap24Filled');

const PersonSwap24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 14c.98 0 1.82.62 2.12 1.5H4.25a.75.75 0 00-.75.75v.57c0 .54.2 1.06.54 1.46C5.29 19.75 7.26 20.5 10 20.5h.16c.09.18.2.35.35.5l.94.93c-.47.05-.95.07-1.45.07-3.15 0-5.54-.9-7.1-2.74a3.75 3.75 0 01-.9-2.44v-.57C2 15 3 14 4.25 14h11.5zM10 2a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm4.78 14.28a.75.75 0 00-1.06-1.06l-2.5 2.5a.75.75 0 000 1.06l2.5 2.5a.75.75 0 001.06-1.06l-1.22-1.22h6.88l-1.22 1.22a.75.75 0 001.06 1.06l2.5-2.5a.75.75 0 000-1.06l-2.5-2.5a.75.75 0 10-1.06 1.06L20.44 19h-6.88l1.22-1.22z",
    fill: primaryFill
  }));
};

export const PersonSwap24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSwap24RegularIcon, 'PersonSwap24Regular');

const PersonSync16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.63 5.07a2.75 2.75 0 10-3.3 1.85 5.53 5.53 0 013.3-1.85zM5.6 8a5.46 5.46 0 00.42 5.69l.2.27C3.55 13.66 2 11.8 2 10v-.5C2 8.67 2.67 8 3.5 8h2.1zm.4 2.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H11a.5.5 0 010-1h.47a1.98 1.98 0 00-1.72-.1 2 2 0 00-.66.44.5.5 0 01-.71-.71A3 3 0 0112 8.15V8c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 019 12.85V13a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H10a.5.5 0 010 1h-.47a1.99 1.99 0 002.38-.34.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const PersonSync16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSync16FilledIcon, 'PersonSync16Filled');

const PersonSync16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10c0 1.8 1.55 3.65 4.22 3.96a5.5 5.5 0 01-.72-1.16C3.88 12.33 3 11.13 3 10v-.5c0-.28.22-.5.5-.5h1.7c.1-.35.24-.68.4-1H3.5C2.67 8 2 8.67 2 9.5v.5zm7.75-5.75c0 .29-.04.56-.12.82-.49.08-.95.22-1.39.41A1.74 1.74 0 007 2.5a1.75 1.75 0 10.4 3.45c-.4.28-.76.6-1.07.97a2.75 2.75 0 113.42-2.67zM6 10.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H11a.5.5 0 010-1h.47a1.98 1.98 0 00-1.72-.1 2 2 0 00-.66.44.5.5 0 01-.71-.71A3 3 0 0112 8.15V8c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 019 12.85V13a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H10a.5.5 0 010 1h-.47a1.99 1.99 0 002.38-.34.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const PersonSync16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSync16RegularIcon, 'PersonSync16Regular');

const PersonSync20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06a5.48 5.48 0 01.05-6.94H4zm6 3.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V12c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const PersonSync20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSync20FilledIcon, 'PersonSync20Filled');

const PersonSync20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2a4 4 0 100 8 4 4 0 000-8zM6 6a3 3 0 116 0 3 3 0 01-6 0zm-2 5a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 019.6 17 12 12 0 019 17a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5.6c.18-.36.4-.7.66-1H4zm6 3.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V12c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const PersonSync20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSync20RegularIcon, 'PersonSync20Regular');

const PersonSync24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 17.5c0-1.29.38-2.49 1.02-3.5H5.25C4.01 14 3 15 3 16.25v.92c0 .57.18 1.13.51 1.6C5.06 20.92 7.58 22 11 22c.6 0 1.17-.03 1.72-.1A6.48 6.48 0 0111 17.5zM11 2a5 5 0 110 10 5 5 0 010-10zm1 15.5a5.5 5.5 0 1011 0 5.5 5.5 0 00-11 0zm8.5-3.5c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h1a2.5 2.5 0 00-4.03.04.5.5 0 01-.8-.59 3.5 3.5 0 015.33-.4v-.55c0-.28.22-.5.5-.5zM15 19.95v.55a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-1a2.5 2.5 0 003.91.11.5.5 0 01.77.65 3.5 3.5 0 01-5.18.19z",
    fill: primaryFill
  }));
};

export const PersonSync24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSync24FilledIcon, 'PersonSync24Filled');

const PersonSync24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.31 15.5c.18-.53.42-1.04.71-1.5H5.25C4.01 14 3 15 3 16.25v.58c0 .89.32 1.75.9 2.43C5.47 21.1 7.85 22 11 22c.6 0 1.17-.03 1.72-.1-.4-.42-.73-.9-1-1.42l-.72.02c-2.74 0-4.7-.75-5.96-2.21-.34-.41-.54-.93-.54-1.46v-.58c0-.42.34-.75.75-.75h6.06zM11 2a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm1 14a5.5 5.5 0 1011 0 5.5 5.5 0 00-11 0zm8.5-3.5c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h1a2.5 2.5 0 00-4.03.04.5.5 0 01-.8-.59 3.5 3.5 0 015.33-.4v-.55c0-.28.22-.5.5-.5zM15 19.95v.55a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-1a2.5 2.5 0 003.91.11.5.5 0 01.77.65 3.5 3.5 0 01-5.18.19z",
    fill: primaryFill
  }));
};

export const PersonSync24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSync24RegularIcon, 'PersonSync24Regular');

const PersonSync28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 20.5c0 2.03.8 3.87 2.11 5.22-.97.18-2 .28-3.11.28-5.79 0-10-2.57-10-6.29V19a3 3 0 013-3h9.5a7.47 7.47 0 00-1.5 4.5zM12 2a6 6 0 110 12 6 6 0 010-12zm2 18.5a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0zm5.35-4.08a4 4 0 014.65 1.9v-.82a.5.5 0 011 0v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h.73a3 3 0 00-4.85-.87.5.5 0 01-.7-.7 4 4 0 011.67-1.01zm2.3 8.16a4 4 0 01-4.65-1.9v.82a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-.73a3 3 0 004.85.87.5.5 0 01.7.7 4 4 0 01-1.67 1.01z",
    fill: primaryFill
  }));
};

export const PersonSync28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSync28FilledIcon, 'PersonSync28Filled');

const PersonSync28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.07 24.37c.3.49.65.94 1.04 1.35-.97.18-2 .28-3.11.28-5.79 0-10-2.57-10-6.29V19a3 3 0 013-3h9.5c-.35.46-.64.96-.88 1.5H5c-.78 0-1.42.6-1.5 1.36v.85c0 2.68 3.39 4.79 8.5 4.79.73 0 1.42-.05 2.07-.13zM12 2a6 6 0 110 12 6 6 0 010-12zm0 1.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm2 17a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0zm5.35-4.08a4 4 0 014.65 1.9v-.82a.5.5 0 011 0v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h.73a3 3 0 00-4.85-.87.5.5 0 01-.7-.7 4 4 0 011.67-1.01zm2.3 8.16a4 4 0 01-4.65-1.9v.82a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-.73a3 3 0 004.85.87.5.5 0 01.7.7 4 4 0 01-1.67 1.01z",
    fill: primaryFill
  }));
};

export const PersonSync28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSync28RegularIcon, 'PersonSync28Regular');

const PersonSync32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 16a7 7 0 100-14 7 7 0 000 14zm-8.5 2A3.5 3.5 0 003 21.5v.5c0 2.4 1.52 4.42 3.68 5.8A15.67 15.67 0 0015 30c.74 0 1.47-.04 2.19-.13A8.98 8.98 0 0115.52 18H6.5zm24 5a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zm-2.75 0c.41 0 .75-.34.75-.75v-2.5a.75.75 0 00-1.5 0v1.19a4.5 4.5 0 00-6.8-1.47c-.43.35-.28.99.2 1.23.26.13.57.07.8-.1a2.99 2.99 0 014.4.9h-.85a.75.75 0 000 1.5h3zm-2.17 2.58c-.26-.26-.66-.25-.96-.06a2.99 2.99 0 01-4.22-1.02h.85a.75.75 0 000-1.5h-3a.75.75 0 00-.75.75v2.5a.75.75 0 001.5 0v-1.19a4.5 4.5 0 006.52 1.67c.4-.27.4-.82.06-1.15z",
    fill: primaryFill
  }));
};

export const PersonSync32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSync32FilledIcon, 'PersonSync32Filled');

const PersonSync32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 9A7 7 0 118 9a7 7 0 0114 0zm-2 0a5 5 0 10-10 0 5 5 0 0010 0zM6.5 18A3.5 3.5 0 003 21.5v.5c0 2.4 1.52 4.42 3.68 5.8A15.67 15.67 0 0015 30c.74 0 1.47-.04 2.19-.13a9.05 9.05 0 01-1.68-1.88L15 28c-2.88 0-5.43-.74-7.24-1.9C5.94 24.96 5 23.48 5 22v-.5c0-.83.67-1.5 1.5-1.5h8.01c.25-.71.6-1.38 1-2H6.5zm24 5a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zm-2.75 0c.41 0 .75-.34.75-.75v-2.5a.75.75 0 00-1.5 0v1.19a4.5 4.5 0 00-6.8-1.47c-.43.35-.28.99.2 1.23.26.13.57.07.8-.1a2.99 2.99 0 014.4.9h-.85a.75.75 0 000 1.5h3zm-2.17 2.58c-.26-.26-.66-.25-.96-.06a2.99 2.99 0 01-4.22-1.02h.85a.75.75 0 000-1.5h-3a.75.75 0 00-.75.75v2.5a.75.75 0 001.5 0v-1.19a4.5 4.5 0 006.52 1.67c.4-.27.4-.82.06-1.15z",
    fill: primaryFill
  }));
};

export const PersonSync32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSync32RegularIcon, 'PersonSync32Regular');

const PersonSync48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 4a10 10 0 100 20 10 10 0 000-20zM10.25 28A4.25 4.25 0 006 32.25V33c0 3.76 1.94 6.57 4.92 8.38C13.85 43.16 17.79 44 22 44c1.17 0 2.32-.06 3.43-.2A12.95 12.95 0 0124.04 28H10.25zM24 35a11 11 0 1022 0 11 11 0 00-22 0zm8.65-7.1A7 7 0 0140 29.6V29a1 1 0 112 0v3a1 1 0 01-1 1h-3a1 1 0 110-2h.57a5 5 0 00-7.1-.04 1 1 0 01-1.42-1.41 7 7 0 012.6-1.64zm4.7 14.2A7 7 0 0130 40.4v.6a1 1 0 11-2 0v-3a1 1 0 011-1h3a1 1 0 110 2h-.57a5 5 0 007.1.04 1 1 0 011.42 1.41 7 7 0 01-2.6 1.64z",
    fill: primaryFill
  }));
};

export const PersonSync48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSync48FilledIcon, 'PersonSync48Filled');

const PersonSync48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 4a10 10 0 100 20 10 10 0 000-20zm-7.5 10a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0zm-4.25 14A4.25 4.25 0 006 32.25V33c0 3.76 1.94 6.57 4.92 8.38C13.85 43.16 17.79 44 22 44c1.17 0 2.32-.06 3.43-.2-.65-.71-1.23-1.5-1.72-2.35-.56.03-1.13.05-1.71.05-3.93 0-7.37-.79-9.78-2.26C9.86 37.81 8.5 35.74 8.5 33v-.75c0-.97.78-1.75 1.75-1.75H22.8c.33-.88.74-1.72 1.24-2.5H10.25zM24 35a11 11 0 1022 0 11 11 0 00-22 0zm8.65-7.1A7 7 0 0140 29.6V29a1 1 0 112 0v3a1 1 0 01-1 1h-3a1 1 0 110-2h.57a5 5 0 00-7.1-.04 1 1 0 01-1.42-1.41 7 7 0 012.6-1.64zm4.7 14.2A7 7 0 0130 40.4v.6a1 1 0 11-2 0v-3a1 1 0 011-1h3a1 1 0 110 2h-.57a5 5 0 007.1.04 1 1 0 011.42 1.41 7 7 0 01-2.6 1.64z",
    fill: primaryFill
  }));
};

export const PersonSync48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonSync48RegularIcon, 'PersonSync48Regular');

const PersonTag20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 6a4 4 0 116.65 3h-.14c-.8 0-1.52.38-1.98.96A4 4 0 015 6zm4.05 5H4.01A2 2 0 002 13c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 009 18c.8 0 1.58-.07 2.31-.22l-1.6-1.63A2.52 2.52 0 019 14.4v-2.87c0-.18.02-.35.05-.52zm.95 3.4c0 .39.15.77.43 1.05l3.04 3.1c.58.59 1.52.6 2.12.03l2.95-2.84c.6-.58.62-1.55.02-2.15l-3.1-3.14a1.5 1.5 0 00-1.08-.45h-2.87c-.83 0-1.51.68-1.51 1.51v2.88zm2.75-.9a.75.75 0 110-1.5.75.75 0 010 1.5z",
    fill: primaryFill
  }));
};

export const PersonTag20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonTag20FilledIcon, 'PersonTag20Filled');

const PersonTag20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 6a4 4 0 116.65 3h-.14c-.8 0-1.52.38-1.98.96A4 4 0 015 6zm4-3a3 3 0 100 6 3 3 0 000-6zm.05 8H4.01A2 2 0 002 13c0 1.7.83 2.97 2.14 3.8A9.14 9.14 0 009 18c.8 0 1.58-.07 2.31-.22l-.85-.87c-.47.06-.95.09-1.46.09a8.16 8.16 0 01-4.33-1.05A3.36 3.36 0 013 13a1 1 0 011-1h5v-.48c0-.18.02-.35.05-.52zm.95 3.4c0 .39.15.77.43 1.05l3.04 3.1c.58.59 1.52.6 2.12.03l2.95-2.84c.6-.58.62-1.55.02-2.15l-3.1-3.14a1.5 1.5 0 00-1.08-.45h-2.87c-.83 0-1.51.68-1.51 1.51v2.88zm2.75-.9a.75.75 0 110-1.5.75.75 0 010 1.5z",
    fill: primaryFill
  }));
};

export const PersonTag20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonTag20RegularIcon, 'PersonTag20Regular');

const PersonTag24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 14v2.94a3 3 0 00.86 2.1l2.26 2.29c-1.18.45-2.56.67-4.12.67-3.42 0-5.94-1.07-7.49-3.24a2.75 2.75 0 01-.5-1.6v-.91C2 15 3 14 4.24 14H11zm4-7A5 5 0 105 7a5 5 0 0010 0zm1.57 15.4l-4-4.07a2 2 0 01-.57-1.4V14c0-1.1.9-2 2-2h2.92a2 2 0 011.4.58l4.08 4.01a2 2 0 01.02 2.83l-3 3a2 2 0 01-2.85-.02zM15 16a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const PersonTag24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonTag24FilledIcon, 'PersonTag24Filled');

const PersonTag24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 14v1.5H4.25a.75.75 0 00-.75.74v.58c0 .54.2 1.06.54 1.46C5.29 19.75 7.26 20.5 10 20.5c1.1 0 2.08-.12 2.94-.37l1.17 1.2c-1.18.44-2.55.67-4.11.67-3.15 0-5.53-.9-7.1-2.74a3.75 3.75 0 01-.9-2.44v-.58C2 15 3 14 4.25 14H11zm4-7A5 5 0 105 7a5 5 0 0010 0zM6.5 7a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zm10.07 15.4l-4-4.07a2 2 0 01-.57-1.4v-2.94c0-1.1.9-2 2-2h2.92a2 2 0 011.4.58l4.08 4.02a2 2 0 01.02 2.83l-3 3a2 2 0 01-2.85-.02zM15 16a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const PersonTag24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonTag24RegularIcon, 'PersonTag24Regular');

const PersonTag28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.22 25.14c-1.5.55-3.27.85-5.22.85-5.79 0-10-2.56-10-6.28V19a3 3 0 013-3h8v3.68a3 3 0 00.88 2.12l3.34 3.34zm-2.13-12a3 3 0 00-.83.42A5.99 5.99 0 016 8a6 6 0 119.09 5.14zM14 16v3.68a2 2 0 00.59 1.41l5.32 5.32a2 2 0 002.83 0l3.68-3.67a2 2 0 000-2.83l-5.33-5.32a2 2 0 00-1.41-.59H16a2 2 0 00-2 2zm3 2a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PersonTag28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonTag28FilledIcon, 'PersonTag28Filled');

const PersonTag28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.22 25.15c-1.5.54-3.27.85-5.22.85-5.79 0-10-2.57-10-6.29V19a3 3 0 013-3h8v1.5H5c-.78 0-1.42.6-1.5 1.36v.85c0 2.68 3.39 4.79 8.5 4.79 1.5 0 2.86-.2 4.04-.54l1.18 1.19zm-2.13-12a3 3 0 00-.83.41 6 6 0 11.83-.42zM7.5 8a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5 8v3.68a2 2 0 00.59 1.41l5.32 5.32a2 2 0 002.83 0l3.67-3.67a2 2 0 000-2.83L21.1 14.6a2 2 0 00-1.41-.59H16a2 2 0 00-2 2zm3 2a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PersonTag28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonTag28RegularIcon, 'PersonTag28Regular');

const PersonTag32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 9A7 7 0 117 9a7 7 0 0114 0zM2 21.5A3.5 3.5 0 015.5 18h9.53c-.02.16-.03.33-.03.5v4.67c0 .93.37 1.82 1.02 2.47l3.48 3.48c-1.66.56-3.53.87-5.5.87-3.2 0-6.14-.82-8.32-2.2C3.52 26.4 2 24.39 2 21.99v-.5zm28.3 4.7l-4.1 4.1a2.4 2.4 0 01-3.4 0l-5.72-5.72a2 2 0 01-.58-1.41V18.5c0-1.1.9-2 2-2h4.67a2 2 0 011.41.58l5.72 5.72a2.4 2.4 0 010 3.4zM20 21a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const PersonTag32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonTag32FilledIcon, 'PersonTag32Filled');

const PersonTag32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 16a7 7 0 100-14 7 7 0 000 14zm0-2a5 5 0 110-10 5 5 0 010 10zm-8.5 6c-.83 0-1.5.67-1.5 1.5v.5c0 1.47.94 2.94 2.76 4.1C8.56 27.25 11.12 28 14 28c1.39 0 2.7-.18 3.9-.49l1.6 1.6c-1.66.57-3.53.88-5.5.88-3.2 0-6.14-.82-8.32-2.2C3.52 26.4 2 24.39 2 21.99v-.5A3.5 3.5 0 015.5 18h9.53l-.03.5V20H5.5zm24.8 6.2a2.4 2.4 0 000-3.4l-5.72-5.72a2 2 0 00-1.41-.58H18.5a2 2 0 00-2 2v4.67a2 2 0 00.58 1.41l5.72 5.72a2.4 2.4 0 003.4 0l4.1-4.1zM20 21a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PersonTag32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonTag32RegularIcon, 'PersonTag32Regular');

const PersonTag48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 14a10 10 0 1120 0 10 10 0 01-20 0zM3 32.25C3 29.9 4.9 28 7.25 28H21v6.67a6 6 0 001.76 4.25l3.97 3.97A25.32 25.32 0 0119 44c-4.21 0-8.15-.84-11.08-2.62C4.94 39.57 3 36.76 3 33v-.75zM23 28v6.66a4 4 0 001.17 2.84l7.32 7.32a4 4 0 005.67 0l6.67-6.67a4 4 0 000-5.67l-7.32-7.32A4 4 0 0033.67 24h-6.66A4 4 0 0023 28zM28.5 31a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
    fill: primaryFill
  }));
};

export const PersonTag48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonTag48FilledIcon, 'PersonTag48Filled');

const PersonTag48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 14a10 10 0 1120 0 10 10 0 01-20 0zm10-7.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15zM3 32.25C3 29.9 4.9 28 7.25 28H22v2.5H7.25c-.97 0-1.75.78-1.75 1.75V33c0 2.74 1.36 4.8 3.72 6.24 2.41 1.47 5.85 2.26 9.78 2.26 2.39 0 4.59-.29 6.5-.85l1.97 1.98c-2.5.93-5.4 1.37-8.47 1.37-4.21 0-8.15-.84-11.08-2.62C4.94 39.57 3 36.76 3 33v-.75zM24 28v6.66a4 4 0 001.17 2.84l7.32 7.32a4 4 0 005.67 0l6.67-6.67a4 4 0 000-5.67l-7.32-7.32A4 4 0 0034.67 24h-6.66A4 4 0 0024 28zM29.5 31a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
    fill: primaryFill
  }));
};

export const PersonTag48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonTag48RegularIcon, 'PersonTag48Regular');

const PersonVoice20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.85 1.15a.5.5 0 00-.7.7 6.6 6.6 0 011.72 4.65 6.6 6.6 0 01-1.72 4.65.5.5 0 00.7.7 7.6 7.6 0 002.03-5.35 7.6 7.6 0 00-2.03-5.35zm-2 2a.5.5 0 00-.7.7c.63.64.97 1.62.97 2.65 0 1.03-.34 2.01-.97 2.65a.5.5 0 00.7.7 4.76 4.76 0 001.28-3.35c0-1.22-.41-2.49-1.28-3.35zM4 7a4 4 0 118 0 4 4 0 01-8 0zm-3 7a2 2 0 012-2h10a2 2 0 012 2c0 1.7-.83 2.97-2.13 3.8A9.14 9.14 0 018 19a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 011 14z",
    fill: primaryFill
  }));
};

export const PersonVoice20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonVoice20FilledIcon, 'PersonVoice20Filled');

const PersonVoice20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.85 1.15a.5.5 0 00-.7.7 6.6 6.6 0 011.72 4.65 6.6 6.6 0 01-1.72 4.65.5.5 0 00.7.7 7.6 7.6 0 002.03-5.35 7.6 7.6 0 00-2.03-5.35zm-2 2a.5.5 0 00-.7.7c.63.64.97 1.62.97 2.65 0 1.03-.34 2.01-.97 2.65a.5.5 0 00.7.7 4.76 4.76 0 001.28-3.35c0-1.22-.41-2.49-1.28-3.35zM4 7a4 4 0 118 0 4 4 0 01-8 0zm4-3a3 3 0 100 6 3 3 0 000-6zM1 14a2 2 0 012-2h10a2 2 0 012 2c0 1.7-.83 2.97-2.13 3.8A9.14 9.14 0 018 19a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 011 14zm2-1a1 1 0 00-1 1c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 008 18c1.74 0 3.26-.36 4.33-1.05A3.36 3.36 0 0014 14a1 1 0 00-1-1H3z",
    fill: primaryFill
  }));
};

export const PersonVoice20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonVoice20RegularIcon, 'PersonVoice20Regular');

const PersonVoice24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.75 15C16 15 17 16 17 17.25v.92c0 .57-.18 1.13-.5 1.6C14.93 21.93 12.41 23 9 23s-5.94-1.07-7.49-3.24a2.75 2.75 0 01-.5-1.6v-.91C1 16 2 15 3.24 15h11.5zm4.3-13.6a.75.75 0 011.03.28 12.7 12.7 0 01-.01 12.66.75.75 0 11-1.3-.75 11.2 11.2 0 000-11.16.75.75 0 01.28-1.03zM9 3a5 5 0 110 10A5 5 0 019 3zm6.59.4a.75.75 0 011.02.28 8.71 8.71 0 010 8.65.75.75 0 11-1.3-.74 7.21 7.21 0 000-7.17.75.75 0 01.28-1.02z",
    fill: primaryFill
  }));
};

export const PersonVoice24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonVoice24FilledIcon, 'PersonVoice24Filled');

const PersonVoice24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.75 15C16 15 17 16 17 17.25v.57c0 .9-.32 1.76-.9 2.44C14.53 22.1 12.15 23 9 23c-3.15 0-5.53-.9-7.1-2.74a3.75 3.75 0 01-.9-2.43v-.58C1 16 2.01 15 3.25 15h11.5zm0 1.5H3.25a.75.75 0 00-.75.75v.58c0 .53.2 1.05.54 1.46C4.3 20.76 6.26 21.5 9 21.5c2.74 0 4.7-.74 5.96-2.21.35-.41.54-.93.54-1.47v-.57a.75.75 0 00-.75-.75zm4.3-15.1a.75.75 0 011.03.28 12.7 12.7 0 01-.01 12.66.75.75 0 11-1.3-.75 11.2 11.2 0 000-11.16.75.75 0 01.28-1.03zM9 3a5 5 0 110 10A5 5 0 019 3zm6.59.4a.75.75 0 011.02.28 8.71 8.71 0 010 8.65.75.75 0 11-1.3-.74 7.21 7.21 0 000-7.17.75.75 0 01.28-1.02zM9 4.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7z",
    fill: primaryFill
  }));
};

export const PersonVoice24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PersonVoice24RegularIcon, 'PersonVoice24Regular');

const Phone12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 2.5C3 1.67 3.67 1 4.5 1h3C8.33 1 9 1.67 9 2.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 013 9.5v-7zM5.5 8a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: primaryFill
  }));
};

export const Phone12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Phone12FilledIcon, 'Phone12Filled');

const Phone12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 8a.5.5 0 000 1h1a.5.5 0 000-1h-1zm-1-7C3.67 1 3 1.67 3 2.5v7c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-7C9 1.67 8.33 1 7.5 1h-3zM4 2.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v7a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-7z",
    fill: primaryFill
  }));
};

export const Phone12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Phone12RegularIcon, 'Phone12Regular');

const Phone16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 2.75C4 1.78 4.78 1 5.75 1h4.5c.97 0 1.75.78 1.75 1.75v10.5c0 .97-.78 1.75-1.75 1.75h-4.5C4.78 15 4 14.22 4 13.25V2.75zM7 12a.5.5 0 000 1h2a.5.5 0 000-1H7z",
    fill: primaryFill
  }));
};

export const Phone16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Phone16FilledIcon, 'Phone16Filled');

const Phone16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 12a.5.5 0 000 1h2a.5.5 0 000-1H7zM5.75 1C4.78 1 4 1.78 4 2.75v10.5c0 .97.78 1.75 1.75 1.75h4.5c.97 0 1.75-.78 1.75-1.75V2.75C12 1.78 11.22 1 10.25 1h-4.5zM5 2.75c0-.41.34-.75.75-.75h4.5c.41 0 .75.34.75.75v10.5c0 .41-.34.75-.75.75h-4.5a.75.75 0 01-.75-.75V2.75z",
    fill: primaryFill
  }));
};

export const Phone16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Phone16RegularIcon, 'Phone16Regular');

const Phone20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-13c0-.83-.67-1.5-1.5-1.5h-7zM9 14h2a.5.5 0 010 1H9a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const Phone20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Phone20FilledIcon, 'Phone20Filled');

const Phone20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 14a.5.5 0 000 1h2a.5.5 0 000-1H9zM7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zM6 4a1 1 0 011-1h6a1 1 0 011 1v12a1 1 0 01-1 1H7a1 1 0 01-1-1V4z",
    fill: primaryFill
  }));
};

export const Phone20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Phone20RegularIcon, 'Phone20Regular');

const Phone24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zm-2.5 16h-2.5a.75.75 0 000 1.5h2.5a.75.75 0 000-1.5z",
    fill: primaryFill
  }));
};

export const Phone24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Phone24FilledIcon, 'Phone24Filled');

const Phone24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zm0 1.5h-7.5a.75.75 0 00-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 00-.75-.75zm-2.5 14a.75.75 0 010 1.5h-2.5a.75.75 0 010-1.5h2.5z",
    fill: primaryFill
  }));
};

export const Phone24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Phone24RegularIcon, 'Phone24Regular');

const Phone28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 4.75A2.75 2.75 0 019.75 2h8.5A2.75 2.75 0 0121 4.75v18.5A2.75 2.75 0 0118.25 26h-8.5A2.75 2.75 0 017 23.25V4.75zM12.25 21a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z",
    fill: primaryFill
  }));
};

export const Phone28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Phone28FilledIcon, 'Phone28Filled');

const Phone28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.75 2A2.75 2.75 0 007 4.75v18.5A2.75 2.75 0 009.75 26h8.5A2.75 2.75 0 0021 23.25V4.75A2.75 2.75 0 0018.25 2h-8.5zM8.5 4.75c0-.69.56-1.25 1.25-1.25h8.5c.69 0 1.25.56 1.25 1.25v18.5c0 .69-.56 1.25-1.25 1.25h-8.5c-.69 0-1.25-.56-1.25-1.25V4.75zM12.25 21a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z",
    fill: primaryFill
  }));
};

export const Phone28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Phone28RegularIcon, 'Phone28Regular');

const Phone32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.25 2A3.25 3.25 0 007 5.25v21.5C7 28.55 8.46 30 10.25 30h11.5c1.8 0 3.25-1.46 3.25-3.25V5.25C25 3.45 23.54 2 21.75 2h-11.5zM14 24h4a1 1 0 110 2h-4a1 1 0 110-2z",
    fill: primaryFill
  }));
};

export const Phone32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Phone32FilledIcon, 'Phone32Filled');

const Phone32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.25 2A3.25 3.25 0 007 5.25v21.5C7 28.55 8.46 30 10.25 30h11.5c1.8 0 3.25-1.46 3.25-3.25V5.25C25 3.45 23.54 2 21.75 2h-11.5zM9 5.25C9 4.56 9.56 4 10.25 4h11.5c.69 0 1.25.56 1.25 1.25v21.5c0 .69-.56 1.25-1.25 1.25h-11.5C9.56 28 9 27.44 9 26.75V5.25zM14 24a1 1 0 100 2h4a1 1 0 100-2h-4z",
    fill: primaryFill
  }));
};

export const Phone32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Phone32RegularIcon, 'Phone32Regular');

const Phone48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.25 4A4.25 4.25 0 0012 8.25v31.5C12 42.1 13.9 44 16.25 44h15.5C34.1 44 36 42.1 36 39.75V8.25C36 5.9 34.1 4 31.75 4h-15.5zm5 31.5h5.5a1.25 1.25 0 110 2.5h-5.5a1.25 1.25 0 110-2.5z",
    fill: primaryFill
  }));
};

export const Phone48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Phone48FilledIcon, 'Phone48Filled');

const Phone48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.25 4A4.25 4.25 0 0012 8.25v31.5C12 42.1 13.9 44 16.25 44h15.5C34.1 44 36 42.1 36 39.75V8.25C36 5.9 34.1 4 31.75 4h-15.5zM14.5 8.25c0-.97.78-1.75 1.75-1.75h15.5c.97 0 1.75.78 1.75 1.75v31.5c0 .97-.78 1.75-1.75 1.75h-15.5c-.97 0-1.75-.78-1.75-1.75V8.25zm6.75 27.25a1.25 1.25 0 100 2.5h5.5a1.25 1.25 0 100-2.5h-5.5z",
    fill: primaryFill
  }));
};

export const Phone48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Phone48RegularIcon, 'Phone48Regular');

const PhoneAdd20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.47 5.47 0 01-1.24-3H7.5a.5.5 0 010-1h1.52A5.5 5.5 0 0114 9.02V3.5c0-.83-.67-1.5-1.5-1.5h-7zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const PhoneAdd20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneAdd20FilledIcon, 'PhoneAdd20Filled');

const PhoneAdd20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3.5C4 2.67 4.67 2 5.5 2h7c.83 0 1.5.67 1.5 1.5v5.52c-.34.03-.68.1-1 .19V3.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h4.1c.18.36.4.7.66 1H5.5A1.5 1.5 0 014 16.5v-13zM9.02 14a5.57 5.57 0 000 1H7.5a.5.5 0 010-1h1.52zm9.98.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const PhoneAdd20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneAdd20RegularIcon, 'PhoneAdd20Regular');

const PhoneAdd24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM13.75 2C14.99 2 16 3 16 4.25v6.92a6.5 6.5 0 00-5 6.33H8.75a.75.75 0 000 1.5h2.42a6.49 6.49 0 001.64 3H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h7.5zm3.75 12h-.09a.5.5 0 00-.4.4l-.01.1V17h-2.6a.5.5 0 00-.4.41v.18c.04.2.2.36.4.4l.1.01H17v2.6c.05.2.2.36.41.4h.18a.5.5 0 00.4-.4l.01-.1V18h2.6a.5.5 0 00.4-.41v-.18a.5.5 0 00-.4-.4l-.1-.01H18v-2.6a.5.5 0 00-.41-.4h-.09z",
    fill: primaryFill
  }));
};

export const PhoneAdd24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneAdd24FilledIcon, 'PhoneAdd24Filled');

const PhoneAdd24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM13.75 2C14.99 2 16 3 16 4.25v6.92c-.53.13-1.03.32-1.5.56V4.25a.75.75 0 00-.75-.75h-7.5a.75.75 0 00-.75.75v15.5c0 .41.34.75.75.75h5.48c.29.55.65 1.06 1.08 1.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h7.5zm3.75 12h-.09a.5.5 0 00-.4.4l-.01.1V17h-2.6a.5.5 0 00-.4.41v.18c.04.2.2.36.4.4l.1.01H17v2.6c.05.2.2.36.41.4h.18a.5.5 0 00.4-.4l.01-.1V18h2.6a.5.5 0 00.4-.41v-.18a.5.5 0 00-.4-.4l-.1-.01H18v-2.6a.5.5 0 00-.41-.4h-.09zm-8.75 3.5H11c0 .52.06 1.02.17 1.5H8.75a.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const PhoneAdd24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneAdd24RegularIcon, 'PhoneAdd24Regular');

const PhoneArrowRight20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3.5C4 2.67 4.67 2 5.5 2h7c.83 0 1.5.67 1.5 1.5v5.52A5.5 5.5 0 009.02 14H7.5a.5.5 0 000 1h1.52c.1 1.13.55 2.17 1.24 3H5.5A1.5 1.5 0 014 16.5v-13zM14.5 10a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const PhoneArrowRight20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneArrowRight20FilledIcon, 'PhoneArrowRight20Filled');

const PhoneArrowRight20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 01-.66-1H5.5a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5.7c.32-.08.66-.15 1-.18V3.5c0-.83-.67-1.5-1.5-1.5h-7zM9 14.5c0-.17 0-.34.02-.5H7.5a.5.5 0 000 1h1.52a5.57 5.57 0 01-.02-.5zm5.5-4.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const PhoneArrowRight20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneArrowRight20RegularIcon, 'PhoneArrowRight20Regular');

const PhoneArrowRight24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.75 2C14.99 2 16 3 16 4.25v5.77A6.5 6.5 0 0010.17 18H8.75a.75.75 0 00-.1 1.5h2.08a6.53 6.53 0 002.3 2.5H6.26C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h7.5zm2.75 9a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm.22 2.59l-.07.06-.06.07a.5.5 0 000 .56l.06.07L18.29 16H13.4a.5.5 0 00-.4.41v.18c.04.2.2.36.4.4l.1.01h4.8l-1.65 1.65-.06.07a.5.5 0 00.7.7l.06-.07 2.53-2.53.04-.05.04-.08.03-.08V16.39l-.03-.08-.04-.08-.04-.05-2.53-2.53-.07-.06a.5.5 0 00-.49-.04l-.07.04z",
    fill: primaryFill
  }));
};

export const PhoneArrowRight24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneArrowRight24FilledIcon, 'PhoneArrowRight24Filled');

const PhoneArrowRight24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.75 2C14.99 2 16 3 16 4.25v5.77c-.52.04-1.02.14-1.5.3V4.24a.75.75 0 00-.75-.75h-7.5a.75.75 0 00-.75.75v15.5c0 .41.34.75.75.75h5.13c.46.6 1.02 1.1 1.66 1.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h7.5zm2.75 9a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm.22 2.59l-.07.06-.06.07a.5.5 0 000 .56l.06.07L18.29 16H13.4a.5.5 0 00-.4.41v.18c.04.2.2.36.4.4l.1.01h4.8l-1.65 1.65-.06.07a.5.5 0 00.7.7l.06-.07 2.53-2.53.04-.05.04-.08.03-.08V16.39l-.03-.08-.04-.08-.04-.05-2.53-2.53-.07-.06a.5.5 0 00-.49-.04l-.07.04zm-6.64 3.91c.08.52.22 1.03.42 1.5H8.75a.75.75 0 010-1.5h1.33z",
    fill: primaryFill
  }));
};

export const PhoneArrowRight24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneArrowRight24RegularIcon, 'PhoneArrowRight24Regular');

const PhoneChat16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 2.75C4 1.78 4.78 1 5.75 1h4.5c.97 0 1.75.78 1.75 1.75v3.27a5.5 5.5 0 00-5.51 7.75L6.12 15h-.37C4.78 15 4 14.22 4 13.25V2.75zM11.5 16a4.5 4.5 0 10-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54c.64.36 1.39.56 2.18.56zM9 10.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 010-1h2a.5.5 0 010 1h-2z",
    fill: primaryFill
  }));
};

export const PhoneChat16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneChat16FilledIcon, 'PhoneChat16Filled');

const PhoneChat16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.75 1C4.78 1 4 1.78 4 2.75v10.5c0 .97.78 1.75 1.75 1.75h.37l.3-1h-.67a.75.75 0 01-.75-.75V2.75c0-.41.34-.75.75-.75h4.5c.41 0 .75.34.75.75v3.27a5.57 5.57 0 011 0V2.75C12 1.78 11.22 1 10.25 1h-4.5zm5.75 15a4.5 4.5 0 10-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54c.64.36 1.39.56 2.18.56zM9 10.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 010-1h2a.5.5 0 010 1h-2z",
    fill: primaryFill
  }));
};

export const PhoneChat16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneChat16RegularIcon, 'PhoneChat16Regular');

const PhoneChat20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h2.62l.37-1.23A5.48 5.48 0 0115 9.02V3.5c0-.83-.67-1.5-1.5-1.5h-7zm8 17a4.5 4.5 0 10-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54c.64.36 1.39.56 2.18.56zM12 13.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 010-1h2a.5.5 0 010 1h-2z",
    fill: primaryFill
  }));
};

export const PhoneChat20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneChat20FilledIcon, 'PhoneChat20Filled');

const PhoneChat20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.42 17H7a1 1 0 01-1-1V4a1 1 0 011-1h6a1 1 0 011 1v5.02a5.57 5.57 0 011 0V4a2 2 0 00-2-2H7a2 2 0 00-2 2v12c0 1.1.9 2 2 2h2.12l.3-1zm5.08 2a4.5 4.5 0 10-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54c.64.36 1.39.56 2.18.56zM12 13.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 010-1h2a.5.5 0 010 1h-2z",
    fill: primaryFill
  }));
};

export const PhoneChat20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneChat20RegularIcon, 'PhoneChat20Regular');

const PhoneChat24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v6.77a6.5 6.5 0 00-6.38 9.24L11.09 22H8.25C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zM21 13.26A5.48 5.48 0 0017.5 12a5.5 5.5 0 00-4.81 8.17l-.67 2.19a.5.5 0 00.63.62l2.18-.67A5.5 5.5 0 0021 13.25zM15.5 17a.5.5 0 110-1h4a.5.5 0 110 1h-4zm2 2h-2a.5.5 0 110-1h2a.5.5 0 110 1z",
    fill: primaryFill
  }));
};

export const PhoneChat24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneChat24FilledIcon, 'PhoneChat24Filled');

const PhoneChat24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 4.25C18 3.01 17 2 15.75 2h-7.5C7.01 2 6 3 6 4.25v15.5C6 20.99 7 22 8.25 22h2.84l.45-1.5H8.25a.75.75 0 01-.75-.75V4.25c0-.41.34-.75.75-.75h7.5c.41 0 .75.34.75.75v6.83a6.55 6.55 0 011.5-.06V4.25zm3 9A5.48 5.48 0 0017.5 12a5.5 5.5 0 00-4.81 8.17l-.67 2.19a.5.5 0 00.63.62l2.18-.67A5.5 5.5 0 0021 13.25zM15.5 17a.5.5 0 110-1h4a.5.5 0 110 1h-4zm2 2h-2a.5.5 0 110-1h2a.5.5 0 110 1z",
    fill: primaryFill
  }));
};

export const PhoneChat24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneChat24RegularIcon, 'PhoneChat24Regular');

const PhoneChat28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.75 2A2.75 2.75 0 007 4.75v18.5A2.75 2.75 0 009.75 26h3.33l.66-2.25A7.5 7.5 0 0121 13.02V4.75A2.75 2.75 0 0018.25 2h-8.5zM27 20.5a6.5 6.5 0 01-9.64 5.69l-2.72.79a.5.5 0 01-.62-.62l.8-2.71A6.5 6.5 0 1127 20.5zM18 19a.5.5 0 100 1h5a.5.5 0 000-1h-5zm-.5 2.5c0 .28.23.5.5.5h2.5a.5.5 0 000-1H18a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PhoneChat28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneChat28FilledIcon, 'PhoneChat28Filled');

const PhoneChat28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 4.75A2.75 2.75 0 019.75 2h8.5A2.75 2.75 0 0121 4.75v8.27a7.63 7.63 0 00-1.5.05V4.75c0-.69-.56-1.25-1.25-1.25h-8.5c-.69 0-1.25.56-1.25 1.25v18.5c0 .69.56 1.25 1.25 1.25h3.77l-.44 1.5H9.75A2.75 2.75 0 017 23.25V4.75zM27 20.5a6.5 6.5 0 01-9.65 5.69l-2.71.79a.5.5 0 01-.62-.62l.8-2.71A6.5 6.5 0 1127 20.5zM18 19a.5.5 0 000 1h5a.5.5 0 100-1h-5zm-.5 2.5c0 .28.22.5.5.5h2.5a.5.5 0 100-1H18a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PhoneChat28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneChat28RegularIcon, 'PhoneChat28Regular');

const PhoneCheckmark16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 11a5.5 5.5 0 001.5-.2v2.45c0 .97-.78 1.75-1.75 1.75h-4.5C4.78 15 4 14.22 4 13.25V2.75C4 1.78 4.78 1 5.75 1h1.59a5.5 5.5 0 003.16 10zM7 12a.5.5 0 000 1h2a.5.5 0 000-1H7zm8-6.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L9.5 6.29l-.65-.64a.5.5 0 10-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const PhoneCheckmark16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneCheckmark16FilledIcon, 'PhoneCheckmark16Filled');

const PhoneCheckmark16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 10.98v2.27c0 .41-.34.75-.75.75h-4.5a.75.75 0 01-.75-.75V2.75c0-.41.34-.75.75-.75h.5c.32-.38.68-.72 1.09-1H5.75C4.78 1 4 1.78 4 2.75v10.5c0 .97.78 1.75 1.75 1.75h4.5c.97 0 1.75-.78 1.75-1.75v-2.46c-.32.1-.66.16-1 .19zM6.5 12.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1H7a.5.5 0 01-.5-.5zm4-2.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm2.35-5.65l-3 3a.5.5 0 01-.7 0l-1-1a.5.5 0 11.7-.7l.65.64 2.65-2.64a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const PhoneCheckmark16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneCheckmark16RegularIcon, 'PhoneCheckmark16Regular');

const PhoneCheckmark20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L12.5 6.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7zM6.5 2h2.76A5.5 5.5 0 0015 10.8v5.7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 16.5v-13C5 2.67 5.67 2 6.5 2zM8 14.5c0 .28.22.5.5.5h3a.5.5 0 000-1h-3a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PhoneCheckmark20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneCheckmark20FilledIcon, 'PhoneCheckmark20Filled');

const PhoneCheckmark20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L12.5 6.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7zM9.25 2H6.5C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-5.7c-.32.08-.66.15-1 .18v5.52a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5h2.1c.18-.36.4-.7.66-1zM8 14.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneCheckmark20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneCheckmark20RegularIcon, 'PhoneCheckmark20Regular');

const PhoneDesktop16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 1a2 2 0 00-2 2v2h1.5A2.5 2.5 0 018 7.5V11h2v1H8v1h3.5a.5.5 0 000-1H11v-1h2a2 2 0 002-2V3a2 2 0 00-2-2H6zM2.5 6C1.67 6 1 6.67 1 7.5v6c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-6C7 6.67 6.33 6 5.5 6h-3zm.5 6.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneDesktop16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktop16FilledIcon, 'PhoneDesktop16Filled');

const PhoneDesktop16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2h7a1 1 0 011 1v6a1 1 0 01-1 1H8v1h2v1H8v1h3.5a.5.5 0 000-1H11v-1h2a2 2 0 002-2V3a2 2 0 00-2-2H6a2 2 0 00-2 2v2h1V3a1 1 0 011-1zM3.5 12a.5.5 0 000 1h1a.5.5 0 000-1h-1zm-1-6C1.67 6 1 6.67 1 7.5v6c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-6C7 6.67 6.33 6 5.5 6h-3zm0 1h3c.28 0 .5.22.5.5v6a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-6c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneDesktop16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktop16RegularIcon, 'PhoneDesktop16Regular');

const PhoneDesktop20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v3h2.5A2.5 2.5 0 019 9.5V13h3v2H9v1h5.5a.5.5 0 000-1H13v-2h3a2 2 0 002-2V4a2 2 0 00-2-2H6zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-7C8 8.67 7.33 8 6.5 8h-3zm.5 7.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneDesktop20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktop20FilledIcon, 'PhoneDesktop20Filled');

const PhoneDesktop20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3h10a1 1 0 011 1v7a1 1 0 01-1 1H9v1h3v2H9v1h5.5a.5.5 0 000-1H13v-2h3a2 2 0 002-2V4a2 2 0 00-2-2H6a2 2 0 00-2 2v3h1V4a1 1 0 011-1zM4.5 15a.5.5 0 000 1h1a.5.5 0 000-1h-1zM2 9.5C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 012 16.5v-7zM3.5 9a.5.5 0 00-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-3z",
    fill: primaryFill
  }));
};

export const PhoneDesktop20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktop20RegularIcon, 'PhoneDesktop20Regular');

const PhoneDesktop24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.26 9c.96 0 1.75.78 1.75 1.75v9.5c0 .97-.79 1.75-1.75 1.75h-4.5C2.77 22 2 21.22 2 20.25v-9.5C2 9.78 2.78 9 3.75 9h4.5zm-2 9.5h-.6a.75.75 0 000 1.49h.7a.75.75 0 000-1.49h-.1zM19.74 2c1.2 0 2.17.93 2.25 2.1v9.15c0 1.2-.92 2.17-2.1 2.24l-.15.01H16v2h1.25a.75.75 0 01.1 1.5H11v-1.5h3.5v-2H11v-5A2.5 2.5 0 008.66 8H4V4.25c0-1.2.93-2.17 2.1-2.24L6.25 2h13.5z",
    fill: primaryFill
  }));
};

export const PhoneDesktop24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktop24FilledIcon, 'PhoneDesktop24Filled');

const PhoneDesktop24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.26 9c.96 0 1.75.78 1.75 1.75v9.5c0 .97-.79 1.75-1.75 1.75h-4.5C2.77 22 2 21.22 2 20.25v-9.5C2 9.78 2.78 9 3.75 9h4.5zm0 1.5h-4.5a.25.25 0 00-.26.25v9.5c0 .14.11.25.25.25h4.5c.14 0 .26-.11.26-.25v-9.5a.25.25 0 00-.25-.25zM6.25 18a.75.75 0 01.1 1.5h-.6a.75.75 0 01-.1-1.5h.6zm13.5-16c1.2 0 2.17.93 2.25 2.1v9.15c0 1.2-.92 2.17-2.1 2.24l-.15.01H16v2h1.25a.75.75 0 01.1 1.5H11v-1.5h3.5v-2H11V14h8.75c.38 0 .7-.28.74-.65l.01-.1v-9a.75.75 0 00-.75-.75H6.25c-.38 0-.7.28-.74.65l-.01.1V8H4V4.25c0-1.2.93-2.17 2.1-2.24L6.25 2h13.5z",
    fill: primaryFill
  }));
};

export const PhoneDesktop24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktop24RegularIcon, 'PhoneDesktop24Regular');

const PhoneDesktop28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.75 10c1.19 0 2.16.93 2.24 2.1v11.65c0 1.2-.92 2.17-2.09 2.24l-.15.01h-5.5c-1.2 0-2.17-.93-2.24-2.1L2 23.75v-11.5c0-1.2.93-2.17 2.1-2.24l.15-.01h5.5zm-2 11.5h-1.6a.75.75 0 000 1.5H7.85a.75.75 0 000-1.5h-.1zm16-19.5c1.2 0 2.17.93 2.25 2.1v11.4c0 1.2-.92 2.17-2.1 2.24l-.15.01H19v2.75h1.25a.75.75 0 01.1 1.5H13v-1.5h4.5v-2.75H13V11.5A2.5 2.5 0 0010.66 9H5V4.25c0-1.2.93-2.17 2.1-2.24L7.25 2h16.5z",
    fill: primaryFill
  }));
};

export const PhoneDesktop28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktop28FilledIcon, 'PhoneDesktop28Filled');

const PhoneDesktop28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.75 10c1.19 0 2.16.93 2.24 2.1v11.65c0 1.2-.92 2.17-2.09 2.24l-.15.01h-5.5c-1.2 0-2.17-.93-2.24-2.1L2 23.75v-11.5c0-1.2.93-2.17 2.1-2.24l.15-.01h5.5zm0 1.5h-5.5c-.38 0-.7.28-.74.65l-.01.1v11.5c0 .38.28.7.65.74l.1.01h5.5c.38 0 .69-.28.74-.65v-11.6c0-.38-.28-.7-.64-.74l-.1-.01zm-2 10a.75.75 0 01.1 1.5h-1.6a.75.75 0 01-.1-1.5h1.6zm16-19.5c1.2 0 2.17.93 2.25 2.1v11.4c0 1.2-.92 2.17-2.1 2.24l-.15.01H19v2.75h1.25a.75.75 0 01.1 1.5H13v-1.5h4.5v-2.75H13v-1.5h10.75c.38 0 .7-.28.75-.65V4.25c0-.38-.28-.7-.65-.74l-.1-.01H7.25c-.38 0-.7.28-.74.65l-.01.1V9H5V4.25c0-1.2.93-2.17 2.1-2.24L7.25 2h16.5z",
    fill: primaryFill
  }));
};

export const PhoneDesktop28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktop28RegularIcon, 'PhoneDesktop28Regular');

const PhoneDesktopAdd20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm-.5 7.5c1.33 0 2.55-.47 3.5-1.26V11a2 2 0 01-2 2h-3v2h1.5a.5.5 0 010 1H9v-1h3v-2H9V9.5A2.5 2.5 0 006.5 7H4V4c0-1.1.9-2 2-2h4.26a5.5 5.5 0 004.24 9zm-11-3C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-7C8 8.67 7.33 8 6.5 8h-3zm.5 7.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneDesktopAdd20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktopAdd20FilledIcon, 'PhoneDesktopAdd20Filled');

const PhoneDesktopAdd20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm2 7.5v-.6c.36-.18.7-.4 1-.66V11a2 2 0 01-2 2h-3v2h1.5a.5.5 0 010 1H9v-1h3v-2H9v-1h7a1 1 0 001-1zm-6.74-9c-.26.3-.48.64-.66 1H6a1 1 0 00-1 1v3H4V4c0-1.1.9-2 2-2h4.26zM4 15.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm-2-6C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 012 16.5v-7zM3.5 9a.5.5 0 00-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-3z",
    fill: primaryFill
  }));
};

export const PhoneDesktopAdd20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDesktopAdd20RegularIcon, 'PhoneDesktopAdd20Regular');

const PhoneDismiss20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.47 5.47 0 01-1.24-3H7.5a.5.5 0 010-1h1.52A5.5 5.5 0 0114 9.02V3.5c0-.83-.67-1.5-1.5-1.5h-7zm9 17a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 01-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 01-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 01.7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const PhoneDismiss20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDismiss20FilledIcon, 'PhoneDismiss20Filled');

const PhoneDismiss20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 01-.66-1H5.5a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5.7c.32-.08.66-.15 1-.18V3.5c0-.83-.67-1.5-1.5-1.5h-7zM9 14.5c0-.17 0-.34.02-.5H7.5a.5.5 0 000 1h1.52a5.57 5.57 0 01-.02-.5zm10 0a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const PhoneDismiss20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDismiss20RegularIcon, 'PhoneDismiss20Regular');

const PhoneDismiss24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM13.75 2C14.99 2 16 3 16 4.25v6.92A6.5 6.5 0 0011.02 18H8.75a.75.75 0 00-.1 1.5h2.66c.3.95.83 1.8 1.5 2.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h7.5zm1.34 12.97l-.07.05-.05.07a.5.5 0 000 .57l.05.07 1.77 1.77-1.76 1.77-.06.07a.5.5 0 000 .57l.06.06.07.06c.17.12.4.12.56 0l.07-.06 1.77-1.76 1.77 1.77.07.05c.17.12.4.12.57 0l.07-.05.05-.07a.5.5 0 000-.57l-.05-.07-1.77-1.77 1.77-1.77.06-.07a.5.5 0 000-.57l-.06-.07-.07-.05a.5.5 0 00-.57 0l-.07.05-1.77 1.77-1.77-1.77-.07-.05a.5.5 0 00-.5-.05l-.07.05z",
    fill: primaryFill
  }));
};

export const PhoneDismiss24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDismiss24FilledIcon, 'PhoneDismiss24Filled');

const PhoneDismiss24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM13.75 2C14.99 2 16 3 16 4.25v6.92c-.53.13-1.03.32-1.5.56V4.25a.75.75 0 00-.75-.75h-7.5a.75.75 0 00-.75.75v15.5c0 .41.34.75.75.75h5.48c.29.55.65 1.06 1.08 1.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h7.5zm1.34 12.97l-.07.05-.05.07a.5.5 0 000 .57l.05.07 1.77 1.77-1.76 1.77-.06.07a.5.5 0 000 .57l.06.06.07.06c.17.12.4.12.56 0l.07-.06 1.77-1.76 1.77 1.77.07.05c.17.12.4.12.57 0l.07-.05.05-.07a.5.5 0 000-.57l-.05-.07-1.77-1.77 1.77-1.77.06-.07a.5.5 0 000-.57l-.06-.07-.07-.05a.5.5 0 00-.57 0l-.07.05-1.77 1.77-1.77-1.77-.07-.05a.5.5 0 00-.5-.05l-.07.05zM8.75 17.5H11c0 .52.06 1.02.17 1.5H8.75a.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const PhoneDismiss24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneDismiss24RegularIcon, 'PhoneDismiss24Regular');

const PhoneEraser16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.94 1.35a1.5 1.5 0 012.12 0l1.59 1.59a1.5 1.5 0 010 2.12l-4.59 4.59a1.5 1.5 0 01-2.12 0L6.35 8.06a1.5 1.5 0 010-2.12l4.59-4.59zM10.29 8L8 5.7l-.94.95a.5.5 0 000 .7l1.59 1.59c.2.2.5.2.7 0L10.3 8zm-4.56.77a2.5 2.5 0 010-3.54l4.13-4.12c-.2-.07-.4-.11-.61-.11h-4.5C3.78 1 3 1.78 3 2.75v10.5c0 .97.78 1.75 1.75 1.75h4.5c.97 0 1.75-.78 1.75-1.75v-3.04l-.15.14a2.5 2.5 0 01-3.53 0L5.73 8.77zM6 12h2a.5.5 0 110 1H6a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const PhoneEraser16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneEraser16FilledIcon, 'PhoneEraser16Filled');

const PhoneEraser16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 10.88v2.37c0 .41-.34.75-.75.75h-4.5a.75.75 0 01-.75-.75V2.75c0-.41.34-.75.75-.75h4.13l.91-.91A1.75 1.75 0 009.25 1h-4.5C3.78 1 3 1.78 3 2.75v10.5c0 .97.78 1.75 1.75 1.75h4.5c.97 0 1.75-.78 1.75-1.75v-3.13l-.23.23c-.23.23-.5.4-.77.53zM5.5 12.5c0-.28.22-.5.5-.5h2a.5.5 0 110 1H6a.5.5 0 01-.5-.5zm7.56-11.15a1.5 1.5 0 00-2.12 0L6.35 5.94a1.5 1.5 0 000 2.12l1.59 1.59a1.5 1.5 0 002.12 0l4.59-4.59a1.5 1.5 0 000-2.12l-1.59-1.59zM8 5.71L10.3 8l-.95.94a.5.5 0 01-.7 0L7.06 7.35a.5.5 0 010-.7L8 5.7z",
    fill: primaryFill
  }));
};

export const PhoneEraser16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneEraser16RegularIcon, 'PhoneEraser16Regular');

const PhoneEraser20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.58 1.44a1.5 1.5 0 012.12 0l1.86 1.86a1.5 1.5 0 010 2.12l-5.14 5.14a1.5 1.5 0 01-2.12 0L9.44 8.7a1.5 1.5 0 010-2.12l5.14-5.14zm-4.43 5.84a.5.5 0 000 .71L12 9.85c.2.2.51.2.7 0l1.3-1.29L11.44 6l-1.3 1.3zM12.6 2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-5.11a2.5 2.5 0 01-3.4-.12L8.72 9.4a2.5 2.5 0 010-3.54L12.6 2zm-2.1 12.5a.5.5 0 01-.5.5H8a.5.5 0 010-1h2c.28 0 .5.22.5.5z",
    fill: primaryFill
  }));
};

export const PhoneEraser20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneEraser20FilledIcon, 'PhoneEraser20Filled');

const PhoneEraser20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.58 1.44a1.5 1.5 0 012.12 0l1.86 1.86a1.5 1.5 0 010 2.12l-5.14 5.14a1.5 1.5 0 01-2.12 0L9.44 8.7a1.5 1.5 0 010-2.12l5.14-5.14zm-4.43 5.84a.5.5 0 000 .71L12 9.85c.2.2.51.2.7 0l1.3-1.29L11.44 6l-1.3 1.3zm2.38-5.2A2 2 0 0012 2H6a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2v-4.61c-.3.26-.64.43-1 .53V16a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1h5.6l.93-.93zM7.5 14.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1H8a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneEraser20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneEraser20RegularIcon, 'PhoneEraser20Regular');

const PhoneKey20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2C5.67 2 5 2.67 5 3.5v13c0 .83.67 1.5 1.5 1.5H9v-1c0-.41.16-.78.44-1.06l.94-.94H9a.5.5 0 010-1h2c.1 0 .2.03.29.1l.73-.74a3.72 3.72 0 01.31-1.98A4.1 4.1 0 0115 9.13V3.5c0-.83-.67-1.5-1.5-1.5h-7zm4 17a.48.48 0 01-.35-.15.48.48 0 01-.15-.35V17c0-.14.05-.25.15-.35l2.94-2.94a3.74 3.74 0 01-.09-.77c0-.4.08-.79.24-1.14a3.1 3.1 0 011.61-1.57 2.94 2.94 0 013.27.64A3 3 0 0115 15.84V16.52a.65.65 0 01-.08.24.5.5 0 01-.15.17.46.46 0 01-.27.07H14c0 .24 0 .43-.02.56a.46.46 0 01-.11.3.47.47 0 01-.3.12L13 18v.27c0 .08 0 .17-.02.25a.86.86 0 01-.06.24.37.37 0 01-.15.17.57.57 0 01-.27.07h-2zm7-6.75c0-.2-.07-.39-.22-.53a.72.72 0 00-.53-.22c-.2 0-.39.07-.53.22a.72.72 0 00-.22.53c0 .2.07.39.22.53.14.15.32.22.53.22.2 0 .39-.07.53-.22a.72.72 0 00.22-.53z",
    fill: primaryFill
  }));
};

export const PhoneKey20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneKey20FilledIcon, 'PhoneKey20Filled');

const PhoneKey20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h2v-1H7a1 1 0 01-1-1V4a1 1 0 011-1h6a1 1 0 011 1v5.54a3.97 3.97 0 011-.4V4a2 2 0 00-2-2H7zm3.38 13l.91-.9A.5.5 0 0011 14H9a.5.5 0 000 1h1.38zm.12 4a.48.48 0 01-.35-.15.48.48 0 01-.15-.35V17c0-.14.05-.25.15-.35l2.94-2.94a3.74 3.74 0 01-.09-.77c0-.4.08-.79.24-1.14a3.1 3.1 0 011.61-1.57 2.94 2.94 0 013.27.64A3 3 0 0115 15.84V16.52a.65.65 0 01-.08.24.5.5 0 01-.15.17.46.46 0 01-.27.07H14c0 .24 0 .43-.02.56a.46.46 0 01-.11.3.47.47 0 01-.3.12L13 18v.27c0 .08 0 .17-.02.25a.86.86 0 01-.06.24.37.37 0 01-.15.17.57.57 0 01-.27.07h-2zm7-6.75c0-.2-.07-.39-.22-.53a.72.72 0 00-.53-.22c-.2 0-.39.07-.53.22a.72.72 0 00-.22.53c0 .2.07.39.22.53.14.15.32.22.53.22.2 0 .39-.07.53-.22a.72.72 0 00.22-.53z",
    fill: primaryFill
  }));
};

export const PhoneKey20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneKey20RegularIcon, 'PhoneKey20Regular');

const PhoneKey24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v7a4.5 4.5 0 00-2.97 4.8L13.1 18h-2.34a.75.75 0 000 1.5h.84l-.08.07c-.33.33-.51.78-.51 1.24V22H8.25C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zm3.75 17a3.5 3.5 0 10-3.38-2.59.75.75 0 00-.15.12l-3.75 3.75a.75.75 0 00-.22.53v1.44c0 .41.34.75.75.75h1.75a.5.5 0 00.5-.5V22h1a.5.5 0 00.5-.5v-1h1a.5.5 0 00.5-.5v-1h1.5zm1.5-4a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const PhoneKey24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneKey24FilledIcon, 'PhoneKey24Filled');

const PhoneKey24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v7c-.56.2-1.07.5-1.5.9v-7.9a.75.75 0 00-.75-.75h-7.5a.75.75 0 00-.75.75v15.5c0 .41.34.75.75.75h2.78c-.02.1-.03.2-.03.31V22H8.25C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zm-2.5 15.5c.1 0 .2.02.28.05L12.08 19h-1.33a.75.75 0 010-1.5h2.5zM19.5 19a3.5 3.5 0 10-3.38-2.59.75.75 0 00-.15.12l-3.75 3.75a.75.75 0 00-.22.53v1.44c0 .41.34.75.75.75h1.75a.5.5 0 00.5-.5V22h1a.5.5 0 00.5-.5v-1h1a.5.5 0 00.5-.5v-1h1.5zm1.5-4a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const PhoneKey24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneKey24RegularIcon, 'PhoneKey24Regular');

const PhoneLaptop16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-4v-4A2.5 2.5 0 006 4H3.5a2 2 0 00-.5.06V4zm11.5 8.5h-6v-1h6a.5.5 0 010 1zM3 5c-.83 0-1.5.67-1.5 1.5v6c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-6C7.5 5.67 6.83 5 6 5H3zm1.5 7.5a.5.5 0 110-1 .5.5 0 010 1z",
    fill: primaryFill
  }));
};

export const PhoneLaptop16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLaptop16FilledIcon, 'PhoneLaptop16Filled');

const PhoneLaptop16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-4v-1h4A.5.5 0 0013 9V4a.5.5 0 00-.5-.5h-8A.5.5 0 004 4h-.5a2 2 0 00-.5.06V4zm11.5 8.5h-6v-1h6a.5.5 0 010 1zm-10 0a.5.5 0 100-1 .5.5 0 000 1zm-3-6C1.5 5.67 2.17 5 3 5h3c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5H3a1.5 1.5 0 01-1.5-1.5v-6zM3 6a.5.5 0 00-.5.5v6c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-6A.5.5 0 006 6H3z",
    fill: primaryFill
  }));
};

export const PhoneLaptop16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLaptop16RegularIcon, 'PhoneLaptop16Regular');

const PhoneLaptop20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H10V8a2 2 0 00-2-2H3V4.5zM10 15h7.5a.5.5 0 000-1H10v1zM2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 16.5v-8zM5 15a.5.5 0 000 1h1a.5.5 0 000-1H5z",
    fill: primaryFill
  }));
};

export const PhoneLaptop20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLaptop20FilledIcon, 'PhoneLaptop20Filled');

const PhoneLaptop20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H10v-1h5.5a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5V6H3V4.5zM10 15h7.5a.5.5 0 000-1H10v1zm-5 0a.5.5 0 000 1h1a.5.5 0 000-1H5zM2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 16.5v-8zM3.5 8a.5.5 0 00-.5.5v8c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-4z",
    fill: primaryFill
  }));
};

export const PhoneLaptop20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLaptop20RegularIcon, 'PhoneLaptop20Regular');

const PhoneLaptop24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.25 8C9.22 8 10 8.8 10 9.75v9.5c0 .97-.78 1.75-1.75 1.75h-4.5C2.78 21 2 20.22 2 19.25v-9.5C2 8.8 2.78 8 3.75 8h4.5zm-2 9.5h-.5a.75.75 0 100 1.5h.5a.75.75 0 000-1.5zm15-1a.75.75 0 01.1 1.5H11v-1.5h10.25zm-3-11.5c.97 0 1.75.78 1.75 1.75v7.5c0 .97-.78 1.75-1.75 1.75H11V9a2 2 0 00-1.85-2H4v-.25C4 5.78 4.78 5 5.75 5h12.5z",
    fill: primaryFill
  }));
};

export const PhoneLaptop24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLaptop24FilledIcon, 'PhoneLaptop24Filled');

const PhoneLaptop24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.25 8C9.22 8 10 8.8 10 9.75v9.5c0 .97-.78 1.75-1.75 1.75h-4.5C2.78 21 2 20.22 2 19.25v-9.5C2 8.8 2.78 8 3.75 8h4.5zm0 1.5h-4.5a.25.25 0 00-.25.25v9.5c0 .14.11.25.25.25h4.5c.14 0 .25-.1.25-.25v-9.5a.25.25 0 00-.25-.25zm-2 7.5a.75.75 0 01.1 1.5h-.6a.75.75 0 01-.1-1.5h.6zm15-.5a.75.75 0 01.1 1.5H11v-1.5h10.25zm-3-11.5c.97 0 1.75.78 1.75 1.75v7.5c0 .97-.78 1.75-1.75 1.75H11v-1.5h7.25c.14 0 .25-.11.25-.25v-7.5a.25.25 0 00-.25-.25H5.75a.25.25 0 00-.25.25V7H4v-.25C4 5.78 4.78 5 5.75 5h12.5z",
    fill: primaryFill
  }));
};

export const PhoneLaptop24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLaptop24RegularIcon, 'PhoneLaptop24Regular');

const PhoneLaptop32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 8a3 3 0 013-3h16a3 3 0 013 3v10a3 3 0 01-3 3h-8v-8a5 5 0 00-5-5H7a4 4 0 00-1 .13V8zm23 17H17v-2h12a1 1 0 110 2zM6 10a3 3 0 00-3 3v12a3 3 0 003 3h6a3 3 0 003-3V13a3 3 0 00-3-3H6zm3 15a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PhoneLaptop32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLaptop32FilledIcon, 'PhoneLaptop32Filled');

const PhoneLaptop32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 8a3 3 0 013-3h16a3 3 0 013 3v10a3 3 0 01-3 3h-8v-2h8a1 1 0 001-1V8a1 1 0 00-1-1H9a1 1 0 00-1 1H7a4 4 0 00-1 .13V8zm23 17H17v-2h12a1 1 0 110 2zM9 25a1 1 0 100-2 1 1 0 000 2zM3 13a3 3 0 013-3h6a3 3 0 013 3v12a3 3 0 01-3 3H6a3 3 0 01-3-3V13zm3-1a1 1 0 00-1 1v12a1 1 0 001 1h6a1 1 0 001-1V13a1 1 0 00-1-1H6z",
    fill: primaryFill
  }));
};

export const PhoneLaptop32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLaptop32RegularIcon, 'PhoneLaptop32Regular');

const PhoneLinkSetup20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v5.52A5.5 5.5 0 0010.26 18H6.5A1.5 1.5 0 015 16.5v-13zm7.07 7.94a2 2 0 01-1.44 2.48l-.46.12a4.73 4.73 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PhoneLinkSetup20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLinkSetup20FilledIcon, 'PhoneLinkSetup20Filled');

const PhoneLinkSetup20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h3.26a5.5 5.5 0 01-.66-1H7a1 1 0 01-1-1V4a1 1 0 011-1h6a1 1 0 011 1v5.02a5.57 5.57 0 011 0V4a2 2 0 00-2-2H7zm5.07 9.44a2 2 0 01-1.44 2.48l-.46.12a4.73 4.73 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PhoneLinkSetup20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLinkSetup20RegularIcon, 'PhoneLinkSetup20Regular');

const PhoneLinkSetup24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12c.3 0 .58.02.86.07l.17.72a2 2 0 002.42 1.47l.1-.02.6-.18c.36.46.65 1 .85 1.57l-.45.43a2 2 0 00-.17 2.7l.15.15.47.46c-.2.57-.5 1.1-.85 1.57l-.6-.18a2 2 0 00-2.49 1.35l-.03.1-.17.72a5.18 5.18 0 01-1.72 0l-.17-.72a2 2 0 00-2.42-1.47l-.1.02-.6.18c-.36-.47-.65-1-.85-1.57l.45-.43a2 2 0 00.17-2.7l-.15-.15-.47-.46c.2-.58.5-1.1.85-1.57l.6.18a2 2 0 002.49-1.35l.03-.1.17-.72c.28-.05.57-.07.86-.07zM13.75 2C14.99 2 16 3 16 4.25v6.92A6.5 6.5 0 0011.02 18H8.75a.75.75 0 00-.1 1.5h2.66c.3.95.83 1.8 1.5 2.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h7.5zm3.75 14c-.8 0-1.45.67-1.45 1.5S16.7 19 17.5 19c.8 0 1.45-.67 1.45-1.5S18.3 16 17.5 16z",
    fill: primaryFill
  }));
};

export const PhoneLinkSetup24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLinkSetup24FilledIcon, 'PhoneLinkSetup24Filled');

const PhoneLinkSetup24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12c.3 0 .58.02.86.07l.17.72a2 2 0 002.42 1.47l.1-.02.6-.18c.36.46.65 1 .85 1.57l-.45.43a2 2 0 00-.17 2.7l.15.15.47.46c-.2.57-.5 1.1-.85 1.57l-.6-.18a2 2 0 00-2.49 1.35l-.03.1-.17.72a5.18 5.18 0 01-1.72 0l-.17-.72a2 2 0 00-2.42-1.47l-.1.02-.6.18c-.36-.47-.65-1-.85-1.57l.45-.43a2 2 0 00.17-2.7l-.15-.15-.47-.46c.2-.58.5-1.1.85-1.57l.6.18a2 2 0 002.49-1.35l.03-.1.17-.72c.28-.05.57-.07.86-.07zM13.75 2C14.99 2 16 3 16 4.25v6.92c-.53.13-1.03.32-1.5.56V4.25a.75.75 0 00-.75-.75h-7.5a.75.75 0 00-.75.75v15.5c0 .41.34.75.75.75h5.48c.29.55.65 1.06 1.08 1.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h7.5zm-5 15.5H11c0 .52.06 1.02.17 1.5H8.75a.75.75 0 010-1.5zM17.5 16c-.8 0-1.45.67-1.45 1.5S16.7 19 17.5 19c.8 0 1.45-.67 1.45-1.5S18.3 16 17.5 16z",
    fill: primaryFill
  }));
};

export const PhoneLinkSetup24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLinkSetup24RegularIcon, 'PhoneLinkSetup24Regular');

const PhoneLock20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v5.54A3 3 0 0011.5 12v.06A2 2 0 0010 14H8.5a.5.5 0 000 1H10v3H6.5A1.5 1.5 0 015 16.5v-13zm7.5 8.5v1H12a1 1 0 00-1 1v4a1 1 0 001 1h5a1 1 0 001-1v-4a1 1 0 00-1-1h-.5v-1a2 2 0 10-4 0zm1 1v-1a1 1 0 112 0v1h-2zm1 2.25a.75.75 0 110 1.5.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const PhoneLock20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLock20FilledIcon, 'PhoneLock20Filled');

const PhoneLock20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v5.04a3.02 3.02 0 00-1 0V4a1 1 0 00-1-1H7a1 1 0 00-1 1v12a1 1 0 001 1h3v1H7a2 2 0 01-2-2V4zm3.5 10H10v1H8.5a.5.5 0 010-1zm4-2v1H12a1 1 0 00-1 1v4a1 1 0 001 1h5a1 1 0 001-1v-4a1 1 0 00-1-1h-.5v-1a2 2 0 10-4 0zm1 1v-1a1 1 0 112 0v1h-2zm1 2.25a.75.75 0 110 1.5.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const PhoneLock20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLock20RegularIcon, 'PhoneLock20Regular');

const PhoneLock24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.75 2C14.99 2 16 3 16 4.25v6.59A3.5 3.5 0 0014 14v.05a2.5 2.5 0 00-2 2.45v2.25a.75.75 0 00-.75-.75h-2.5a.75.75 0 000 1.5h2.5c.41 0 .75-.34.75-.75v2.75c0 .17.02.34.05.5h-5.8C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h7.5zM15 14v1h-.5c-.83 0-1.5.67-1.5 1.5v5a1.5 1.5 0 001.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H20v-1a2.5 2.5 0 00-5 0zm1.5 0a1 1 0 112 0v1h-2v-1zm2 5a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const PhoneLock24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLock24FilledIcon, 'PhoneLock24Filled');

const PhoneLock24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.75 2C14.99 2 16 3 16 4.25v6.59c-.62.3-1.15.77-1.5 1.36V4.25a.75.75 0 00-.75-.75h-7.5a.75.75 0 00-.75.75v15.5c0 .41.34.75.75.75H12v1c0 .17.02.34.05.5h-5.8C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h7.5zM15 14a2.5 2.5 0 115 0v1h.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5h.5v-1zm1.5 0v1h2v-1a1 1 0 10-2 0zm2 5a1 1 0 10-2 0 1 1 0 002 0zm-6.5-.75c0 .41-.34.75-.75.75h-2.5a.75.75 0 010-1.5h2.5c.41 0 .75.33.75.75z",
    fill: primaryFill
  }));
};

export const PhoneLock24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneLock24RegularIcon, 'PhoneLock24Regular');

const PhonePageHeader20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v1H5V4zm0 2v10c0 1.1.9 2 2 2h6a2 2 0 002-2V6H5z",
    fill: primaryFill
  }));
};

export const PhonePageHeader20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePageHeader20FilledIcon, 'PhonePageHeader20Filled');

const PhonePageHeader20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zM6 5h8v11a1 1 0 01-1 1H7a1 1 0 01-1-1V5z",
    fill: primaryFill
  }));
};

export const PhonePageHeader20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePageHeader20RegularIcon, 'PhonePageHeader20Regular');

const PhonePageHeader24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 6v13.75c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V6h12zm-2.25-4C16.99 2 18 3 18 4.25V5H6v-.75C6 3.01 7 2 8.25 2h7.5z",
    fill: primaryFill
  }));
};

export const PhonePageHeader24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePageHeader24FilledIcon, 'PhonePageHeader24Filled');

const PhonePageHeader24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zm.75 3h-9v14.75c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V5z",
    fill: primaryFill
  }));
};

export const PhonePageHeader24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePageHeader24RegularIcon, 'PhonePageHeader24Regular');

const PhonePagination20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V4zm3 11a.5.5 0 100-1 .5.5 0 000 1zm2 0a.5.5 0 100-1 .5.5 0 000 1zm2.5-.5a.5.5 0 10-1 0 .5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const PhonePagination20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePagination20FilledIcon, 'PhonePagination20Filled');

const PhonePagination20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 15a.5.5 0 100-1 .5.5 0 000 1zm2.5-.5a.5.5 0 11-1 0 .5.5 0 011 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1zM7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zM6 4a1 1 0 011-1h6a1 1 0 011 1v12a1 1 0 01-1 1H7a1 1 0 01-1-1V4z",
    fill: primaryFill
  }));
};

export const PhonePagination20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePagination20RegularIcon, 'PhonePagination20Regular');

const PhonePagination24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zM9.5 17.76a.75.75 0 100 1.5.75.75 0 000-1.5zm2.5 0a.75.75 0 100 1.5.75.75 0 000-1.5zm2.5 0a.75.75 0 100 1.5.75.75 0 000-1.5z",
    fill: primaryFill
  }));
};

export const PhonePagination24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePagination24FilledIcon, 'PhonePagination24Filled');

const PhonePagination24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zm0 1.5h-7.5a.75.75 0 00-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 00-.75-.75zM9.5 17.75a.75.75 0 110 1.5.75.75 0 010-1.5zm2.5 0a.75.75 0 110 1.5.75.75 0 010-1.5zm2.5 0a.75.75 0 110 1.5.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const PhonePagination24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhonePagination24RegularIcon, 'PhonePagination24Regular');

const PhoneScreenTime20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.47 5.47 0 01-1.24-3H7.5a.5.5 0 010-1h1.52A5.5 5.5 0 0114 9.02V3.5c0-.83-.67-1.5-1.5-1.5h-7zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1v-1.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneScreenTime20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneScreenTime20FilledIcon, 'PhoneScreenTime20Filled');

const PhoneScreenTime20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 01-.66-1H5.5a.5.5 0 01-.5-.5v-13c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5.7c.32-.08.66-.15 1-.18V3.5c0-.83-.67-1.5-1.5-1.5h-7zM9 14.5c0 .17 0 .34.02.5H7.5a.5.5 0 010-1h1.52l-.02.5zm10 0a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1v-1.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneScreenTime20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneScreenTime20RegularIcon, 'PhoneScreenTime20Regular');

const PhoneScreenTime24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM13.75 2C14.99 2 16 3 16 4.25v6.92A6.5 6.5 0 0011.02 18H8.75a.75.75 0 00-.1 1.5h2.66c.3.95.83 1.8 1.5 2.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h7.5zm2.75 12a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h3a.5.5 0 000-1H17v-3.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneScreenTime24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneScreenTime24FilledIcon, 'PhoneScreenTime24Filled');

const PhoneScreenTime24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM13.75 2C14.99 2 16 3 16 4.25v6.92c-.53.13-1.03.32-1.5.56V4.25a.75.75 0 00-.75-.75h-7.5a.75.75 0 00-.75.75v15.5c0 .41.34.75.75.75h5.48c.29.55.65 1.06 1.08 1.5H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h7.5zm-5 15.5H11c0 .52.06 1.02.17 1.5H8.75a.75.75 0 010-1.5zM16.5 14a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h3a.5.5 0 000-1H17v-3.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneScreenTime24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneScreenTime24RegularIcon, 'PhoneScreenTime24Regular');

const PhoneShake20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.37 2.93a.5.5 0 11.5-.86 4.25 4.25 0 011.63 5.66.5.5 0 01-.88-.47 3.25 3.25 0 00-1.25-4.33zm-1 1.74a.5.5 0 11.5-.87c1.02.59 1.4 1.86.91 2.9a.5.5 0 01-.9-.42c.27-.58.06-1.29-.5-1.61zm-9.74 12.4a.5.5 0 11-.5.86 4.25 4.25 0 01-1.63-5.66.5.5 0 11.88.46 3.25 3.25 0 001.25 4.33zm1-1.74a.5.5 0 11-.5.87 2.25 2.25 0 01-.92-2.9.5.5 0 01.9.42c-.26.58-.05 1.28.52 1.61zm4.54-12.26a1.95 1.95 0 012.4 1.4l2.37 8.97a2.04 2.04 0 01-1.42 2.48l-3.69 1a1.95 1.95 0 01-2.4-1.4L5.08 6.57a2.04 2.04 0 011.42-2.49l3.68-1zm-.49 11.3c.07.27.34.43.6.36l1.79-.48a.51.51 0 00.36-.62.49.49 0 00-.6-.36l-1.78.49a.51.51 0 00-.37.62z",
    fill: primaryFill
  }));
};

export const PhoneShake20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneShake20FilledIcon, 'PhoneShake20Filled');

const PhoneShake20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.37 2.93a.5.5 0 11.5-.86 4.25 4.25 0 011.63 5.66.5.5 0 01-.88-.47 3.25 3.25 0 00-1.25-4.33zm-1 1.74a.5.5 0 11.5-.87c1.02.59 1.4 1.86.91 2.9a.5.5 0 01-.9-.42c.27-.58.06-1.29-.5-1.61zm-9.74 12.4a.5.5 0 11-.5.86 4.25 4.25 0 01-1.63-5.66.5.5 0 11.88.46 3.25 3.25 0 001.25 4.33zm1-1.74a.5.5 0 11-.5.87 2.25 2.25 0 01-.92-2.9.5.5 0 01.9.42c-.26.58-.05 1.28.52 1.61zm5.97-10.6a.96.96 0 00-1.17-.7l-3.7 1.01c-.52.14-.84.7-.7 1.25l2.37 8.98c.14.53.67.83 1.18.7l3.68-1.01c.53-.15.85-.7.7-1.25L11.6 4.73zm-1.43-1.66a1.95 1.95 0 012.4 1.4l2.36 8.97a2.04 2.04 0 01-1.41 2.48l-3.69 1a1.95 1.95 0 01-2.4-1.4L5.07 6.57a2.04 2.04 0 011.41-2.49l3.69-1zm-.49 11.3a.51.51 0 01.36-.61l1.79-.48c.26-.08.53.08.6.35.07.27-.1.54-.36.62l-1.78.48a.49.49 0 01-.6-.35z",
    fill: primaryFill
  }));
};

export const PhoneShake20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneShake20RegularIcon, 'PhoneShake20Regular');

const PhoneShake24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.34 4.07c1.2-.32 2.43.39 2.76 1.6l2.75 10.28c.33 1.2-.39 2.43-1.59 2.76l-4.6 1.23c-1.2.32-2.43-.4-2.75-1.6L6.16 8.06A2.25 2.25 0 017.75 5.3l4.59-1.23zm2.35 11.2a.75.75 0 00-.92-.52l-1.93.52-.1.03a.75.75 0 00.49 1.42l1.93-.52.1-.04a.75.75 0 00.43-.88zM18.68 2.4c.2-.36.65-.5 1.02-.3a4.9 4.9 0 011.72 6.49.75.75 0 01-1.34-.69l.05-.09a3.4 3.4 0 00-1.16-4.39.75.75 0 01-.3-1.02zM17.5 4.44a.75.75 0 011.05-.14 2.6 2.6 0 01.9 1.32c.11.44.09.88-.02 1.29l-.05.18-.05.13a.75.75 0 01-1.41-.49l.05-.14v-.06c.06-.18.07-.37.03-.52a.93.93 0 00-.17-.31 1.37 1.37 0 00-.15-.18l-.04-.03a.75.75 0 01-.14-1.05zM2.54 15.41a.75.75 0 011.34.66l-.1.2-.1.28a3.54 3.54 0 00.6 3.36c.26.32.51.54.68.65l.07.04a.75.75 0 11-.75 1.3 5.04 5.04 0 01-1.74-6.49zm2.13 1.35a.75.75 0 011.42.47l-.05.15-.01.05c-.05.18-.06.37-.02.53a1.38 1.38 0 00.32.5l.04.02a.75.75 0 01-.92 1.19 2.6 2.6 0 01-.88-1.33c-.12-.43-.1-.87 0-1.28l.06-.17.04-.13z",
    fill: primaryFill
  }));
};

export const PhoneShake24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneShake24FilledIcon, 'PhoneShake24Filled');

const PhoneShake24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.68 2.4c.2-.37.65-.5 1.02-.3a4.9 4.9 0 011.72 6.49.75.75 0 01-1.34-.7l.05-.09a3.4 3.4 0 00-1.16-4.39.75.75 0 01-.3-1.02zm-3.99 12.88a.75.75 0 00-.92-.53l-1.93.52-.1.03a.75.75 0 00.49 1.42l1.93-.52.1-.04a.75.75 0 00.43-.88zm.4-9.62a2.25 2.25 0 00-2.75-1.59L7.74 5.3a2.25 2.25 0 00-1.58 2.76L8.9 18.34a2.25 2.25 0 002.76 1.6l4.6-1.23a2.25 2.25 0 001.58-2.76L15.1 5.66zm-2.36-.14c.4-.1.81.13.92.53l2.76 10.29c.1.4-.14.81-.54.92l-4.6 1.23a.75.75 0 01-.91-.53L7.61 7.67c-.11-.4.13-.81.53-.92l4.59-1.23zm5.82-1.22a.75.75 0 10-.9 1.2l.03.02c.04.04.1.1.15.18.08.1.14.21.17.31a1.07 1.07 0 01-.03.58l-.05.14a.75.75 0 001.41.49l.05-.13.05-.18c.1-.41.13-.85.01-1.29a2.6 2.6 0 00-.9-1.32zM2.54 15.41a.75.75 0 011.34.66l-.1.2-.1.28a3.54 3.54 0 00.6 3.36c.26.32.51.54.68.65l.07.04a.75.75 0 11-.75 1.3 5.04 5.04 0 01-1.74-6.49zm3.11.94a.75.75 0 00-.98.4 1.8 1.8 0 00-.04.14l-.05.17c-.1.41-.13.85-.01 1.28a2.61 2.61 0 00.89 1.32.75.75 0 00.9-1.18l-.03-.03c-.04-.04-.1-.1-.15-.18a.95.95 0 01-.17-.31 1.07 1.07 0 01.03-.58l.05-.15a.75.75 0 00-.44-.88z",
    fill: primaryFill
  }));
};

export const PhoneShake24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneShake24RegularIcon, 'PhoneShake24Regular');

const PhoneSpanIn16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 1a2 2 0 00-2 2v2.09c.2.07.4.19.56.35l2 2a1.5 1.5 0 010 2.12l-2 2a1.5 1.5 0 01-.56.35V13c0 1.1.9 2 2 2h4a2 2 0 002-2v-1.09a1.5 1.5 0 01-.56-.35l-2-2a1.5 1.5 0 010-2.12l2-2c.16-.16.36-.28.56-.35V3a2 2 0 00-2-2H6zM3.15 6.85a.5.5 0 11.7-.7l2 2a.5.5 0 010 .7l-2 2a.5.5 0 01-.7-.7L4.29 9H1.5a.5.5 0 010-1h2.8L3.14 6.85zm9.7-.7c.2.2.2.5 0 .7L11.71 8h2.79a.5.5 0 010 1h-2.8l1.15 1.15a.5.5 0 11-.7.7l-2-2a.5.5 0 010-.7l2-2c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const PhoneSpanIn16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanIn16FilledIcon, 'PhoneSpanIn16Filled');

const PhoneSpanIn16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3c0-1.1.9-2 2-2h4a2 2 0 012 2v2.09c-.2.07-.4.19-.56.35l-.44.44V3a1 1 0 00-1-1H6a1 1 0 00-1 1v2.88l-.44-.44A1.5 1.5 0 004 5.09V3zm7 8.12V13a1 1 0 01-1 1H6a1 1 0 01-1-1v-1.88l-.44.44a1.5 1.5 0 01-.56.35V13c0 1.1.9 2 2 2h4a2 2 0 002-2v-1.09a1.5 1.5 0 01-.56-.35l-.44-.44zM3.15 6.85a.5.5 0 11.7-.7l2 2a.5.5 0 010 .7l-2 2a.5.5 0 01-.7-.7L4.29 9H1.5a.5.5 0 010-1h2.8L3.14 6.85zm9.7-.7c.2.2.2.5 0 .7L11.71 8h2.79a.5.5 0 010 1h-2.8l1.15 1.15a.5.5 0 11-.7.7l-2-2a.5.5 0 010-.7l2-2c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const PhoneSpanIn16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanIn16RegularIcon, 'PhoneSpanIn16Regular');

const PhoneSpanIn20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2a2 2 0 00-2 2v3.09a1.5 1.5 0 011.56.35l2 2a1.5 1.5 0 010 2.12l-2 2a1.5 1.5 0 01-1.56.35V16c0 1.1.9 2 2 2h6a2 2 0 002-2v-2.09a1.5 1.5 0 01-1.56-.35l-2-2a1.5 1.5 0 010-2.12l2-2A1.5 1.5 0 0115 7.09V4a2 2 0 00-2-2H7zm7.85 6.15c.2.2.2.5 0 .7L13.71 10h2.79a.5.5 0 010 1h-2.8l1.15 1.15a.5.5 0 01-.7.7l-2-2a.5.5 0 010-.7l2-2c.2-.2.5-.2.7 0zm-9.7.7a.5.5 0 11.7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7-.7L6.29 11H3.5a.5.5 0 010-1h2.8L5.14 8.85z",
    fill: primaryFill
  }));
};

export const PhoneSpanIn20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanIn20FilledIcon, 'PhoneSpanIn20Filled');

const PhoneSpanIn20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v3.09a1.5 1.5 0 00-1 0V4a1 1 0 00-1-1H7a1 1 0 00-1 1v3.09a1.5 1.5 0 00-1 0V4zm0 9.91V16c0 1.1.9 2 2 2h6a2 2 0 002-2v-2.09a1.5 1.5 0 01-1 0V16a1 1 0 01-1 1H7a1 1 0 01-1-1v-2.09a1.5 1.5 0 01-1 0zm2.85-3.06l-2 2a.5.5 0 01-.7-.7L6.29 11H3.5a.5.5 0 010-1h2.8L5.14 8.85a.5.5 0 11.7-.7l2 2a.5.5 0 01.15.35.5.5 0 01-.14.35zm6.3-2.7l-2 2a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 11h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7z",
    fill: primaryFill
  }));
};

export const PhoneSpanIn20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanIn20RegularIcon, 'PhoneSpanIn20Regular');

const PhoneSpanIn24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2c1.2 0 2.17.93 2.24 2.1l.01.15v3.67c-.65-.31-1.45-.2-1.99.34l-2.18 2.22c-.52.31-.83.9-.83 1.52v.16c.05.46.26.88.6 1.18l.1.1 2.31 2.3.14.12a1.8 1.8 0 001.85.22v3.67c0 1.2-.93 2.17-2.1 2.24l-.15.01h-7.5c-1.2 0-2.17-.93-2.24-2.1L6 19.75v-3.68c.59.28 1.27.22 1.8-.16l.13-.12 2.36-2.35.12-.1c.37-.33.59-.82.59-1.34v-.16a1.78 1.78 0 00-.6-1.18l-.1-.1-2.31-2.3A1.75 1.75 0 006 7.92V4.25c0-1.2.93-2.17 2.1-2.24L8.25 2h7.5zm2.03 6.97c.27.27.3.68.07.98l-.07.08-1.22 1.22h3.78c.37 0 .66.33.66.75 0 .38-.25.7-.57.74H16.56l1.22 1.23c.27.27.3.68.07.98l-.07.08a.75.75 0 01-.98.07l-.08-.07-2.37-2.37A.77.77 0 0114 12c0-.29.14-.54.35-.66l2.37-2.37c.3-.3.77-.3 1.06 0zM7.2 8.9l.08.07 2.37 2.37c.2.12.35.37.35.66 0 .25-.1.47-.28.61l-.07.05-2.37 2.37-.08.07c-.27.2-.62.2-.89.01l-.1-.08-.06-.08a.75.75 0 01-.01-.89l.08-.09 1.22-1.22H3.56C3.26 12.68 3 12.37 3 12s.25-.7.57-.74l.09-.01h3.78l-1.22-1.22-.07-.09A.75.75 0 017.2 8.9z",
    fill: primaryFill
  }));
};

export const PhoneSpanIn24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanIn24FilledIcon, 'PhoneSpanIn24Filled');

const PhoneSpanIn24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 16.07c.48.23 1.03.23 1.5.01v3.67c0 .38.28.7.65.74l.1.01h7.5c.38 0 .7-.28.74-.65l.01-.1v-3.68c.5.23 1.04.23 1.5.01v3.67c0 1.2-.93 2.17-2.1 2.24l-.15.01h-7.5c-1.2 0-2.17-.93-2.24-2.1L6 19.75v-3.68zm11.78-7.1c.27.27.3.68.07.98l-.07.08-1.22 1.22h3.78c.37 0 .66.33.66.75 0 .38-.25.7-.57.74H16.56l1.22 1.23c.27.27.3.68.07.98l-.07.08a.75.75 0 01-.98.07l-.08-.07-2.37-2.37A.77.77 0 0114 12c0-.29.14-.54.35-.66l2.37-2.37c.3-.3.77-.3 1.06 0zM7.2 8.9l.08.07 2.37 2.37c.2.12.35.37.35.66 0 .25-.1.47-.28.61l-.07.05-2.37 2.37-.08.07c-.27.2-.62.2-.89.01l-.1-.08-.06-.08a.75.75 0 01-.01-.89l.08-.09 1.22-1.22H3.56C3.26 12.68 3 12.37 3 12s.25-.7.57-.74l.09-.01h3.78l-1.22-1.22-.07-.09A.75.75 0 017.2 8.9zM15.75 2c1.2 0 2.17.93 2.24 2.1l.01.15v3.67a1.76 1.76 0 00-1.5 0V4.25c0-.38-.28-.7-.65-.74l-.1-.01h-7.5c-.38 0-.7.28-.74.65l-.01.1v3.67a1.76 1.76 0 00-1.5 0V4.25c0-1.2.93-2.17 2.1-2.24L8.25 2h7.5z",
    fill: primaryFill
  }));
};

export const PhoneSpanIn24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanIn24RegularIcon, 'PhoneSpanIn24Regular');

const PhoneSpanIn28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 2A2.75 2.75 0 006 4.75v5.13c.87-.59 2.07-.5 2.84.28l3 3c.88.88.88 2.3 0 3.18l-3 3c-.77.77-1.97.87-2.84.28v3.63A2.75 2.75 0 008.75 26h10.5A2.75 2.75 0 0022 23.25v-3.63c-.87.59-2.07.5-2.84-.28l-3-3a2.25 2.25 0 010-3.18l3-3A2.25 2.25 0 0122 9.88V4.75A2.75 2.75 0 0019.25 2H8.75zM6.72 12.28L8.44 14H3.75a.75.75 0 000 1.5h4.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06zm14.56 0L19.56 14h4.69a.75.75 0 010 1.5h-4.69l1.72 1.72a.75.75 0 11-1.06 1.06l-3-3a.75.75 0 010-1.06l3-3a.75.75 0 111.06 1.06z",
    fill: primaryFill
  }));
};

export const PhoneSpanIn28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanIn28FilledIcon, 'PhoneSpanIn28Filled');

const PhoneSpanIn28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 2A2.75 2.75 0 006 4.75v5.13c.45-.3.98-.42 1.5-.37V4.75c0-.69.56-1.25 1.25-1.25h10.5c.69 0 1.25.56 1.25 1.25v4.76c.52-.05 1.05.07 1.5.37V4.75A2.75 2.75 0 0019.25 2H8.75zM25 14.75a.75.75 0 00-.75-.75h-4.69l1.72-1.72a.75.75 0 10-1.06-1.06l-3 3c-.3.3-.3.77 0 1.06l3 3a.75.75 0 101.06-1.06l-1.72-1.72h4.69c.41 0 .75-.34.75-.75zm-3 4.87c-.45.3-.98.42-1.5.37v3.26c0 .69-.56 1.25-1.25 1.25H8.75c-.69 0-1.25-.56-1.25-1.25v-3.26a2.25 2.25 0 01-1.5-.37v3.63A2.75 2.75 0 008.75 26h10.5A2.75 2.75 0 0022 23.25v-3.63zM7.5 11.04a.75.75 0 00-.78 1.24L8.44 14H3.75a.75.75 0 000 1.5h4.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3c.3-.3.3-.77 0-1.06l-3-3a.75.75 0 00-.28-.18z",
    fill: primaryFill
  }));
};

export const PhoneSpanIn28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanIn28RegularIcon, 'PhoneSpanIn28Regular');

const PhoneSpanOut16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 1a2 2 0 00-2 2v2.09A1.5 1.5 0 014.91 7h.59a1.5 1.5 0 110 3h-.59A1.5 1.5 0 014 11.91V13c0 1.1.9 2 2 2h4a2 2 0 002-2v-1.09a1.5 1.5 0 01-.91-1.91h-.59a1.5 1.5 0 110-3h.59A1.5 1.5 0 0112 5.09V3a2 2 0 00-2-2H6zm4.5 7h2.8l-1.15-1.15a.5.5 0 01.7-.7l2 2a.5.5 0 01.15.35.5.5 0 01-.14.35l-2 2a.5.5 0 01-.71-.7L13.29 9H10.5a.5.5 0 01-.5-.5.5.5 0 01.5-.5zm-5 1a.5.5 0 000-1H2.7l1.15-1.15a.5.5 0 10-.7-.7l-2 2A.5.5 0 001 8.5a.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L2.71 9H5.5z",
    fill: primaryFill
  }));
};

export const PhoneSpanOut16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanOut16FilledIcon, 'PhoneSpanOut16Filled');

const PhoneSpanOut16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3c0-1.1.9-2 2-2h4a2 2 0 012 2v2.09a1.5 1.5 0 00-1 1.41V3a1 1 0 00-1-1H6a1 1 0 00-1 1v3.5a1.5 1.5 0 00-1-1.41V3zm7 7.5V13a1 1 0 01-1 1H6a1 1 0 01-1-1v-2.5a1.5 1.5 0 01-1 1.41V13c0 1.1.9 2 2 2h4a2 2 0 002-2v-1.09a1.5 1.5 0 01-1-1.41zM1.15 8.15l2-2a.5.5 0 11.7.7L2.71 8H5.5a.5.5 0 010 1H2.7l1.15 1.15a.5.5 0 01-.7.7l-2-2A.5.5 0 011 8.5a.5.5 0 01.14-.35zm11.7 2.7l2-2A.5.5 0 0015 8.5a.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L13.29 8H10.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7z",
    fill: primaryFill
  }));
};

export const PhoneSpanOut16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanOut16RegularIcon, 'PhoneSpanOut16Regular');

const PhoneSpanOut20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2a2 2 0 00-2 2v3.09A1.5 1.5 0 016.91 9h.59a1.5 1.5 0 110 3h-.59A1.5 1.5 0 015 13.91V16c0 1.1.9 2 2 2h6a2 2 0 002-2v-2.09A1.5 1.5 0 0113.09 12h-.59a1.5 1.5 0 010-3h.59A1.5 1.5 0 0115 7.09V4a2 2 0 00-2-2H7zm7.85 6.15a.5.5 0 00-.7.7L15.29 10H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2zM4.71 10l1.14-1.15h.01a.5.5 0 00-.71-.7l-2 2a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L4.71 11H7.5a.5.5 0 00.5-.5.5.5 0 00-.5-.5H4.7z",
    fill: primaryFill
  }));
};

export const PhoneSpanOut20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanOut20FilledIcon, 'PhoneSpanOut20Filled');

const PhoneSpanOut20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v3.09a1.5 1.5 0 00-1 0V4a1 1 0 00-1-1H7a1 1 0 00-1 1v3.09a1.5 1.5 0 00-1 0V4zm0 9.91c.32.12.68.12 1 0V16a1 1 0 001 1h6a1 1 0 001-1v-2.09c.32.12.68.12 1 0V16a2 2 0 01-2 2H7a2 2 0 01-2-2v-2.09zm-1.85-3.76l2-2a.5.5 0 11.7.7L4.71 10H7.5a.5.5 0 010 1H4.7l1.15 1.15a.5.5 0 01-.7.7l-2-2A.5.5 0 013 10.5a.5.5 0 01.14-.35zm11.7 2.7l2-2a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 10H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7z",
    fill: primaryFill
  }));
};

export const PhoneSpanOut20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanOut20RegularIcon, 'PhoneSpanOut20Regular');

const PhoneSpanOut24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2c1.2 0 2.17.93 2.24 2.1l.01.15v3.52a1.75 1.75 0 00-1.49.5A1.73 1.73 0 0016.1 10l.05.16.04.09h-1.52c-.85 0-1.5.65-1.64 1.46l-.01.14L13 12c0 .8.51 1.51 1.33 1.7l.16.04h1.68l-.02.04c-.2.47-.2 1.02.05 1.51l.1.17.09.14.12.14c.4.4.95.57 1.49.48v3.53c0 1.2-.93 2.17-2.1 2.24l-.15.01h-7.5c-1.2 0-2.17-.93-2.24-2.1L6 19.75v-3.53c.54.09 1.09-.08 1.49-.48l.12-.14.1-.14c.33-.54.37-1.16.14-1.68l-.02-.03h1.51l.17-.01c.91-.14 1.49-.9 1.49-1.74v-.15a1.7 1.7 0 00-1.66-1.6H7.82l.04-.1A1.74 1.74 0 006 7.78V4.25c0-1.2.93-2.17 2.1-2.24L8.25 2h7.5zM6.78 8.97c.27.26.3.68.07.97l-.07.09-1.22 1.22h3.78c.37 0 .66.33.66.75 0 .38-.25.7-.57.74H5.56l1.22 1.23c.27.27.3.68.07.98l-.07.08a.75.75 0 01-.98.07l-.08-.07-2.37-2.37A.77.77 0 013 12c0-.29.14-.54.35-.66l2.37-2.37c.3-.3.77-.3 1.06 0zm10.44 0a.75.75 0 01.98-.08l.08.08 2.37 2.36c.2.13.35.38.35.67 0 .25-.1.47-.28.6l-.07.06-2.37 2.37-.08.07c-.27.2-.62.2-.89 0l-.1-.07-.06-.09a.75.75 0 01-.01-.88l.08-.1 1.22-1.21h-3.78l-.1-.01c-.31-.05-.56-.37-.56-.74 0-.38.25-.7.57-.75H18.44l-1.22-1.22-.07-.09a.75.75 0 01.07-.97z",
    fill: primaryFill
  }));
};

export const PhoneSpanOut24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanOut24FilledIcon, 'PhoneSpanOut24Filled');

const PhoneSpanOut24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.5 15.72l.01.02c.4.4.95.57 1.49.48v3.53c0 1.2-.93 2.17-2.1 2.24l-.15.01h-7.5c-1.2 0-2.17-.93-2.24-2.1L6 19.75v-3.53c.49.08.98-.05 1.36-.37l.14-.13v4.03c0 .38.28.7.65.74l.1.01h7.5c.38 0 .7-.28.74-.65l.01-.1v-4.03zM6.78 8.97c.27.26.3.68.07.97l-.07.09-1.22 1.22h3.78c.37 0 .66.33.66.75 0 .38-.25.7-.57.74H5.56l1.22 1.23c.27.27.3.68.07.98l-.07.08a.75.75 0 01-.98.07l-.08-.07-2.37-2.37A.77.77 0 013 12c0-.29.14-.54.35-.66l2.37-2.37c.3-.3.77-.3 1.06 0zm10.44 0a.75.75 0 01.98-.08l.08.08 2.37 2.36c.2.13.35.38.35.67 0 .25-.1.47-.28.6l-.07.06-2.37 2.37-.08.07c-.27.2-.62.2-.89 0l-.1-.07-.06-.09a.75.75 0 01-.01-.88l.08-.1 1.22-1.21h-3.78l-.1-.01c-.31-.05-.56-.37-.56-.74 0-.38.25-.7.57-.75H18.44l-1.22-1.22-.07-.09a.75.75 0 01.07-.97zM15.75 2c1.2 0 2.17.93 2.24 2.1l.01.15v3.52c-.47-.07-.97.06-1.36.38l-.14.12V4.25c0-.38-.28-.7-.65-.74l-.1-.01h-7.5c-.38 0-.7.28-.74.65l-.01.1v4.02h-.01c-.4-.41-.96-.58-1.5-.5L6 4.25c0-1.2.93-2.17 2.1-2.24L8.25 2h7.5z",
    fill: primaryFill
  }));
};

export const PhoneSpanOut24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanOut24RegularIcon, 'PhoneSpanOut24Regular');

const PhoneSpanOut28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 2A2.75 2.75 0 006 4.75v4.88a2.25 2.25 0 012.87 2.87h1.38a2.25 2.25 0 010 4.5H8.87A2.25 2.25 0 016 19.87v3.38A2.75 2.75 0 008.75 26h10.5A2.75 2.75 0 0022 23.25v-3.38A2.25 2.25 0 0119.13 17h-1.38a2.25 2.25 0 010-4.5h1.38A2.25 2.25 0 0122 9.63V4.75A2.75 2.75 0 0019.25 2H8.75zM6.22 18.28l-3-3a.75.75 0 010-1.06l3-3a.75.75 0 011.06 1.06L5.56 14h4.69a.75.75 0 010 1.5H5.56l1.72 1.72a.75.75 0 11-1.06 1.06zm15.56-7.06l3 3c.3.3.3.77 0 1.06l-3 3a.75.75 0 01-1.06-1.06l1.72-1.72h-4.69a.75.75 0 010-1.5h4.69l-1.72-1.72a.75.75 0 111.06-1.06z",
    fill: primaryFill
  }));
};

export const PhoneSpanOut28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanOut28FilledIcon, 'PhoneSpanOut28Filled');

const PhoneSpanOut28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 2A2.75 2.75 0 006 4.75v4.88a2.26 2.26 0 011.5 0V4.75c0-.69.56-1.25 1.25-1.25h10.5c.69 0 1.25.56 1.25 1.25v4.88a2.26 2.26 0 011.5 0V4.75A2.75 2.75 0 0019.25 2H8.75zm13.03 9.22a.75.75 0 10-1.06 1.06L22.44 14h-4.69a.75.75 0 000 1.5h4.69l-1.72 1.72a.75.75 0 000 1.06c.3.3.77.3 1.06 0l3-3c.3-.3.3-.77 0-1.06l-3-3zm-1.28 8.65c.48.17 1.02.17 1.5 0v3.38A2.75 2.75 0 0119.25 26H8.75A2.75 2.75 0 016 23.25v-3.38c.48.17 1.02.17 1.5 0v3.38c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-3.38zM5.56 15.5h4.69a.75.75 0 000-1.5H5.56l1.72-1.72a.75.75 0 10-1.06-1.06l-3 3c-.3.3-.3.77 0 1.06l3 3a.75.75 0 001.06-1.06L5.56 15.5z",
    fill: primaryFill
  }));
};

export const PhoneSpanOut28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpanOut28RegularIcon, 'PhoneSpanOut28Regular');

const PhoneSpeaker20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.99A1.5 1.5 0 019 16.5V15H8a.5.5 0 010-1h1.09c.2-.58.76-1 1.41-1h.38l1.56-1.56a1.5 1.5 0 011.56-.35V3.5c0-.83-.67-1.5-1.5-1.5h-7zm8.2 10.04c.18.08.3.26.3.46v6a.5.5 0 01-.85.35L11.29 17h-.79a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 01.54-.11zm3.95.16c.12.16.29.45.44.87.26.68.41 1.5.41 2.43 0 .94-.15 1.75-.4 2.43-.16.42-.33.7-.45.87a.5.5 0 01-.85-.52l.12-.19a5.9 5.9 0 00.58-2.6 5.9 5.9 0 00-.58-2.58l-.07-.11a.5.5 0 01.8-.6zm-1.43 1.77c-.1-.3-.2-.55-.27-.7a.5.5 0 10-.9.45 4.6 4.6 0 01.45 1.78 3.94 3.94 0 01-.37 1.6l-.08.18a.5.5 0 10.9.44 5.5 5.5 0 00.55-2.22c0-.5-.1-1.02-.28-1.53z",
    fill: primaryFill
  }));
};

export const PhoneSpeaker20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpeaker20FilledIcon, 'PhoneSpeaker20Filled');

const PhoneSpeaker20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 14a.5.5 0 000 1h1v-.5c0-.18.03-.34.09-.5H8zm-2 3h3.09c.2.58.75 1 1.4 1H6a2 2 0 01-2-2V4c0-1.1.9-2 2-2h6a2 2 0 012 2v7.09a1.5 1.5 0 00-1 0V4a1 1 0 00-1-1H6a1 1 0 00-1 1v12a1 1 0 001 1zm7.7-4.96c.18.08.3.26.3.46v6a.5.5 0 01-.85.35L11.29 17h-.79a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 01.54-.11zm3.95.16c.12.16.29.45.44.87.26.68.41 1.5.41 2.43 0 .94-.15 1.75-.4 2.43-.16.42-.33.7-.45.87a.5.5 0 01-.85-.52l.12-.19a5.9 5.9 0 00.58-2.6 5.9 5.9 0 00-.58-2.58l-.07-.11a.5.5 0 01.8-.6zm-1.43 1.77c-.1-.3-.2-.55-.27-.7a.5.5 0 10-.9.45 4.6 4.6 0 01.45 1.78 3.94 3.94 0 01-.37 1.6l-.08.18a.5.5 0 10.9.44 5.5 5.5 0 00.55-2.22c0-.5-.1-1.02-.28-1.53z",
    fill: primaryFill
  }));
};

export const PhoneSpeaker20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpeaker20RegularIcon, 'PhoneSpeaker20Regular');

const PhoneSpeaker24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.75 2C14.99 2 16 3 16 4.25v8.67c-.37.05-.73.23-1.03.54L13.53 15H12a1 1 0 00-1 1v2H8.75a.75.75 0 000 1.5h2.38c.18.3.5.5.87.5h1.53l1.44 1.54a2 2 0 00.06.06c-.36.25-.8.4-1.28.4h-7.5C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h7.5zm8.4 12.3a4.53 4.53 0 00-.92-1.13.75.75 0 10-.96 1.16c.13.1.35.35.59.74.4.67.64 1.48.64 2.43 0 .95-.24 1.76-.64 2.43-.24.39-.46.64-.59.74a.75.75 0 10.96 1.16c.25-.21.59-.58.91-1.13.54-.9.86-1.96.86-3.2 0-1.24-.32-2.3-.86-3.2zm-2.28 1.1c-.23-.36-.48-.6-.67-.75a.75.75 0 00-.9 1.2 2.24 2.24 0 01.7 1.65 2.24 2.24 0 01-.7 1.65l-.08.07a.75.75 0 00.98 1.13 3.73 3.73 0 001.3-2.85c0-.81-.23-1.52-.63-2.1zM17 14.75a.75.75 0 00-1.31-.5L14.16 16h-1.41a.75.75 0 00-.75.75v1.5c0 .41.34.75.75.75h1.41l1.53 1.74a.75.75 0 001.31-.49v-5.5z",
    fill: primaryFill
  }));
};

export const PhoneSpeaker24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpeaker24FilledIcon, 'PhoneSpeaker24Filled');

const PhoneSpeaker24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.75 2C14.99 2 16 3 16 4.25v8.67c-.37.05-.73.23-1.03.54l-.47.5V4.26a.75.75 0 00-.75-.75h-7.5a.75.75 0 00-.75.75v15.5c0 .41.34.75.75.75h7.5c.08 0 .15-.01.22-.03l1 1.07a2 2 0 00.06.06c-.36.25-.8.4-1.28.4h-7.5C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h7.5zm-5 15.5H11V19H8.75a.75.75 0 010-1.5zm13.4-3.2a4.53 4.53 0 00-.92-1.13.75.75 0 10-.96 1.16c.13.1.35.35.59.74.4.67.64 1.48.64 2.43 0 .95-.24 1.76-.64 2.43-.24.39-.46.64-.59.74a.75.75 0 10.96 1.16c.25-.21.59-.58.91-1.13.54-.9.86-1.96.86-3.2 0-1.24-.32-2.3-.86-3.2zm-2.28 1.1c-.23-.36-.48-.6-.67-.75a.75.75 0 00-.9 1.2 2.24 2.24 0 01.7 1.65 2.24 2.24 0 01-.7 1.65l-.08.07a.75.75 0 00.98 1.13 3.73 3.73 0 001.3-2.85c0-.81-.23-1.52-.63-2.1zM17 14.75a.75.75 0 00-1.31-.5L14.16 16h-1.41a.75.75 0 00-.75.75v1.5c0 .41.34.75.75.75h1.41l1.53 1.74a.75.75 0 001.31-.49v-5.5z",
    fill: primaryFill
  }));
};

export const PhoneSpeaker24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneSpeaker24RegularIcon, 'PhoneSpeaker24Regular');

const PhoneStatusBar20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V4zm2.5 0a.5.5 0 000 1h5a.5.5 0 000-1h-5z",
    fill: primaryFill
  }));
};

export const PhoneStatusBar20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneStatusBar20FilledIcon, 'PhoneStatusBar20Filled');

const PhoneStatusBar20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 4a.5.5 0 000 1h5a.5.5 0 000-1h-5zM7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zM6 4a1 1 0 011-1h6a1 1 0 011 1v12a1 1 0 01-1 1H7a1 1 0 01-1-1V4z",
    fill: primaryFill
  }));
};

export const PhoneStatusBar20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneStatusBar20RegularIcon, 'PhoneStatusBar20Regular');

const PhoneStatusBar24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zm-1 2.5h-5.5a.75.75 0 00-.1 1.5h5.6a.75.75 0 00.1-1.5h-.1z",
    fill: primaryFill
  }));
};

export const PhoneStatusBar24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneStatusBar24FilledIcon, 'PhoneStatusBar24Filled');

const PhoneStatusBar24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zm0 1.5h-7.5a.75.75 0 00-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 00-.75-.75zm-1 1a.75.75 0 010 1.5h-5.5a.75.75 0 010-1.5h5.5z",
    fill: primaryFill
  }));
};

export const PhoneStatusBar24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneStatusBar24RegularIcon, 'PhoneStatusBar24Regular');

const PhoneTablet20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 4.8C4 3.8 4.84 3 5.84 3h10.32c1 0 1.84.8 1.84 1.8v7.4c0 1-.84 1.8-1.84 1.8H10v-2h2.5a.5.5 0 000-1H10V8a2 2 0 00-2-2H4V4.8zM3.5 7C2.67 7 2 7.67 2 8.5v8c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-8C9 7.67 8.33 7 7.5 7h-4zm1 8.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1H5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const PhoneTablet20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneTablet20FilledIcon, 'PhoneTablet20Filled');

const PhoneTablet20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.84 4a.83.83 0 00-.84.8V6H4V4.8C4 3.8 4.84 3 5.84 3h10.32c1 0 1.84.8 1.84 1.8v7.4c0 1-.84 1.8-1.84 1.8H10v-1h6.16c.48 0 .84-.37.84-.8V4.8c0-.43-.36-.8-.84-.8H5.84zM10 12h2.5a.5.5 0 000-1H10v1zm-5 3a.5.5 0 000 1h1a.5.5 0 000-1H5zM2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 16.5v-8zM3.5 8a.5.5 0 00-.5.5v8c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-4z",
    fill: primaryFill
  }));
};

export const PhoneTablet20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneTablet20RegularIcon, 'PhoneTablet20Regular');

const PhoneTablet24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.26 7C9.22 7 10 7.78 10 8.75v9.5c0 .97-.79 1.75-1.75 1.75h-4.5C2.77 20 2 19.22 2 18.25v-9.5C2 7.78 2.78 7 3.75 7h4.5zm-2 9.5h-.6a.75.75 0 000 1.49h.7a.75.75 0 000-1.49h-.1zM19.74 4c1.2 0 2.17.93 2.25 2.1v8.65c0 1.2-.92 2.17-2.1 2.24l-.15.01H11V8.5A2.5 2.5 0 008.66 6H6.01A2.25 2.25 0 018.1 4h11.66zm-4.5 9.5h-2.5a.75.75 0 00-.1 1.5h2.6a.75.75 0 00.1-1.5h-.1z",
    fill: primaryFill
  }));
};

export const PhoneTablet24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneTablet24FilledIcon, 'PhoneTablet24Filled');

const PhoneTablet24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.26 7C9.22 7 10 7.78 10 8.75v9.5c0 .97-.79 1.75-1.75 1.75h-4.5C2.77 20 2 19.22 2 18.25v-9.5C2 7.78 2.78 7 3.75 7h4.5zm0 1.5h-4.5a.25.25 0 00-.26.25v9.5c0 .14.11.25.25.25h4.5c.14 0 .26-.11.26-.25v-9.5a.25.25 0 00-.25-.25zm-2 7.5a.75.75 0 01.1 1.5h-.6a.75.75 0 01-.1-1.5h.6zM19.74 4c1.2 0 2.17.93 2.25 2.1v8.65c0 1.2-.92 2.17-2.1 2.24l-.15.01H11v-1.5h8.75c.38 0 .7-.28.74-.65l.01-.1v-8.5c0-.38-.28-.7-.65-.74l-.1-.01H8.25c-.33 0-.6.2-.7.5H6A2.25 2.25 0 018.1 4h11.66zm-4.5 9a.75.75 0 010 1.5h-2.5a.75.75 0 110-1.5h2.5z",
    fill: primaryFill
  }));
};

export const PhoneTablet24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneTablet24RegularIcon, 'PhoneTablet24Regular');

const PhoneUpdate20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 16.5v-13zm5.5 3a.5.5 0 00-1 0v5.8l-1.15-1.15a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 00-.7-.7l-1.15 1.14V6.5z",
    fill: primaryFill
  }));
};

export const PhoneUpdate20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneUpdate20FilledIcon, 'PhoneUpdate20Filled');

const PhoneUpdate20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6c.28 0 .5.22.5.5v5.8l1.15-1.15a.5.5 0 01.7.7l-2 2A.5.5 0 0110 14a.5.5 0 01-.35-.15l-2-2a.5.5 0 01.7-.7l1.15 1.14V6.5c0-.28.22-.5.5-.5zM5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 16.5v-13zM6.5 3a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5h-7z",
    fill: primaryFill
  }));
};

export const PhoneUpdate20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneUpdate20RegularIcon, 'PhoneUpdate20Regular');

const PhoneUpdate24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zM12 7.03h-.1l-.1.03a.75.75 0 00-.54.6l-.01.12v6.71l-.96-.96-.09-.07a.75.75 0 00-1.04 1.05l.07.08 2.24 2.24.05.05.06.04.07.05.12.05.1.02.08.01h.1l.09-.01.06-.01.1-.04.06-.03.07-.04.06-.05.04-.04 2.24-2.24.07-.08c.2-.26.2-.62.01-.89l-.08-.09-.08-.07a.75.75 0 00-.88 0l-.1.07-.96.96V7.68a.75.75 0 00-.65-.64H12z",
    fill: primaryFill
  }));
};

export const PhoneUpdate24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneUpdate24FilledIcon, 'PhoneUpdate24Filled');

const PhoneUpdate24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zm0 1.5h-7.5a.75.75 0 00-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 00-.75-.75zM12 7.03c.38 0 .7.28.74.65l.01.1v6.71l.96-.96a.75.75 0 01.98-.07l.08.07c.27.27.3.68.07.98l-.07.08-2.24 2.24-.04.04-.06.05-.07.04-.06.03-.1.04-.06.01-.1.01h-.09l-.09-.01-.1-.02-.1-.05-.08-.05-.11-.09-2.24-2.24a.75.75 0 01.97-1.13l.09.07.96.96V7.8c0-.35.23-.64.55-.73l.1-.02h.1z",
    fill: primaryFill
  }));
};

export const PhoneUpdate24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneUpdate24RegularIcon, 'PhoneUpdate24Regular');

const PhoneUpdateCheckmark20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 16c0 1.1.9 2 2 2h3.26a5.48 5.48 0 01-.76-5.8v-5L8.35 8.36a.5.5 0 11-.7-.7l2-2c.2-.2.5-.2.7 0l2 2a.5.5 0 01-.7.7L10.5 7.21v3.52a5.48 5.48 0 014.5-1.7V4a2 2 0 00-2-2H7a2 2 0 00-2 2v12zm14-1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const PhoneUpdateCheckmark20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneUpdateCheckmark20FilledIcon, 'PhoneUpdateCheckmark20Filled');

const PhoneUpdateCheckmark20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 16a1 1 0 001 1h2.6c.18.36.4.7.66 1H7a2 2 0 01-2-2V4c0-1.1.9-2 2-2h6a2 2 0 012 2v5.02a5.57 5.57 0 00-1 0V4a1 1 0 00-1-1H7a1 1 0 00-1 1v12zm3.5-3.8c.25-.54.6-1.04 1-1.47V7.2l1.15 1.14a.5.5 0 00.7-.7l-2-2a.5.5 0 00-.7 0l-2 2a.5.5 0 10.7.7L9.5 7.21v5zm9.5 2.3a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const PhoneUpdateCheckmark20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneUpdateCheckmark20RegularIcon, 'PhoneUpdateCheckmark20Regular');

const PhoneUpdateCheckmark24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.25 22h4.56a6.48 6.48 0 01-1.56-6.3V9.5l-.96.97-.09.07A.75.75 0 019.16 9.5l.07-.08 2.24-2.24.05-.05.06-.04.07-.05.12-.05.1-.02.08-.01h.1l.09.01.06.01.1.04.06.03.07.04.06.05.04.04 2.24 2.24.07.08c.2.26.2.62.01.89l-.08.09-.08.07c-.26.2-.62.2-.88 0l-.1-.07-.96-.96v3.55A6.48 6.48 0 0118 11.02V4.25C18 3.01 17 2 15.75 2h-7.5C7.01 2 6 3 6 4.25v15.5C6 20.99 7 22 8.25 22zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-2.15-2.35a.5.5 0 00-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const PhoneUpdateCheckmark24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneUpdateCheckmark24FilledIcon, 'PhoneUpdateCheckmark24Filled');

const PhoneUpdateCheckmark24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.25 22h4.56a6.52 6.52 0 01-1.08-1.5H8.25a.75.75 0 01-.75-.75V4.25c0-.41.34-.75.75-.75h7.5c.41 0 .75.34.75.75v6.83a6.55 6.55 0 011.5-.06V4.25C18 3.01 17 2 15.75 2h-7.5C7.01 2 6 3 6 4.25v15.5C6 20.99 7 22 8.25 22zm3-6.3c.29-1 .8-1.9 1.5-2.64V9.51l.96.96c.27.27.68.29.98.07l.08-.07a.75.75 0 00.07-.98l-.07-.08-2.24-2.24-.04-.04-.06-.05-.07-.04-.06-.03-.1-.04-.06-.01-.1-.01h-.09l-.09.01-.1.02-.1.05-.08.05-.11.09L9.23 9.4a.75.75 0 00.97 1.13l.09-.07.96-.96v6.2zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-2.15-2.35a.5.5 0 00-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const PhoneUpdateCheckmark24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneUpdateCheckmark24RegularIcon, 'PhoneUpdateCheckmark24Regular');

const PhoneVerticalScroll20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 16.5v-13zm7.35 5.35a.5.5 0 000-.7l-2-2a.5.5 0 00-.7 0l-2 2a.5.5 0 10.7.7L10 7.21l1.65 1.64c.2.2.5.2.7 0zm-4.7 2.3a.5.5 0 000 .7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 00-.7-.7L10 12.79l-1.65-1.64a.5.5 0 00-.7 0z",
    fill: primaryFill
  }));
};

export const PhoneVerticalScroll20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneVerticalScroll20FilledIcon, 'PhoneVerticalScroll20Filled');

const PhoneVerticalScroll20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.65 11.15c.2-.2.5-.2.7 0L10 12.79l1.65-1.64a.5.5 0 01.7.7l-2 2a.5.5 0 01-.7 0l-2-2a.5.5 0 010-.7zm4-2.3a.5.5 0 00.7-.7l-2-2a.5.5 0 00-.7 0l-2 2a.5.5 0 10.7.7L10 7.21l1.65 1.64zM5 3.5C5 2.67 5.67 2 6.5 2h7c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 16.5v-13zM6.5 3a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5h-7z",
    fill: primaryFill
  }));
};

export const PhoneVerticalScroll20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneVerticalScroll20RegularIcon, 'PhoneVerticalScroll20Regular');

const PhoneVerticalScroll24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zm-2.04 11.47L12 15.22l-1.72-1.75a.75.75 0 00-1.07 1.06l2.25 2.3c.3.3.78.3 1.08 0l2.25-2.3a.75.75 0 10-1.08-1.05zm1.08-3.95l-2.25-2.3a.75.75 0 00-1-.07l-.08.07-2.25 2.3a.75.75 0 00.99 1.12l.08-.07L12 8.82l1.71 1.75a.75.75 0 001.15-.96l-.07-.09-2.25-2.3 2.25 2.3z",
    fill: primaryFill
  }));
};

export const PhoneVerticalScroll24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneVerticalScroll24FilledIcon, 'PhoneVerticalScroll24Filled');

const PhoneVerticalScroll24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zm0 1.5h-7.5a.75.75 0 00-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 00-.75-.75zm-.97 9.96c.26.27.3.68.08.98l-.07.09-2.25 2.3c-.27.26-.7.29-1 .07l-.08-.08-2.25-2.3a.75.75 0 01.99-1.12l.08.07L12 15.22l1.71-1.75c.3-.3.77-.3 1.06 0zm-2.24-6.23l2.25 2.3a.75.75 0 11-1.08 1.04L12 8.82l-1.72 1.75a.75.75 0 01-1.07-1.05l2.25-2.3c.3-.3.78-.3 1.08 0z",
    fill: primaryFill
  }));
};

export const PhoneVerticalScroll24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneVerticalScroll24RegularIcon, 'PhoneVerticalScroll24Regular');

const PhoneVibrate20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4c0-1.1.9-2 2-2h6a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V4zm3.5 10.5a.5.5 0 000 1h3a.5.5 0 000-1h-3zM2.92 7.22a.5.5 0 00-.84.56l.38.57c.29.42.32.97.1 1.43-.4.78-.34 1.7.14 2.43l.38.57a.5.5 0 10.84-.56l-.38-.57a1.43 1.43 0 01-.1-1.43c.4-.78.34-1.7-.14-2.43l-.38-.57zm13.3-.14a.5.5 0 01.7.14l.38.57c.48.73.54 1.65.15 2.43-.23.46-.2 1 .09 1.43l.38.57a.5.5 0 11-.84.56l-.38-.57a2.43 2.43 0 01-.15-2.43c.23-.46.2-1-.09-1.43l-.38-.57a.5.5 0 01.14-.7z",
    fill: primaryFill
  }));
};

export const PhoneVibrate20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneVibrate20FilledIcon, 'PhoneVibrate20Filled');

const PhoneVibrate20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 14.5a.5.5 0 000 1h3a.5.5 0 000-1h-3zM7 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zM6 4a1 1 0 011-1h6a1 1 0 011 1v12a1 1 0 01-1 1H7a1 1 0 01-1-1V4zM2.92 7.22a.5.5 0 00-.84.56l.38.57c.29.42.32.97.1 1.43-.4.78-.34 1.7.14 2.43l.38.57a.5.5 0 10.84-.56l-.38-.57a1.43 1.43 0 01-.1-1.43c.4-.78.34-1.7-.14-2.43l-.38-.57zm13.3-.14a.5.5 0 01.7.14l.38.57c.48.73.54 1.65.15 2.43-.23.46-.2 1 .09 1.43l.38.57a.5.5 0 11-.84.56l-.38-.57a2.43 2.43 0 01-.15-2.43c.23-.46.2-1-.09-1.43l-.38-.57a.5.5 0 01.14-.7z",
    fill: primaryFill
  }));
};

export const PhoneVibrate20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneVibrate20RegularIcon, 'PhoneVibrate20Regular');

const PhoneVibrate24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zm-2.5 16h-2.5a.75.75 0 00-.1 1.5h2.6a.75.75 0 100-1.5zm6.88-10.43a1 1 0 011.25.45l.05.1L22 9.6a3 3 0 01-.27 2.74l-.11.17-.16.2a1 1 0 00-.16.85l.04.12.58 1.46a1 1 0 01-1.8.85l-.06-.1-.58-1.47a3 3 0 01.27-2.74l.11-.17.16-.2a1 1 0 00.16-.85l-.04-.12-.58-1.46a1 1 0 01.56-1.3zm-17.5 0a1 1 0 011.25.45l.05.1.58 1.47a3 3 0 01-.27 2.74l-.11.17-.16.2a1 1 0 00-.16.85l.04.12.58 1.46a1 1 0 01-1.8.85l-.06-.1L2 14.4a3 3 0 01.27-2.74l.11-.17.16-.2a1 1 0 00.16-.85l-.04-.12-.58-1.46a1 1 0 01.56-1.3z",
    fill: primaryFill
  }));
};

export const PhoneVibrate24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneVibrate24FilledIcon, 'PhoneVibrate24Filled');

const PhoneVibrate24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5zm0 1.5h-7.5a.75.75 0 00-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 00-.75-.75zm-2.5 14a.75.75 0 010 1.5h-2.5a.75.75 0 010-1.5h2.5zm7.4-9.37l.05.1.58 1.45c.33.83.24 1.77-.25 2.51l-.1.16-.16.2c-.23.31-.3.7-.2 1.08l.04.14.59 1.45a.75.75 0 01-1.35.65l-.05-.1-.58-1.45a2.75 2.75 0 01.25-2.51l.1-.16.16-.2c.23-.31.3-.7.2-1.08l-.04-.14-.59-1.45a.75.75 0 011.3-.74l.05.09zm-16.5 0l.05.1.58 1.45c.33.83.24 1.77-.25 2.51l-.1.16-.16.2c-.23.31-.3.7-.2 1.08l.04.14.59 1.45a.75.75 0 01-1.35.65l-.05-.1-.58-1.45a2.75 2.75 0 01.25-2.51l.1-.16.16-.2c.23-.31.3-.7.2-1.08l-.04-.14-.59-1.45a.75.75 0 011.3-.74l.05.09z",
    fill: primaryFill
  }));
};

export const PhoneVibrate24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhoneVibrate24RegularIcon, 'PhoneVibrate24Regular');

const PhotoFilter20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.26 13.74a6 6 0 117.48-7.48 6 6 0 11-7.48 7.48zM3.5 8A4.5 4.5 0 006 12.03V12a6 6 0 016.03-6A4.5 4.5 0 003.5 8zm4.47 6A4.5 4.5 0 1014 7.97V8a6 6 0 01-6 6h-.03z",
    fill: primaryFill
  }));
};

export const PhotoFilter20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhotoFilter20FilledIcon, 'PhotoFilter20Filled');

const PhotoFilter20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 8a6 6 0 004.26 5.74 6 6 0 107.48-7.48A6 6 0 002 8zm6-5a5 5 0 014.6 3.03L12 6a6 6 0 00-5.97 6.6A5 5 0 018 3zm9 9a5 5 0 01-9.6 1.97L8 14a6 6 0 005.97-6.6A5 5 0 0117 12z",
    fill: primaryFill
  }));
};

export const PhotoFilter20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhotoFilter20RegularIcon, 'PhotoFilter20Regular');

const PhotoFilter24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 2a7.5 7.5 0 017.18 5.32 7.5 7.5 0 11-9.36 9.36A7.5 7.5 0 019.5 2zM17 9.6v-.1A7.5 7.5 0 019.6 17 5.5 5.5 0 1017 9.6zM9.5 4A5.5 5.5 0 007 14.4v.1A7.5 7.5 0 0114.4 7a5.5 5.5 0 00-4.9-3z",
    fill: primaryFill
  }));
};

export const PhotoFilter24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhotoFilter24FilledIcon, 'PhotoFilter24Filled');

const PhotoFilter24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 2a7.5 7.5 0 017.18 5.32 7.5 7.5 0 11-9.36 9.36A7.5 7.5 0 019.5 2zm7.49 7.04v.22l.01.24a7.5 7.5 0 01-7.96 7.49 6 6 0 107.95-7.95zM9.5 3.5a6 6 0 00-2.49 11.46v-.22L7 14.5a7.5 7.5 0 017.96-7.49A6 6 0 009.5 3.5z",
    fill: primaryFill
  }));
};

export const PhotoFilter24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PhotoFilter24RegularIcon, 'PhotoFilter24Regular');

const Pi20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.4 4.78c-.17.32-.18.76-.12 1.07a.75.75 0 11-1.47.3c-.1-.52-.11-1.34.26-2.06.41-.79 1.22-1.34 2.47-1.34H16.5a.75.75 0 010 1.5h-2.25v9.42c0 1.5.45 1.89.7 2 .32.15.8.08 1.21-.13a.75.75 0 01.68 1.34c-.6.3-1.6.58-2.53.15-1.01-.47-1.56-1.61-1.56-3.36V4.25H8.24a90.75 90.75 0 01-.6 6.32 44.66 44.66 0 01-.61 3.55 12.38 12.38 0 01-.86 2.72.75.75 0 11-1.34-.68c.26-.5.5-1.33.73-2.36.23-1.03.42-2.21.58-3.42.31-2.28.5-4.62.6-6.13h-2.2c-.74 0-1.01.28-1.14.53z",
    fill: primaryFill
  }));
};

export const Pi20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pi20FilledIcon, 'Pi20Filled');

const Pi20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.18 4.67a2 2 0 00-.14 1.23.5.5 0 11-.98.2 3 3 0 01.23-1.9C2.66 3.5 3.38 3 4.54 3H16.5a.5.5 0 110 1H14v9.67c0 1.54.47 2.05.84 2.23.42.2 1 .09 1.43-.14a.5.5 0 11.46.9c-.56.28-1.49.53-2.32.14-.88-.41-1.41-1.42-1.41-3.13V4H8v.03a90.2 90.2 0 01-.62 6.51 44.43 44.43 0 01-.6 3.52c-.23 1.06-.5 2-.83 2.66a.5.5 0 11-.9-.44c.27-.55.53-1.39.76-2.43.22-1.03.42-2.22.58-3.44.33-2.42.53-4.92.6-6.41H4.55c-.83 0-1.18.33-1.36.67z",
    fill: primaryFill
  }));
};

export const Pi20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pi20RegularIcon, 'Pi20Regular');

const Pi24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 7a3 3 0 013-3h15.25a1 1 0 110 2H17v10.7a1.5 1.5 0 002 1.42l.16-.06a1 1 0 11.68 1.88l-.16.06A3.5 3.5 0 0115 16.7V6H9.98a53.9 53.9 0 01-.36 4.21 45.04 45.04 0 01-1.93 9.12 1 1 0 11-1.88-.66 43.1 43.1 0 001.82-8.7A65.6 65.6 0 007.98 6H5a1 1 0 00-1 1v.5a1 1 0 01-2 0V7z",
    fill: primaryFill
  }));
};

export const Pi24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pi24FilledIcon, 'Pi24Filled');

const Pi24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.5 6.75A2.75 2.75 0 015.25 4h15a.75.75 0 010 1.5H17v11.45c0 1.21 1.2 2.06 2.34 1.65l.16-.06a.75.75 0 01.5 1.42l-.16.05a3.25 3.25 0 01-4.34-3.06V5.5h-6a56.9 56.9 0 01-.25 4.53c-.25 2.87-.76 6.5-1.8 9.47a.75.75 0 01-1.4-.5 40.07 40.07 0 001.7-9.1A67.9 67.9 0 008 5.5H5.25C4.56 5.5 4 6.06 4 6.75v.5a.75.75 0 01-1.5 0v-.5z",
    fill: primaryFill
  }));
};

export const Pi24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pi24RegularIcon, 'Pi24Regular');

const PictureInPicture16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 2A2.5 2.5 0 001 4.5v5A2.5 2.5 0 003.5 12H7v-2c0-1.1.9-2 2-2h5V4.5A2.5 2.5 0 0011.5 2h-8zM8 10a1 1 0 011-1h5a1 1 0 011 1v3a1 1 0 01-1 1H9a1 1 0 01-1-1v-3z",
    fill: primaryFill
  }));
};

export const PictureInPicture16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPicture16FilledIcon, 'PictureInPicture16Filled');

const PictureInPicture16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 4.5A2.5 2.5 0 013.5 2h8A2.5 2.5 0 0114 4.5V8h-1V4.5c0-.83-.67-1.5-1.5-1.5h-8C2.67 3 2 3.67 2 4.5v5c0 .83.67 1.5 1.5 1.5H7v1H3.5A2.5 2.5 0 011 9.5v-5zM9 9a1 1 0 00-1 1v3a1 1 0 001 1h5a1 1 0 001-1v-3a1 1 0 00-1-1H9z",
    fill: primaryFill
  }));
};

export const PictureInPicture16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPicture16RegularIcon, 'PictureInPicture16Regular');

const PictureInPicture20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 3A2.75 2.75 0 002 5.75v6.5A2.75 2.75 0 004.75 15H9v-2.5a2.5 2.5 0 012.5-2.5h6c.17 0 .34.02.5.05v-4.3A2.75 2.75 0 0015.25 3H4.75zM18 11.09a1.5 1.5 0 00-.5-.09h-6c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.65-.42-1.2-1-1.41z",
    fill: primaryFill
  }));
};

export const PictureInPicture20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPicture20FilledIcon, 'PictureInPicture20Filled');

const PictureInPicture20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.75A2.75 2.75 0 014.75 3h10.5A2.75 2.75 0 0118 5.75V10h-1V5.75C17 4.78 16.22 4 15.25 4H4.75C3.78 4 3 4.78 3 5.75v6.5c0 .97.78 1.75 1.75 1.75H9v1H4.75A2.75 2.75 0 012 12.25v-6.5zM11.5 11c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-6z",
    fill: primaryFill
  }));
};

export const PictureInPicture20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPicture20RegularIcon, 'PictureInPicture20Regular');

const PictureInPicture24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 3A3.25 3.25 0 002 6.25v9.5C2 17.55 3.46 19 5.25 19H11v-4a3 3 0 013-3h7a3 3 0 011 .17V6.25C22 4.45 20.54 3 18.75 3H5.25zM22 13.27a2 2 0 00-1-.27h-7a2 2 0 00-2 2v5c0 1.1.9 2 2 2h7a2 2 0 002-2v-5a2 2 0 00-1-1.73z",
    fill: primaryFill
  }));
};

export const PictureInPicture24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPicture24FilledIcon, 'PictureInPicture24Filled');

const PictureInPicture24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.25C2 4.45 3.46 3 5.25 3h13.5C20.55 3 22 4.46 22 6.25V12h-1.5V6.25c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75H11V19H5.25A3.25 3.25 0 012 15.75v-9.5zM14 13a2 2 0 00-2 2v5c0 1.1.9 2 2 2h7a2 2 0 002-2v-5a2 2 0 00-2-2h-7z",
    fill: primaryFill
  }));
};

export const PictureInPicture24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPicture24RegularIcon, 'PictureInPicture24Regular');

const PictureInPictureEnter16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 2A2.5 2.5 0 001 4.5v5A2.5 2.5 0 003.5 12H7v-2c0-1.1.9-2 2-2h5V4.5A2.5 2.5 0 0011.5 2h-8zm.15 2.65c.2-.2.5-.2.7 0L6 6.29V5.5a.5.5 0 011 0v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h.8L3.64 5.35a.5.5 0 010-.7zM8 10a1 1 0 011-1h5a1 1 0 011 1v3a1 1 0 01-1 1H9a1 1 0 01-1-1v-3z",
    fill: primaryFill
  }));
};

export const PictureInPictureEnter16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureEnter16FilledIcon, 'PictureInPictureEnter16Filled');

const PictureInPictureEnter16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 2A2.5 2.5 0 001 4.5v5A2.5 2.5 0 003.5 12H7v-1H3.5A1.5 1.5 0 012 9.5v-5C2 3.67 2.67 3 3.5 3h8c.83 0 1.5.67 1.5 1.5V8h1V4.5A2.5 2.5 0 0011.5 2h-8zm.85 2.65a.5.5 0 10-.7.7L5.29 7H4.5a.5.5 0 000 1h2a.5.5 0 00.35-.14A.5.5 0 007 7.5v-2a.5.5 0 00-1 0v.8L4.35 4.64zM9 9a1 1 0 00-1 1v3a1 1 0 001 1h5a1 1 0 001-1v-3a1 1 0 00-1-1H9z",
    fill: primaryFill
  }));
};

export const PictureInPictureEnter16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureEnter16RegularIcon, 'PictureInPictureEnter16Regular');

const PictureInPictureEnter20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 3A2.75 2.75 0 002 5.75v6.5A2.75 2.75 0 004.75 15H9v-2.5a2.5 2.5 0 012.5-2.5h6c.17 0 .34.02.5.05v-4.3A2.75 2.75 0 0015.25 3H4.75zm.6 2.65L8 8.29V6.5a.5.5 0 011 0v3a.5.5 0 01-.5.5h-3a.5.5 0 010-1h1.8L4.64 6.35a.5.5 0 11.7-.7zM18 11.09a1.5 1.5 0 00-.5-.09h-6c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.65-.42-1.2-1-1.41z",
    fill: primaryFill
  }));
};

export const PictureInPictureEnter20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureEnter20FilledIcon, 'PictureInPictureEnter20Filled');

const PictureInPictureEnter20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.75A2.75 2.75 0 014.75 3h10.5A2.75 2.75 0 0118 5.75V10h-1V5.75C17 4.78 16.22 4 15.25 4H4.75C3.78 4 3 4.78 3 5.75v6.5c0 .97.78 1.75 1.75 1.75H9v1H4.75A2.75 2.75 0 012 12.25v-6.5zM11.5 11c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-6zM4.65 5.65c.2-.2.5-.2.7 0L8 8.29V6.5a.5.5 0 011 0v3a.5.5 0 01-.5.5h-3a.5.5 0 010-1h1.8L4.64 6.35a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const PictureInPictureEnter20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureEnter20RegularIcon, 'PictureInPictureEnter20Regular');

const PictureInPictureEnter24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 3A3.25 3.25 0 002 6.25v9.5C2 17.55 3.46 19 5.25 19H11v-4a3 3 0 013-3h7a3 3 0 011 .17V6.25C22 4.45 20.54 3 18.75 3H5.25zm1.03 3.22L9.5 9.44V7.75a.75.75 0 011.5 0v3.5c0 .41-.34.75-.75.75h-3.5a.75.75 0 010-1.5h1.69L5.22 7.28a.75.75 0 011.06-1.06zM22 13.27a2 2 0 00-1-.27h-7a2 2 0 00-2 2v5c0 1.1.9 2 2 2h7a2 2 0 002-2v-5a2 2 0 00-1-1.73z",
    fill: primaryFill
  }));
};

export const PictureInPictureEnter24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureEnter24FilledIcon, 'PictureInPictureEnter24Filled');

const PictureInPictureEnter24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.25C2 4.45 3.46 3 5.25 3h13.5C20.55 3 22 4.46 22 6.25V12h-1.5V6.25c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75H11V19H5.25A3.25 3.25 0 012 15.75v-9.5zM14 13a2 2 0 00-2 2v5c0 1.1.9 2 2 2h7a2 2 0 002-2v-5a2 2 0 00-2-2h-7zM5.22 6.22c.3-.3.77-.3 1.06 0L9.5 9.44V7.75a.75.75 0 011.5 0v3.5c0 .41-.34.75-.75.75h-3.5a.75.75 0 010-1.5h1.69L5.22 7.28a.75.75 0 010-1.06z",
    fill: primaryFill
  }));
};

export const PictureInPictureEnter24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureEnter24RegularIcon, 'PictureInPictureEnter24Regular');

const PictureInPictureExit16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 7a1 1 0 001-1V3a1 1 0 00-1-1H2a1 1 0 00-1 1v3a1 1 0 001 1h5zm-5 4.5V8h5a2 2 0 002-2V4h3.5A2.5 2.5 0 0115 6.5v5a2.5 2.5 0 01-2.5 2.5h-8A2.5 2.5 0 012 11.5zm8.5-.5a.5.5 0 000 1h2a.5.5 0 00.5-.5v-2a.5.5 0 00-1 0v.8l-1.65-1.65a.5.5 0 00-.7.7L11.29 11h-.79z",
    fill: primaryFill
  }));
};

export const PictureInPictureExit16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureExit16FilledIcon, 'PictureInPictureExit16Filled');

const PictureInPictureExit16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 7a1 1 0 001-1V3a1 1 0 00-1-1H2a1 1 0 00-1 1v3a1 1 0 001 1h5zm2-2h3.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 013 11.5V8H2v3.5A2.5 2.5 0 004.5 14h8a2.5 2.5 0 002.5-2.5v-5A2.5 2.5 0 0012.5 4H9v1zm2 4.3v-.8a.5.5 0 011 0v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h.8L8.64 8.35a.5.5 0 11.7-.7L11 9.29z",
    fill: primaryFill
  }));
};

export const PictureInPictureExit16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureExit16RegularIcon, 'PictureInPictureExit16Regular');

const PictureInPictureExit20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 9c.83 0 1.5-.67 1.5-1.5v-4C10 2.67 9.33 2 8.5 2h-6C1.67 2 1 2.67 1 3.5v4A1.5 1.5 0 002.5 9h6zm0 1h-6c-.17 0-.34-.02-.5-.05v4.3A2.75 2.75 0 004.75 17h10.5A2.75 2.75 0 0018 14.25v-6.5A2.75 2.75 0 0015.25 5H11v2.5A2.5 2.5 0 018.5 10zm3.85.65L15 13.29V11.5a.5.5 0 011 0v3a.5.5 0 01-.5.5h-3a.5.5 0 010-1h1.8l-2.65-2.65a.5.5 0 01.7-.7z",
    fill: primaryFill
  }));
};

export const PictureInPictureExit20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureExit20FilledIcon, 'PictureInPictureExit20Filled');

const PictureInPictureExit20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 9c.83 0 1.5-.67 1.5-1.5v-4C10 2.67 9.33 2 8.5 2h-6C1.67 2 1 2.67 1 3.5v4c0 .65.42 1.2 1 1.41l.02.01c.15.05.31.08.48.08h6zm6.75-3H11V5h4.25A2.75 2.75 0 0118 7.75v6.5A2.75 2.75 0 0115.25 17H4.75A2.75 2.75 0 012 14.25v-4.3c.16.03.33.05.5.05H3v4.25c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C17 6.78 16.22 6 15.25 6zM14 12.3l-2.65-2.65a.5.5 0 00-.7.7L13.29 13H11.5a.5.5 0 000 1h3a.5.5 0 00.5-.5v-3a.5.5 0 00-1 0v1.8z",
    fill: primaryFill
  }));
};

export const PictureInPictureExit20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureExit20RegularIcon, 'PictureInPictureExit20Regular');

const PictureInPictureExit24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 11a2 2 0 002-2V4a2 2 0 00-2-2H3a2 2 0 00-2 2v5a2 2 0 002 2h7zm0 1H3a3 3 0 01-1-.17v5.92C2 19.55 3.46 21 5.25 21h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 6.45 20.54 5 18.75 5H13v4a3 3 0 01-3 3zm4.25 4h1.69l-2.72-2.72a.75.75 0 111.06-1.06L17 14.94v-1.69a.75.75 0 011.5 0v3.5c0 .41-.34.75-.75.75h-3.5a.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const PictureInPictureExit24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureExit24FilledIcon, 'PictureInPictureExit24Filled');

const PictureInPictureExit24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 11a2 2 0 002-2V4a2 2 0 00-2-2H3a2 2 0 00-2 2v5a2 2 0 002 2h7zm8.75-4.5H13V5h5.75C20.55 5 22 6.46 22 8.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 012 17.75v-5.92A3 3 0 003 12h.5v5.75c0 .97.78 1.75 1.75 1.75h13.5c.97 0 1.75-.78 1.75-1.75v-9.5c0-.97-.78-1.75-1.75-1.75zM15.94 16h-1.69a.75.75 0 000 1.5h3.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 00-1.5 0v1.69l-2.72-2.72a.75.75 0 10-1.06 1.06L15.94 16z",
    fill: primaryFill
  }));
};

export const PictureInPictureExit24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PictureInPictureExit24RegularIcon, 'PictureInPictureExit24Regular');

const Pill16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 3.05A3.5 3.5 0 1112.95 8L8 12.95A3.5 3.5 0 013.05 8L8 3.05zm2.12 6.36l2.12-2.12a2.5 2.5 0 00-3.53-3.53L6.59 5.88l3.53 3.53zm-2.27 1.44a.5.5 0 10-.7-.7l-1.5 1.5a.5.5 0 10.7.7l1.5-1.5z",
    fill: primaryFill
  }));
};

export const Pill16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pill16FilledIcon, 'Pill16Filled');

const Pill16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.35 10.35a.5.5 0 10-.7-.7l-1.5 1.5a.5.5 0 10.7.7l1.5-1.5zm5.6-7.3a3.5 3.5 0 00-4.95 0L3.05 8A3.5 3.5 0 108 12.95L12.95 8a3.5 3.5 0 000-4.95zM5.88 6.6l3.53 3.53-2.12 2.12a2.5 2.5 0 01-3.53-3.53l2.12-2.12zm6.36.7l-2.12 2.12L6.6 5.88 8.7 3.76a2.5 2.5 0 113.53 3.53z",
    fill: primaryFill
  }));
};

export const Pill16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pill16RegularIcon, 'Pill16Regular');

const Pill20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.15 3.15a4.04 4.04 0 115.7 5.7l-8 8a4.04 4.04 0 11-5.7-5.7l8-8zm5 .7a3.04 3.04 0 00-4.3 0L8.21 7.5l4.29 4.3 3.65-3.65a3.04 3.04 0 000-4.3zm-7.3 10.3a.5.5 0 00-.7 0l-1.5 1.5a.91.91 0 01-1.3 0 .5.5 0 00-.85.35c0 .14.06.27.15.36.75.74 1.96.74 2.7 0l1.5-1.5a.5.5 0 000-.71z",
    fill: primaryFill
  }));
};

export const Pill20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pill20FilledIcon, 'Pill20Filled');

const Pill20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.85 13.15c.2.2.2.5 0 .7l-1.5 1.5c-.74.75-1.95.75-2.7 0A.5.5 0 015 14.5a.5.5 0 01.35.15c.36.35.94.35 1.3 0l1.5-1.5c.2-.2.5-.2.7 0zm2.3-10a4.04 4.04 0 115.7 5.7l-8 8a4.04 4.04 0 11-5.7-5.7l8-8zm5 .7a3.04 3.04 0 00-4.3 0L8.21 7.5l4.29 4.3 3.65-3.65a3.04 3.04 0 000-4.3zm-4.36 8.65L7.5 8.2l-3.65 3.65a3.04 3.04 0 004.3 4.3l3.64-3.65z",
    fill: primaryFill
  }));
};

export const Pill20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pill20RegularIcon, 'Pill20Regular');

const Pill24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.3 3.53a5.07 5.07 0 017.17 7.17l-9.77 9.77a5.07 5.07 0 01-7.17-7.17l9.77-9.77zm6.11 1.06a3.57 3.57 0 00-5.05 0l-4.35 4.35L15.06 14l4.35-4.35a3.57 3.57 0 000-5.05zm-8.6 13.69a.75.75 0 00-1.06-1.06L8.3 18.66a1.5 1.5 0 01-2.1.02l-.02-.02a.75.75 0 10-1.04 1.08l.02.02a3 3 0 004.2-.04l1.44-1.44z",
    fill: primaryFill
  }));
};

export const Pill24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pill24FilledIcon, 'Pill24Filled');

const Pill24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.53 15.47c.3.3.3.77 0 1.06l-2 2c-.84.84-2.2.85-3.05 0A.75.75 0 016 17.26c.2 0 .4.08.53.22.26.26.68.26.94 0l2-2c.3-.3.77-.3 1.06 0zM13.3 3.53a5.07 5.07 0 017.17 7.17l-9.77 9.77a5.07 5.07 0 01-7.17-7.17l9.77-9.77zm6.11 1.06a3.57 3.57 0 00-5.05 0l-4.35 4.35L15.06 14l4.35-4.35a3.57 3.57 0 000-5.05zM14 15.06L8.95 10 4.6 14.36a3.57 3.57 0 105.05 5.05l4.35-4.35z",
    fill: primaryFill
  }));
};

export const Pill24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pill24RegularIcon, 'Pill24Regular');

const Pill28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.78 3.74a6 6 0 018.48 8.5L12.22 24.26a6 6 0 01-8.48-8.5L15.78 3.74zm1.93 12.91l5.49-5.48a4.5 4.5 0 00-6.36-6.36l-5.5 5.48 6.37 6.36zm-5.93 4.63a.75.75 0 00-1.06-1.06L8.74 22.2c-.4.4-1.07.4-1.48 0l-.48-.48a.75.75 0 00-1.06 1.06l.48.48c1 1 2.6 1 3.6 0l1.98-1.98z",
    fill: primaryFill
  }));
};

export const Pill28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pill28FilledIcon, 'Pill28Filled');

const Pill28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.78 20.28a.75.75 0 00-1.06-1.06L8.74 21.2c-.4.4-1.07.4-1.48 0l-.48-.48a.75.75 0 00-1.06 1.06l.48.48c1 1 2.6 1 3.6 0l1.98-1.98zM24.25 3.75a6 6 0 00-8.47 0L3.74 15.75a6 6 0 008.48 8.5l12.04-12.02a6 6 0 000-8.49zm-13.96 7.6l6.36 6.36-5.49 5.48a4.5 4.5 0 01-6.36-6.36l5.49-5.48zm12.9-.18l-5.48 5.48-6.36-6.36 5.49-5.48a4.5 4.5 0 016.36 6.36z",
    fill: primaryFill
  }));
};

export const Pill28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pill28RegularIcon, 'Pill28Regular');

const Pin12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.05 1.44a1.5 1.5 0 00-2.38.34L4.14 4.61l-2.33.93a.5.5 0 00-.16.81L3.29 8l-2.14 2.15L1 11l.85-.15L4 8.71l1.65 1.64a.5.5 0 00.81-.16l.94-2.34 2.82-1.52a1.5 1.5 0 00.34-2.38l-2.5-2.51z",
    fill: primaryFill
  }));
};

export const Pin12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pin12FilledIcon, 'Pin12Filled');

const Pin12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.05 1.44a1.5 1.5 0 00-2.38.34L4.14 4.61l-2.33.93a.5.5 0 00-.16.81L3.29 8l-2.14 2.15L1 11l.85-.15L4 8.71l1.65 1.64a.5.5 0 00.81-.16l.94-2.34 2.82-1.52a1.5 1.5 0 00.34-2.38l-2.5-2.51zm-1.5.82a.5.5 0 01.8-.12l2.5 2.52a.5.5 0 01-.1.79L6.75 7.06a.5.5 0 00-.22.25l-.72 1.8-2.93-2.93 1.8-.71a.5.5 0 00.25-.23l1.61-2.98z",
    fill: primaryFill
  }));
};

export const Pin12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pin12RegularIcon, 'Pin12Regular');

const Pin16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.06 2.45a1.5 1.5 0 00-2.39.35L5.65 6.59l-2.8.94a.5.5 0 00-.2.82l2.14 2.15-2.64 2.65L2 14l.85-.15 2.65-2.64 2.15 2.14a.5.5 0 00.82-.2l.94-2.8 3.78-2.03a1.5 1.5 0 00.35-2.38l-3.48-3.5z",
    fill: primaryFill
  }));
};

export const Pin16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pin16FilledIcon, 'Pin16Filled');

const Pin16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.06 2.45a1.5 1.5 0 00-2.39.35L5.65 6.59l-2.8.94a.5.5 0 00-.2.82l2.14 2.15-2.64 2.65L2 14l.85-.15 2.65-2.64 2.15 2.14a.5.5 0 00.82-.2l.94-2.8 3.78-2.03a1.5 1.5 0 00.35-2.38l-3.48-3.5zm-1.5.82a.5.5 0 01.8-.12l3.48 3.5a.5.5 0 01-.12.8l-3.96 2.1a.5.5 0 00-.23.3l-.75 2.22-3.85-3.85 2.23-.75a.5.5 0 00.28-.23l2.12-3.97z",
    fill: primaryFill
  }));
};

export const Pin16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pin16RegularIcon, 'Pin16Regular');

const Pin20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.33 2.62a2 2 0 00-3.2.52L8.38 6.6a1.5 1.5 0 01-.78.72L4 8.75a1 1 0 00-.33 1.64l2.61 2.6L3 16.3v.7h.7L7 13.72l2.61 2.6a1 1 0 001.64-.33l1.43-3.59c.14-.34.4-.62.72-.78l3.46-1.73a2 2 0 00.52-3.2l-4.05-4.06z",
    fill: primaryFill
  }));
};

export const Pin20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pin20FilledIcon, 'Pin20Filled');

const Pin20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.12 3.14a2 2 0 013.2-.52l4.06 4.05a2 2 0 01-.52 3.2l-3.46 1.74a1.5 1.5 0 00-.72.78L11.25 16a1 1 0 01-1.64.33L7 13.7 3.7 17H3v-.7L6.3 13l-2.62-2.61a1 1 0 01.34-1.64L7.6 7.32c.34-.14.62-.4.78-.72l1.73-3.46zm2.5.18a1 1 0 00-1.6.26L9.29 7.04a2.5 2.5 0 01-1.31 1.2L4.39 9.69l5.93 5.93 1.43-3.59a2.5 2.5 0 011.2-1.3l3.46-1.74a1 1 0 00.26-1.6l-4.05-4.06z",
    fill: primaryFill
  }));
};

export const Pin20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pin20RegularIcon, 'Pin20Regular');

const Pin24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.07 7.76l-4.83-4.83a2.75 2.75 0 00-4.4.72L9.4 8.52a.75.75 0 01-.42.37L4.8 10.33a1.25 1.25 0 00-.48 2.07l3.1 3.1L3 19.94V21h1.06l4.44-4.44 3.1 3.1c.66.66 1.77.4 2.07-.47l1.44-4.17c.06-.18.2-.33.37-.42l4.87-2.44a2.75 2.75 0 00.72-4.4z",
    fill: primaryFill
  }));
};

export const Pin24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pin24FilledIcon, 'Pin24Filled');

const Pin24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.24 2.93l4.83 4.83a2.75 2.75 0 01-.72 4.4l-4.87 2.44a.75.75 0 00-.37.42l-1.44 4.17a1.25 1.25 0 01-2.07.48l-3.1-3.1L4.06 21H3v-1.06l4.44-4.44-3.1-3.1c-.66-.66-.4-1.77.47-2.07l4.17-1.44c.18-.06.34-.2.42-.37l2.44-4.87a2.75 2.75 0 014.4-.72zm3.77 5.89l-4.83-4.83c-.6-.6-1.62-.44-2 .33l-2.44 4.87c-.26.52-.72.93-1.27 1.12l-3.8 1.3 6.71 6.71 1.31-3.79c.2-.55.6-1.01 1.12-1.27l4.87-2.44c.77-.38.93-1.4.33-2z",
    fill: primaryFill
  }));
};

export const Pin24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pin24RegularIcon, 'Pin24Regular');

const Pin28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.04 3.48a3.25 3.25 0 00-5.24.9l-2.55 5.4c-.2.4-.53.72-.95.88l-4.13 1.59a1.75 1.75 0 00-.61 2.87l3.13 3.13L3 23.94V25h1.06l5.69-5.69 3.13 3.13c.9.9 2.42.57 2.87-.6l1.6-4.14c.15-.42.47-.76.88-.95l5.38-2.55a3.25 3.25 0 00.91-5.24l-5.48-5.48z",
    fill: primaryFill
  }));
};

export const Pin28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pin28FilledIcon, 'Pin28Filled');

const Pin28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.8 4.38a3.25 3.25 0 015.24-.9l5.48 5.48a3.25 3.25 0 01-.9 5.24l-5.4 2.55c-.4.2-.72.53-.88.95l-1.59 4.13a1.75 1.75 0 01-2.87.61l-3.13-3.13L4.06 25H3v-1.06l5.69-5.69-3.13-3.13c-.9-.9-.58-2.42.6-2.87l4.14-1.6c.42-.15.76-.47.95-.88l2.55-5.39zm4.18.16c-.86-.86-2.3-.6-2.82.49l-2.55 5.39c-.36.75-1 1.34-1.77 1.64L6.7 13.65a.25.25 0 00-.1.4l7.33 7.33c.13.13.35.08.41-.09l1.6-4.13c.3-.77.88-1.4 1.63-1.77l5.4-2.55a1.75 1.75 0 00.48-2.82l-5.48-5.48z",
    fill: primaryFill
  }));
};

export const Pin28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pin28RegularIcon, 'Pin28Regular');

const Pin32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.74 4.28a4 4 0 016.41-1.04l6.61 6.61a4 4 0 01-1.04 6.4l-6.35 3.18a1.5 1.5 0 00-.75.87l-1.66 4.98a2 2 0 01-3.31.78l-4.15-4.15-6.09 6.1H4v-1.42l6.09-6.09-4.15-4.15a2 2 0 01.78-3.31l4.98-1.66c.38-.13.7-.4.87-.75l3.17-6.35z",
    fill: primaryFill
  }));
};

export const Pin32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pin32FilledIcon, 'Pin32Filled');

const Pin32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22.15 3.24a4 4 0 00-6.4 1.04l-3.18 6.35a1.5 1.5 0 01-.87.75l-4.98 1.66a2 2 0 00-.78 3.31l4.15 4.15L4 26.6V28h1.41l6.09-6.09 4.15 4.15a2 2 0 003.31-.78l1.66-4.98c.13-.38.4-.69.75-.87l6.35-3.17a4 4 0 001.04-6.41l-6.61-6.61zm-4.62 1.93a2 2 0 013.2-.52l6.62 6.61a2 2 0 01-.52 3.2l-6.35 3.18a3.5 3.5 0 00-1.76 2.03l-1.66 4.98-9.7-9.71 4.97-1.66a3.5 3.5 0 002.03-1.76l3.17-6.35z",
    fill: primaryFill
  }));
};

export const Pin32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pin32RegularIcon, 'Pin32Regular');

const Pin48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M31.82 5.55l10.63 10.63a4.75 4.75 0 01-1.23 7.61l-10.55 5.27c-.3.15-.51.4-.62.71l-2.69 7.77a2.75 2.75 0 01-4.54 1.05L17 32.77 7.77 42H6v-1.77L15.23 31l-5.82-5.82a2.75 2.75 0 011.05-4.54l7.77-2.69c.3-.1.56-.33.7-.62l5.28-10.55a4.75 4.75 0 017.6-1.23z",
    fill: primaryFill
  }));
};

export const Pin48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pin48FilledIcon, 'Pin48Filled');

const Pin48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M42.45 16.18L31.82 5.55a4.75 4.75 0 00-7.61 1.23l-5.27 10.55c-.15.3-.4.52-.71.62l-7.77 2.69a2.75 2.75 0 00-1.05 4.54L15.23 31 6 40.23V42h1.77L17 32.77l5.82 5.82a2.75 2.75 0 004.54-1.05l2.69-7.77c.1-.3.33-.56.62-.7l10.55-5.28a4.75 4.75 0 001.23-7.6zm-12.4-8.86l10.63 10.63a2.25 2.25 0 01-.58 3.6l-10.55 5.28a3.75 3.75 0 00-1.86 2.13L25 36.73a.25.25 0 01-.41.1L11.18 23.4a.25.25 0 01.1-.41l7.76-2.69c.93-.32 1.7-.99 2.13-1.86L26.45 7.9a2.25 2.25 0 013.6-.58z",
    fill: primaryFill
  }));
};

export const Pin48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pin48RegularIcon, 'Pin48Regular');

const PinOff16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.56 10.27l4.59 4.58a.5.5 0 00.7-.7l-13-13a.5.5 0 10-.7.7l4.58 4.59-.08.15-2.8.94a.5.5 0 00-.2.82l2.14 2.15-2.64 2.65L2 14l.85-.15 2.65-2.64 2.15 2.14a.5.5 0 00.82-.2l.94-2.8.15-.08zm3.63-1.95l-1.79.96L6.72 4.6l.95-1.8a1.5 1.5 0 012.39-.34l3.48 3.5c.71.7.54 1.9-.35 2.37z",
    fill: primaryFill
  }));
};

export const PinOff16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinOff16FilledIcon, 'PinOff16Filled');

const PinOff16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.56 10.27l4.59 4.58a.5.5 0 00.7-.7l-13-13a.5.5 0 10-.7.7l4.58 4.59-.08.15-2.8.94a.5.5 0 00-.2.82l2.14 2.15-2.64 2.65L2 14l.85-.15 2.65-2.64 2.15 2.14a.5.5 0 00.82-.2l.94-2.8.15-.08zm-.74-.74l-.06.03a.5.5 0 00-.23.28l-.75 2.23-3.85-3.85 2.23-.75a.5.5 0 00.28-.23l.03-.06 2.35 2.35zm3.9-2.09l-2.06 1.1.74.74 1.79-.96a1.5 1.5 0 00.35-2.38l-3.48-3.5a1.5 1.5 0 00-2.39.36l-.95 1.8.73.73 1.1-2.06a.5.5 0 01.8-.12l3.49 3.5a.5.5 0 01-.12.8z",
    fill: primaryFill
  }));
};

export const PinOff16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinOff16RegularIcon, 'PinOff16Regular');

const PinOff20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L6.9 7.6 4.02 8.75a1 1 0 00-.34 1.64L6.3 13 3 16.3v.7h.7L7 13.7l2.61 2.62a1 1 0 001.64-.34l1.15-2.88 4.75 4.75a.5.5 0 00.7-.7l-15-15zm14.01 7.73l-3.24 1.62L8.5 6.38l1.62-3.24a2 2 0 013.2-.52l4.06 4.05a2 2 0 01-.52 3.2z",
    fill: primaryFill
  }));
};

export const PinOff20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinOff20FilledIcon, 'PinOff20Filled');

const PinOff20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L6.9 7.6 4.02 8.75a1 1 0 00-.34 1.64L6.3 13 3 16.3v.7h.7L7 13.7l2.61 2.62a1 1 0 001.64-.34l1.15-2.88 4.75 4.75a.5.5 0 00.7-.7l-15-15zm8.78 10.18l-1.31 3.28-5.93-5.93 3.28-1.3 3.96 3.95zm1.33-1.62l-.08.04.74.75 3.24-1.62a2 2 0 00.52-3.2l-4.05-4.06a2 2 0 00-3.2.52L8.5 6.38l.75.74.04-.08 1.73-3.45a1 1 0 011.6-.26l4.05 4.05a1 1 0 01-.26 1.6l-3.45 1.73z",
    fill: primaryFill
  }));
};

export const PinOff20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinOff20RegularIcon, 'PinOff20Regular');

const PinOff24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 00-1.06 1.06l5.9 5.9-3.3 1.15a1.25 1.25 0 00-.49 2.07l3.1 3.1L3 19.94V21h1.06l4.44-4.44 3.1 3.1c.66.66 1.77.4 2.07-.47l1.14-3.31 5.91 5.9a.75.75 0 101.06-1.06L3.28 2.22zm17.07 9.94l-3.34 1.67L10.17 7l1.67-3.34a2.75 2.75 0 014.4-.72l4.83 4.83a2.75 2.75 0 01-.72 4.4z",
    fill: primaryFill
  }));
};

export const PinOff24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinOff24FilledIcon, 'PinOff24Filled');

const PinOff24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 00-1.06 1.06l5.9 5.9-3.3 1.15a1.25 1.25 0 00-.49 2.07l3.1 3.1L3 19.94V21h1.06l4.44-4.44 3.1 3.1c.66.66 1.77.4 2.07-.47l1.14-3.31 5.91 5.9a.75.75 0 101.06-1.06L3.28 2.22zM13.64 14.7l-1.26 3.62-6.7-6.7 3.62-1.26 4.34 4.34zm6.04-3.88l-3.78 1.9L17 13.82l3.34-1.67a2.75 2.75 0 00.72-4.4l-4.83-4.83a2.75 2.75 0 00-4.4.72l-1.67 3.34 1.12 1.11 1.89-3.78c.38-.77 1.4-.93 2-.33l4.83 4.83c.6.6.44 1.62-.33 2z",
    fill: primaryFill
  }));
};

export const PinOff24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinOff24RegularIcon, 'PinOff24Regular');

const PinOff28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 10-1.06 1.06l7.57 7.57-3.62 1.4a1.75 1.75 0 00-.61 2.87l3.13 3.13L3 23.94V25h1.06l5.69-5.69 3.13 3.13c.9.9 2.42.57 2.87-.6l1.4-3.63 7.57 7.57a.75.75 0 001.06-1.06L3.28 2.22zm8.52 6.4l7.58 7.58 4.23-2a3.25 3.25 0 00.91-5.24l-5.48-5.48a3.25 3.25 0 00-5.24.9l-2 4.24z",
    fill: primaryFill
  }));
};

export const PinOff28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinOff28FilledIcon, 'PinOff28Filled');

const PinOff28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 10-1.06 1.06l7.57 7.57-3.62 1.4a1.75 1.75 0 00-.61 2.87l3.13 3.13L3 23.94V25h1.06l5.69-5.69 3.13 3.13c.9.9 2.42.57 2.87-.6l1.4-3.63 7.57 7.57a.75.75 0 001.06-1.06L3.28 2.22zm12.7 14.83a3.4 3.4 0 00-.04.11l-1.59 4.13a.25.25 0 01-.4.1l-7.33-7.33a.25.25 0 01.09-.41l4.13-1.6c.03 0 .07-.02.11-.04L16 17.05zM11.8 8.62l1.13 1.12 2.23-4.71a1.75 1.75 0 012.82-.5l5.48 5.5c.86.85.6 2.3-.49 2.81l-4.71 2.23 1.12 1.13 4.23-2a3.25 3.25 0 00.91-5.24l-5.48-5.48a3.25 3.25 0 00-5.24.9l-2 4.24z",
    fill: primaryFill
  }));
};

export const PinOff28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinOff28RegularIcon, 'PinOff28Regular');

const PinOff32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.19 21.6l8.1 8.1a1 1 0 001.42-1.4l-26-26a1 1 0 00-1.42 1.4l8.1 8.11-3.67 1.23a2 2 0 00-.78 3.31l4.15 4.15L4 26.59V28h1.41l6.09-6.09 4.15 4.15a2 2 0 003.31-.78l1.23-3.68zm7.53-5.34l-5.28 2.64-9.34-9.33 2.64-5.3a4 4 0 016.41-1.03l6.61 6.61a4 4 0 01-1.04 6.4z",
    fill: primaryFill
  }));
};

export const PinOff32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinOff32FilledIcon, 'PinOff32Filled');

const PinOff32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.19 21.6l-1.23 3.68a2 2 0 01-3.31.78l-4.15-4.15L5.41 28H4v-1.41l6.09-6.09-4.15-4.15a2 2 0 01.78-3.31l3.68-1.23-8.1-8.1a1 1 0 011.4-1.42l26 26a1 1 0 01-1.4 1.42l-8.11-8.1zm-1.58-1.58l-6.63-6.63-4.63 1.55 9.71 9.7 1.55-4.62zm8.22-5.55l-5.89 2.94 1.5 1.5 5.28-2.65a4 4 0 001.04-6.41l-6.6-6.61a4 4 0 00-6.42 1.04L13.1 9.57l1.5 1.49 2.93-5.89a2 2 0 013.2-.52l6.62 6.61a2 2 0 01-.52 3.2z",
    fill: primaryFill
  }));
};

export const PinOff32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinOff32RegularIcon, 'PinOff32Regular');

const PinOff48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M29.52 31.3l12.1 12.08a1.25 1.25 0 101.76-1.76l-37-37a1.25 1.25 0 10-1.76 1.76l12.09 12.1-6.25 2.16a2.75 2.75 0 00-1.05 4.54L15.23 31 6 40.23V42h1.77L17 32.77l5.82 5.82a2.75 2.75 0 004.54-1.05l2.16-6.25zm11.7-7.51l-8.09 4.04-12.96-12.96 4.04-8.09a4.75 4.75 0 017.6-1.23l10.64 10.63a4.75 4.75 0 01-1.23 7.61z",
    fill: primaryFill
  }));
};

export const PinOff48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinOff48FilledIcon, 'PinOff48Filled');

const PinOff48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.7 18.48L4.63 6.38a1.25 1.25 0 111.76-1.76l37 37a1.25 1.25 0 01-1.76 1.76L29.52 31.3l-2.16 6.25a2.75 2.75 0 01-4.54 1.05L17 32.77 7.77 42H6v-1.77L15.23 31l-5.82-5.82a2.75 2.75 0 011.05-4.54l6.25-2.16zm10.86 10.85l-8.89-8.89-7.4 2.56a.25.25 0 00-.1.41L24.6 36.82c.13.13.35.08.41-.1l2.56-7.4zm12.54-7.78l-8.83 4.42 1.86 1.86 8.09-4.04a4.75 4.75 0 001.23-7.6L31.82 5.54a4.75 4.75 0 00-7.61 1.23l-4.04 8.09 1.86 1.86 4.42-8.83a2.25 2.25 0 013.6-.58l10.63 10.63a2.25 2.25 0 01-.58 3.6z",
    fill: primaryFill
  }));
};

export const PinOff48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PinOff48RegularIcon, 'PinOff48Regular');

const Pipeline20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.5a1.5 1.5 0 013 0v9a1.5 1.5 0 01-3 0v-9zm13 0v9a1.5 1.5 0 003 0v-9a1.5 1.5 0 00-3 0zM14 14V6H6v8h8z",
    fill: primaryFill
  }));
};

export const Pipeline20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pipeline20FilledIcon, 'Pipeline20Filled');

const Pipeline20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.5a1.5 1.5 0 113 0V6h10v-.5a1.5 1.5 0 013 0v9a1.5 1.5 0 01-3 0V14H5v.5a1.5 1.5 0 01-3 0v-9zm2 0a.5.5 0 00-1 0v9a.5.5 0 001 0v-9zM15 7H5v6h10V7zm2-1.5a.5.5 0 00-1 0v9a.5.5 0 001 0v-9z",
    fill: primaryFill
  }));
};

export const Pipeline20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pipeline20RegularIcon, 'Pipeline20Regular');

const Pipeline24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6a2 2 0 114 0v11a2 2 0 11-4 0V6zm16 0a2 2 0 114 0v11a2 2 0 11-4 0V6zm-1.5 0h-9v11h9V6z",
    fill: primaryFill
  }));
};

export const Pipeline24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pipeline24FilledIcon, 'Pipeline24Filled');

const Pipeline24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.25A2.25 2.25 0 016.49 6H17.5a2.25 2.25 0 014.49.25v10.5a2.25 2.25 0 01-4.49.25H6.5A2.25 2.25 0 012 16.75V6.25zm3 0a.75.75 0 00-1.5 0v10.5a.75.75 0 001.5 0V6.25zm1.5 9.25h11v-8h-11v8zm14-9.25a.75.75 0 00-1.5 0v10.5a.75.75 0 001.5 0V6.25z",
    fill: primaryFill
  }));
};

export const Pipeline24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pipeline24RegularIcon, 'Pipeline24Regular');

const Pipeline32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 8a2 2 0 114 0v16a2 2 0 11-4 0V8zm24 0a2 2 0 114 0v16a2 2 0 11-4 0V8zm-2 1H8v14h16V9z",
    fill: primaryFill
  }));
};

export const Pipeline32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pipeline32FilledIcon, 'Pipeline32Filled');

const Pipeline32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 9a3 3 0 016 0h16a3 3 0 116 0v14a3 3 0 11-6 0H8a3 3 0 11-6 0V9zm4 0a1 1 0 00-2 0v14a1 1 0 102 0V9zm2 12h16V11H8v10zM28 9a1 1 0 10-2 0v14a1 1 0 102 0V9z",
    fill: primaryFill
  }));
};

export const Pipeline32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pipeline32RegularIcon, 'Pipeline32Regular');

const PipelineAdd20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.5a1.5 1.5 0 013 0v9a1.5 1.5 0 01-3 0v-9zm12 3.52A5.5 5.5 0 009.02 14H6V6h8v3.02zm1-3.52v3.52c1.13.1 2.17.55 3 1.24V5.5a1.5 1.5 0 00-3 0zm4 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const PipelineAdd20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelineAdd20FilledIcon, 'PipelineAdd20Filled');

const PipelineAdd20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.5a1.5 1.5 0 113 0V6h10v-.5a1.5 1.5 0 013 0v4.76a5.5 5.5 0 00-1-.66V5.5a.5.5 0 00-1 0v3.7c-.32-.08-.66-.15-1-.18V7H5v6h4.2c-.08.32-.15.66-.18 1H5v.5a1.5 1.5 0 01-3 0v-9zm2 0a.5.5 0 00-1 0v9a.5.5 0 001 0v-9zm15 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const PipelineAdd20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelineAdd20RegularIcon, 'PipelineAdd20Regular');

const PipelineAdd32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 6a2 2 0 00-2 2v16a2 2 0 104 0V8a2 2 0 00-2-2zm24 0a2 2 0 00-2 2v6.51a9.02 9.02 0 014 2.83V8a2 2 0 00-2-2zm-5 8c.34 0 .67.02 1 .05V9H8v14h6a9 9 0 019-9zm0 16.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15zm1-12.25V22h3.75a.75.75 0 010 1.5H24v3.75a.75.75 0 01-1.5 0V23.5h-3.75a.75.75 0 010-1.5h3.75v-3.75a.75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const PipelineAdd32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelineAdd32FilledIcon, 'PipelineAdd32Filled');

const PipelineAdd32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 9a3 3 0 016 0h16a3 3 0 116 0v8.34a9.05 9.05 0 00-2-1.82V9a1 1 0 10-2 0v5.51a8.95 8.95 0 00-2-.46V11H8v10h6.22a9.03 9.03 0 00-.22 2H8a3 3 0 11-6 0V9zm4 0a1 1 0 00-2 0v14a1 1 0 102 0V9zm17 21.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15zm1-12.25V22h3.75a.75.75 0 010 1.5H24v3.75a.75.75 0 01-1.5 0V23.5h-3.75a.75.75 0 010-1.5h3.75v-3.75a.75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const PipelineAdd32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelineAdd32RegularIcon, 'PipelineAdd32Regular');

const PipelineArrowCurveDown20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 5.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm6.4.9l-.9.9V5.74A2.75 2.75 0 003.75 3H3.5a.5.5 0 100 1h.25c.97 0 1.75.78 1.75 1.75v1.54l-.9-.9a.5.5 0 00-.7.71l1.75 1.76a.5.5 0 00.7 0L8.12 7.1a.5.5 0 10-.7-.7zM2 9.74a5.48 5.48 0 003 1.24v3.52a1.5 1.5 0 01-3 0V9.74zM10.98 6A5.5 5.5 0 016 10.98V14h8V6h-3.02zm5.52-2c-.83 0-1.5.67-1.5 1.5v9a1.5 1.5 0 003 0v-9c0-.83-.67-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const PipelineArrowCurveDown20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelineArrowCurveDown20FilledIcon, 'PipelineArrowCurveDown20Filled');

const PipelineArrowCurveDown20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.98 6c-.03.34-.1.68-.18 1H15v6H5v-2.02c-.35-.03-.68-.1-1-.19v3.71a.5.5 0 01-1 0v-4.1c-.37-.19-.7-.4-1-.66v4.76a1.5 1.5 0 003 0V14h10v.5a1.5 1.5 0 003 0v-9a1.5 1.5 0 00-3 0V6h-4.02zm5.52-1c.28 0 .5.22.5.5v9a.5.5 0 01-1 0v-9c0-.28.22-.5.5-.5zm-11-4a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm2.6 5.4c.2.2.2.5 0 .7L6.37 8.85a.5.5 0 01-.7 0L3.9 7.1a.5.5 0 11.7-.7l.9.9V5.74C5.5 4.78 4.72 4 3.75 4H3.5a.5.5 0 110-1h.25A2.75 2.75 0 016.5 5.75v1.54l.9-.9c.2-.19.51-.19.7 0z",
    fill: primaryFill
  }));
};

export const PipelineArrowCurveDown20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelineArrowCurveDown20RegularIcon, 'PipelineArrowCurveDown20Regular');

const PipelinePlay20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.5a1.5 1.5 0 013 0v9a1.5 1.5 0 01-3 0v-9zm12 3.52A5.5 5.5 0 009.02 14H6V6h8v3.02zm1-3.52v3.52c1.13.1 2.17.55 3 1.24V5.5a1.5 1.5 0 00-3 0zm4 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.29-.44l-2.97-1.65a.5.5 0 00-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const PipelinePlay20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelinePlay20FilledIcon, 'PipelinePlay20Filled');

const PipelinePlay20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.5a1.5 1.5 0 113 0V6h10v-.5a1.5 1.5 0 013 0v4.76a5.5 5.5 0 00-1-.66V5.5a.5.5 0 00-1 0v3.7c-.32-.08-.66-.15-1-.18V7H5v6h4.2c-.08.32-.15.66-.18 1H5v.5a1.5 1.5 0 01-3 0v-9zm2 0a.5.5 0 00-1 0v9a.5.5 0 001 0v-9zm15 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.29-.44l-2.97-1.65a.5.5 0 00-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const PipelinePlay20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PipelinePlay20RegularIcon, 'PipelinePlay20Regular');

const Pivot20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5.5v9A2.5 2.5 0 005.5 17h4.59a1.5 1.5 0 01.35-1.56l1-1a1.5 1.5 0 012.47.56h.59a.5.5 0 00.5-.5v-.59a1.5 1.5 0 01-.56-2.47l1-1a1.5 1.5 0 011.56-.35V5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5zM6 5h1a1 1 0 011 1v1a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1zm3 1a1 1 0 011-1h4a1 1 0 011 1v1a1 1 0 01-1 1h-4a1 1 0 01-1-1V6zM7 9a1 1 0 011 1v4a1 1 0 01-1 1H6a1 1 0 01-1-1v-4a1 1 0 011-1h1zm9.85 2.15a.5.5 0 00-.7 0l-1 1a.5.5 0 00.7.7l.15-.14v1.79c0 .83-.67 1.5-1.5 1.5h-1.8l.15-.15a.5.5 0 00-.7-.7l-1 1a.5.5 0 000 .7l1 1a.5.5 0 00.7-.7l-.14-.15h1.79a2.5 2.5 0 002.5-2.5v-1.8l.15.15a.5.5 0 00.7-.7l-1-1z",
    fill: primaryFill
  }));
};

export const Pivot20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pivot20FilledIcon, 'Pivot20Filled');

const Pivot20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 4C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h4.59a1.5 1.5 0 000 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v4.59a1.5 1.5 0 00-1 0V5.5c0-.83-.67-1.5-1.5-1.5h-9zM6 5a1 1 0 00-1 1v1a1 1 0 001 1h1a1 1 0 001-1V6a1 1 0 00-1-1H6zm4 0a1 1 0 00-1 1v1a1 1 0 001 1h4a1 1 0 001-1V6a1 1 0 00-1-1h-4zM6 9a1 1 0 00-1 1v4a1 1 0 001 1h1a1 1 0 001-1v-4a1 1 0 00-1-1H6zm10.85 2.15a.5.5 0 00-.7 0l-1 1a.5.5 0 00.7.7l.15-.14v1.79c0 .83-.67 1.5-1.5 1.5h-1.8l.15-.15a.5.5 0 00-.7-.7l-1 1a.5.5 0 000 .7l1 1a.5.5 0 00.7-.7l-.14-.15h1.79a2.5 2.5 0 002.5-2.5v-1.8l.15.15a.5.5 0 00.7-.7l-1-1z",
    fill: primaryFill
  }));
};

export const Pivot20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pivot20RegularIcon, 'Pivot20Regular');

const Pivot24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6.5V17a3.5 3.5 0 003.5 3.5h4.38a2.25 2.25 0 01.53-2.34l1.5-1.5a2.25 2.25 0 013.71.84h.88v-.88a2.25 2.25 0 01-.84-3.71l1.5-1.5a2.25 2.25 0 012.34-.53V6.5A3.5 3.5 0 0017 3H6.5A3.5 3.5 0 003 6.5zM6.5 5h1C8.33 5 9 5.67 9 6.5v1C9 8.33 8.33 9 7.5 9h-1A1.5 1.5 0 015 7.5v-1C5 5.67 5.67 5 6.5 5zM11 6.5c0-.83.67-1.5 1.5-1.5H17c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-4.5A1.5 1.5 0 0111 7.5v-1zM7.5 11c.83 0 1.5.67 1.5 1.5V17c0 .83-.67 1.5-1.5 1.5h-1A1.5 1.5 0 015 17v-4.5c0-.83.67-1.5 1.5-1.5h1zm12.78 1.47a.75.75 0 00-1.06 0l-1.5 1.5a.75.75 0 101.06 1.06l.22-.22v2.44c0 .97-.78 1.75-1.75 1.75h-2.44l.22-.22a.75.75 0 10-1.06-1.06l-1.5 1.5a.75.75 0 000 1.06l1.5 1.5a.75.75 0 101.06-1.06l-.22-.22h2.44c1.8 0 3.25-1.46 3.25-3.25v-2.44l.22.22a.75.75 0 101.06-1.06l-1.5-1.5z",
    fill: primaryFill
  }));
};

export const Pivot24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pivot24FilledIcon, 'Pivot24Filled');

const Pivot24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 6.25c0-.97.78-1.75 1.75-1.75h11c.97 0 1.75.78 1.75 1.75v4.63a2.25 2.25 0 011.5 0V6.25c0-1.8-1.46-3.25-3.25-3.25h-11A3.25 3.25 0 003 6.25v11c0 1.8 1.46 3.25 3.25 3.25h4.63a2.25 2.25 0 010-1.5H6.25c-.97 0-1.75-.78-1.75-1.75v-11zM6 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1V7zm5.5 0a1 1 0 011-1h4a1 1 0 011 1v2a1 1 0 01-1 1h-4a1 1 0 01-1-1V7zM6 12.5a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1H7a1 1 0 01-1-1v-4zm14.28-.03a.75.75 0 00-1.06 0l-1.5 1.5a.75.75 0 101.06 1.06l.22-.22v2.44c0 .97-.78 1.75-1.75 1.75h-2.44l.22-.22a.75.75 0 10-1.06-1.06l-1.5 1.5a.75.75 0 000 1.06l1.5 1.5a.75.75 0 101.06-1.06l-.22-.22h2.44c1.8 0 3.25-1.46 3.25-3.25v-2.44l.22.22a.75.75 0 101.06-1.06l-1.5-1.5z",
    fill: primaryFill
  }));
};

export const Pivot24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Pivot24RegularIcon, 'Pivot24Regular');

const Play12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2a1 1 0 00-1.5.86v6.28a1 1 0 001.5.87l5.49-3.14a1 1 0 000-1.74L4.49 2z",
    fill: primaryFill
  }));
};

export const Play12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Play12FilledIcon, 'Play12Filled');

const Play12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 2.86A1 1 0 014.5 2l5.49 3.14a1 1 0 010 1.74L4.49 10A1 1 0 013 9.14V2.86zM9.5 6L4 2.86v6.28L9.5 6z",
    fill: primaryFill
  }));
};

export const Play12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Play12RegularIcon, 'Play12Regular');

const Play16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.24 2.2A1.5 1.5 0 004 3.5v9a1.5 1.5 0 002.24 1.3l8-4.5a1.5 1.5 0 000-2.6l-8-4.5z",
    fill: primaryFill
  }));
};

export const Play16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Play16FilledIcon, 'Play16Filled');

const Play16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.75 3.06A.5.5 0 005 3.5v9c0 .38.41.62.75.44l8-4.5a.5.5 0 000-.88l-8-4.5zM4 3.5a1.5 1.5 0 012.24-1.3l8 4.5a1.5 1.5 0 010 2.6l-8 4.5A1.5 1.5 0 014 12.5v-9z",
    fill: primaryFill
  }));
};

export const Play16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Play16RegularIcon, 'Play16Regular');

const Play20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.22 8.68a1.5 1.5 0 010 2.63l-10 5.5A1.5 1.5 0 015 15.5v-11A1.5 1.5 0 017.22 3.2l10 5.5z",
    fill: primaryFill
  }));
};

export const Play20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Play20FilledIcon, 'Play20Filled');

const Play20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.22 8.69a1.5 1.5 0 010 2.62l-10 5.5A1.5 1.5 0 015 15.5v-11A1.5 1.5 0 017.22 3.2l10 5.5zm-.48 1.75a.5.5 0 000-.88l-10-5.5A.5.5 0 006 4.5v11c0 .38.4.62.74.44l10-5.5z",
    fill: primaryFill
  }));
};

export const Play20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Play20RegularIcon, 'Play20Regular');

const Play24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 5.27c0-1.7 1.83-2.79 3.33-1.97l12.36 6.72a2.25 2.25 0 010 3.96L8.33 20.7A2.25 2.25 0 015 18.73V5.27z",
    fill: primaryFill
  }));
};

export const Play24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Play24FilledIcon, 'Play24Filled');

const Play24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.6 4.61a.75.75 0 00-1.1.66v13.46c0 .56.6.93 1.1.65l12.37-6.72a.75.75 0 000-1.32L7.61 4.61zM5 5.27c0-1.7 1.83-2.79 3.33-1.97l12.36 6.72a2.25 2.25 0 010 3.96L8.33 20.7A2.25 2.25 0 015 18.73V5.27z",
    fill: primaryFill
  }));
};

export const Play24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Play24RegularIcon, 'Play24Regular');

const Play28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.14 3.38A2.75 2.75 0 006 5.76v16.48c0 2.13 2.3 3.45 4.14 2.38l14.7-8.6a2.35 2.35 0 000-4.05l-14.7-8.59z",
    fill: primaryFill
  }));
};

export const Play28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Play28FilledIcon, 'Play28Filled');

const Play28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.38 4.68A1.25 1.25 0 007.5 5.76v16.48c0 .97 1.05 1.57 1.88 1.08l14.7-8.59a.85.85 0 000-1.46l-14.7-8.6zM6 5.76c0-2.13 2.3-3.45 4.14-2.38l14.7 8.6a2.35 2.35 0 010 4.05l-14.7 8.59A2.75 2.75 0 016 22.24V5.76z",
    fill: primaryFill
  }));
};

export const Play28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Play28RegularIcon, 'Play28Regular');

const Play32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.22 4.46A3.5 3.5 0 007 7.51V24.5a3.5 3.5 0 005.23 3.04l15-8.5a3.5 3.5 0 000-6.09l-15-8.49z",
    fill: primaryFill
  }));
};

export const Play32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Play32FilledIcon, 'Play32Filled');

const Play32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.24 6.2A1.5 1.5 0 009 7.5v17a1.5 1.5 0 002.24 1.3l15-8.5a1.5 1.5 0 000-2.6l-15-8.5zM7 7.5a3.5 3.5 0 015.22-3.04l15 8.5a3.5 3.5 0 010 6.09l-15 8.5A3.5 3.5 0 017 24.5v-17z",
    fill: primaryFill
  }));
};

export const Play32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Play32RegularIcon, 'Play32Regular');

const Play48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.75 8.41l24.42 12.7a3.25 3.25 0 010 5.77l-24.42 12.7A3.25 3.25 0 0112 36.7V11.3a3.25 3.25 0 014.55-2.98l.2.1z",
    fill: primaryFill
  }));
};

export const Play48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Play48FilledIcon, 'Play48Filled');

const Play48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.75 8.41l24.42 12.7a3.25 3.25 0 010 5.77l-24.42 12.7A3.25 3.25 0 0112 36.7V11.3a3.25 3.25 0 014.55-2.98l.2.1zm-1.15 2.22l-.11-.05a.75.75 0 00-.99.71V36.7a.75.75 0 001.1.67L40 24.67a.75.75 0 000-1.34L15.6 10.63z",
    fill: primaryFill
  }));
};

export const Play48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Play48RegularIcon, 'Play48Regular');

const PlayCircle16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 8a6 6 0 1112 0A6 6 0 012 8zm8.5 0a.5.5 0 00-.25-.44L7.62 6.08a.75.75 0 00-1.12.65v2.54c0 .58.62.94 1.12.65l2.63-1.48A.5.5 0 0010.5 8z",
    fill: primaryFill
  }));
};

export const PlayCircle16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayCircle16FilledIcon, 'PlayCircle16Filled');

const PlayCircle16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 8a.5.5 0 01-.25.44L7.62 9.92a.75.75 0 01-1.12-.65V6.73c0-.58.62-.94 1.12-.65l2.63 1.48a.5.5 0 01.25.44zM8 2a6 6 0 100 12A6 6 0 008 2zM3 8a5 5 0 1110 0A5 5 0 013 8z",
    fill: primaryFill
  }));
};

export const PlayCircle16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayCircle16RegularIcon, 'PlayCircle16Regular');

const PlayCircle20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm6-2.17v4.34c0 .57.63.94 1.13.65l4.12-2.39a.5.5 0 000-.86L9.13 7.18A.75.75 0 008 7.83z",
    fill: primaryFill
  }));
};

export const PlayCircle20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayCircle20FilledIcon, 'PlayCircle20Filled');

const PlayCircle20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.13 7.18A.75.75 0 008 7.83v4.34c0 .57.63.94 1.13.65l4.12-2.39a.5.5 0 000-.86L9.13 7.18zM2 10a8 8 0 1116 0 8 8 0 01-16 0zm8-7a7 7 0 100 14 7 7 0 000-14z",
    fill: primaryFill
  }));
};

export const PlayCircle20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayCircle20RegularIcon, 'PlayCircle20Regular');

const PlayCircle24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 12a10 10 0 1120 0 10 10 0 01-20 0zm8.86-3.85A1.25 1.25 0 009 9.25v5.5c0 .95 1.02 1.56 1.86 1.1l5.75-3.2a.75.75 0 000-1.3l-5.75-3.2z",
    fill: primaryFill
  }));
};

export const PlayCircle24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayCircle24FilledIcon, 'PlayCircle24Filled');

const PlayCircle24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.86 8.15A1.25 1.25 0 009 9.25v5.5c0 .95 1.02 1.56 1.86 1.1l5.75-3.2a.75.75 0 000-1.3l-5.75-3.2zM12 2a10 10 0 100 20 10 10 0 000-20zM3.5 12a8.5 8.5 0 1117 0 8.5 8.5 0 01-17 0z",
    fill: primaryFill
  }));
};

export const PlayCircle24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayCircle24RegularIcon, 'PlayCircle24Regular');

const PlayCircle28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 2a12 12 0 100 24 12 12 0 000-24zm-1.23 7.28l6.5 3.86a1 1 0 010 1.72l-6.5 3.86a1.5 1.5 0 01-2.27-1.29v-6.86a1.5 1.5 0 012.27-1.3z",
    fill: primaryFill
  }));
};

export const PlayCircle28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayCircle28FilledIcon, 'PlayCircle28Filled');

const PlayCircle28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.77 9.28c-1-.6-2.27.12-2.27 1.29v6.86a1.5 1.5 0 002.27 1.3l6.5-3.87a1 1 0 000-1.72l-6.5-3.86zM2 14a12 12 0 1124 0 12 12 0 01-24 0zM14 3.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21z",
    fill: primaryFill
  }));
};

export const PlayCircle28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayCircle28RegularIcon, 'PlayCircle28Regular');

const PlayCircle48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 44a20 20 0 100-40 20 20 0 000 40zm9.77-21.29c.97.58.97 2 0 2.58L21.4 32.68c-1.5.9-3.4-.19-3.4-1.94V17.26c0-1.75 1.9-2.83 3.4-1.93l12.37 7.38z",
    fill: primaryFill
  }));
};

export const PlayCircle48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayCircle48FilledIcon, 'PlayCircle48Filled');

const PlayCircle48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M33.77 22.71L21.4 15.33c-1.5-.9-3.4.18-3.4 1.93v13.48c0 1.75 1.9 2.83 3.4 1.94l12.37-7.4c.97-.57.97-1.99 0-2.57zM24 44a20 20 0 100-40 20 20 0 000 40zm0-37.5a17.5 17.5 0 110 35 17.5 17.5 0 010-35z",
    fill: primaryFill
  }));
};

export const PlayCircle48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayCircle48RegularIcon, 'PlayCircle48Regular');

const PlaySettings20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.22 8.68a1.5 1.5 0 010 2.63L12 14.2A5.5 5.5 0 005 9.2V4.5a1.5 1.5 0 012.23-1.32l10 5.5zM4.06 11.44a2 2 0 01-1.43 2.48l-.46.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 014 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 019 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zM6.5 15.5a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PlaySettings20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlaySettings20FilledIcon, 'PlaySettings20Filled');

const PlaySettings20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.22 8.69a1.5 1.5 0 010 2.62l-5.23 2.88a5.5 5.5 0 00-.16-1.05l4.9-2.7a.5.5 0 000-.88l-9.99-5.5A.5.5 0 006 4.5v4.52c-.34.03-.68.1-1 .19V4.5a1.5 1.5 0 012.22-1.32l10 5.5zM4.06 11.44a2 2 0 01-1.43 2.48l-.46.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 014 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 019 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zM6.5 15.5a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const PlaySettings20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlaySettings20RegularIcon, 'PlaySettings20Regular');

const PlayingCards20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.82 2.74c.07-.27.19-.52.33-.74H7a2 2 0 00-2 2v5.54l1.82-6.8zM4 3.5c0-.15.01-.3.04-.45l-.06.02a2 2 0 00-1.41 2.45l1.42 5.34L4 3.5zm6.1-1.43a2 2 0 00-2.45 1.41L4.82 14.03a2 2 0 001.41 2.45l5.42 1.45a2 2 0 002.45-1.41l2.83-10.55a2 2 0 00-1.4-2.45L10.1 2.07zM12 7a1 1 0 110-2 1 1 0 010 2zm-1.25 7a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const PlayingCards20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayingCards20FilledIcon, 'PlayingCards20Filled');

const PlayingCards20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.85 3.03a1 1 0 00-1.23.71L5.78 14.3a1 1 0 00.71 1.22l5.42 1.46a1 1 0 001.22-.71L15.97 5.7a1 1 0 00-.7-1.22L9.84 3.03zm-2.2.45a2 2 0 012.46-1.41l5.41 1.45a2 2 0 011.41 2.45L14.1 16.52a2 2 0 01-2.45 1.41l-5.42-1.45a2 2 0 01-1.41-2.45L7.65 3.48zM12 7a1 1 0 100-2 1 1 0 000 2zm-1.25 7a1 1 0 11-2 0 1 1 0 012 0zM7.15 2H7a2 2 0 00-2 2v5.52L6 5.8V4a1 1 0 01.74-.97l.08-.29A2.51 2.51 0 017.15 2zM4.04 3.05C4 3.2 4 3.35 4 3.5v.64a1 1 0 00-.47 1.12L4 6.99v3.86L2.56 5.52a2 2 0 011.41-2.45l.06-.02z",
    fill: primaryFill
  }));
};

export const PlayingCards20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlayingCards20RegularIcon, 'PlayingCards20Regular');

const PlugConnected20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.78 3.28a.75.75 0 00-1.06-1.06l-2.45 2.45a4.04 4.04 0 00-5.12.48l-.3.3a1.49 1.49 0 000 2.1l3.6 3.6c.58.59 1.52.59 2.1 0l.3-.3a4.04 4.04 0 00.48-5.12l2.45-2.45zM7.55 8.85a1.49 1.49 0 00-2.1 0l-.3.3a4.04 4.04 0 00-.48 5.12l-2.45 2.45a.75.75 0 101.06 1.06l2.45-2.45a4.04 4.04 0 005.12-.48l.3-.3c.59-.58.59-1.52 0-2.1l-3.6-3.6z",
    fill: primaryFill
  }));
};

export const PlugConnected20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugConnected20FilledIcon, 'PlugConnected20Filled');

const PlugConnected20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.85 2.85a.5.5 0 00-.7-.7L14.48 4.8a4.04 4.04 0 00-5.33.34l-.3.3a1.49 1.49 0 000 2.1l3.6 3.6c.58.59 1.52.59 2.1 0l.3-.3a4.04 4.04 0 00.34-5.33l2.66-2.67zm-4 7.6c-.2.19-.5.19-.7 0l-3.6-3.6c-.19-.2-.19-.5 0-.7l.3-.3a3.04 3.04 0 014.3 4.3l-.3.3zm-6.3-1.6a1.49 1.49 0 00-2.1 0l-.3.3a4.04 4.04 0 00-.34 5.33l-2.66 2.67a.5.5 0 00.7.7l2.67-2.66a4.04 4.04 0 005.33-.34l.3-.3c.59-.58.59-1.52 0-2.1l-3.6-3.6zm-1.4.7c.2-.19.5-.19.7 0l3.6 3.6c.19.2.19.5 0 .7l-.3.3a3.04 3.04 0 11-4.3-4.3l.3-.3z",
    fill: primaryFill
  }));
};

export const PlugConnected20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugConnected20RegularIcon, 'PlugConnected20Regular');

const PlugConnected24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.49 5.57a5.97 5.97 0 01-1.9 8.96c-.64.35-1.42.14-1.94-.38l-5.8-5.8c-.52-.52-.73-1.3-.38-1.95a6 6 0 018.96-1.89l2.29-2.29a.75.75 0 111.06 1.06l-2.29 2.3zM3.28 21.78l2.3-2.29a5.97 5.97 0 008.95-1.9c.35-.64.14-1.42-.38-1.94l-5.8-5.8c-.52-.52-1.3-.73-1.95-.38a6 6 0 00-1.89 8.96l-2.29 2.29a.75.75 0 101.06 1.06z",
    fill: primaryFill
  }));
};

export const PlugConnected24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugConnected24FilledIcon, 'PlugConnected24Filled');

const PlugConnected24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.49 5.57a5.97 5.97 0 01-1.9 8.96c-.64.35-1.42.14-1.94-.38l-5.8-5.8c-.52-.52-.73-1.3-.38-1.95a6 6 0 018.96-1.89l2.29-2.29a.75.75 0 111.06 1.06l-2.29 2.3zm-2.02 7.26a4.5 4.5 0 10-6.3-6.3c-.27.35-.19.83.12 1.14l5.04 5.04c.31.3.8.39 1.14.12zM3.28 21.78l2.3-2.29a5.97 5.97 0 008.95-1.9c.35-.64.14-1.42-.38-1.94l-5.8-5.8c-.52-.52-1.3-.73-1.95-.38a6 6 0 00-1.89 8.96l-2.29 2.29a.75.75 0 101.06 1.06zm4.39-10.49l5.04 5.04c.3.31.39.8.12 1.14a4.5 4.5 0 11-6.3-6.3c.35-.27.83-.19 1.14.12z",
    fill: primaryFill
  }));
};

export const PlugConnected24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugConnected24RegularIcon, 'PlugConnected24Regular');

const PlugConnectedAdd20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.78 3.28a.75.75 0 00-1.06-1.06l-2.45 2.45a4.04 4.04 0 00-5.12.48l-.3.3a1.49 1.49 0 000 2.1l2.46 2.47a5.48 5.48 0 014.55-.85 4.04 4.04 0 00-.53-3.44l2.45-2.45zM7.55 8.85l2.47 2.46a5.48 5.48 0 00-.85 4.55 4.04 4.04 0 01-3.44-.53l-2.45 2.45a.75.75 0 01-1.06-1.06l2.45-2.45a4.04 4.04 0 01.48-5.12l.3-.3a1.49 1.49 0 012.1 0zm9.45 9.4a4.5 4.5 0 11-5-7.5 4.5 4.5 0 015 7.5zm-2.15-6.1a.5.5 0 00-.85.35V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5a.5.5 0 00-.15-.35z",
    fill: primaryFill
  }));
};

export const PlugConnectedAdd20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugConnectedAdd20FilledIcon, 'PlugConnectedAdd20Filled');

const PlugConnectedAdd20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.96 2.3a.5.5 0 00-.82-.15l-2.7 2.7a4.04 4.04 0 00-5.33.33l-.6.61a1.05 1.05 0 000 1.49l2.76 2.76c.28-.2.58-.37.89-.52L9.52 6.88a.5.5 0 010-.7l.3-.3a3.03 3.03 0 014.29 0v.02a3.04 3.04 0 01.73 3.11c.34.02.68.07 1 .16a4.03 4.03 0 00-.69-3.62l2.7-2.7a.5.5 0 00.11-.54zM7.28 8.5l2.77 2.77c-.2.28-.38.57-.53.88L6.9 9.52a.49.49 0 00-.7 0l-.3.3a3.04 3.04 0 000 4.29h.01a3.03 3.03 0 003.11.73c.02.34.07.68.15 1a4.03 4.03 0 01-3.6-.69l-2.7 2.7a.5.5 0 11-.71-.7l2.7-2.7a4.03 4.03 0 01.33-5.34l.3-.3.31-.31a1.05 1.05 0 011.49 0zM17 18.24a4.5 4.5 0 11-5-7.48 4.5 4.5 0 015 7.48zm-2.15-6.1a.5.5 0 00-.85.36V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5a.5.5 0 00-.15-.35z",
    fill: primaryFill
  }));
};

export const PlugConnectedAdd20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugConnectedAdd20RegularIcon, 'PlugConnectedAdd20Regular');

const PlugConnectedCheckmark20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.78 3.28a.75.75 0 00-1.06-1.06l-2.45 2.45a4.04 4.04 0 00-5.12.48l-.3.3a1.49 1.49 0 000 2.1l2.46 2.47a5.48 5.48 0 014.55-.85 4.04 4.04 0 00-.53-3.44l2.45-2.45zM7.55 8.85l2.47 2.46a5.48 5.48 0 00-.85 4.55 4.04 4.04 0 01-3.44-.53l-2.45 2.45a.75.75 0 01-1.06-1.06l2.45-2.45a4.04 4.04 0 01.48-5.12l.3-.3a1.49 1.49 0 012.1 0zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const PlugConnectedCheckmark20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugConnectedCheckmark20FilledIcon, 'PlugConnectedCheckmark20Filled');

const PlugConnectedCheckmark20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.85 2.85a.5.5 0 00-.7-.7L14.48 4.8a4.04 4.04 0 00-5.33.34l-.3.3a1.49 1.49 0 000 2.1l2.46 2.47c.28-.2.58-.38.9-.52L9.55 6.85c-.19-.2-.19-.5 0-.7l.3-.3a3.04 3.04 0 015.01 3.16c.35.02.68.08 1 .16.37-1.23.15-2.6-.67-3.65l2.66-2.67zm-10.3 6l2.47 2.46c-.2.28-.38.58-.52.9L6.85 9.55c-.2-.19-.5-.19-.7 0l-.3.3a3.04 3.04 0 003.16 5.01c.02.35.08.68.16 1-1.23.37-2.6.15-3.65-.67l-2.67 2.66a.5.5 0 01-.7-.7l2.66-2.67a4.04 4.04 0 01.34-5.33l.3-.3a1.49 1.49 0 012.1 0zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const PlugConnectedCheckmark20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugConnectedCheckmark20RegularIcon, 'PlugConnectedCheckmark20Regular');

const PlugDisconnected20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.78 2.22c.3.3.3.77 0 1.06l-1.45 1.45a4.04 4.04 0 01-.48 5.12l-.3.3-.3.31c-.42.41-1.08.41-1.5 0L9.55 6.24a1.05 1.05 0 010-1.48l.6-.61a4.05 4.05 0 015.13-.48l1.45-1.45c.3-.3.77-.3 1.06 0zm-9 6.25c.3.3.3.77 0 1.06L7.51 10.8l1.69 1.7 1.27-1.28a.75.75 0 111.06 1.06l-1.28 1.28c.48.58.45 1.45-.1 2l-.3.3a4.04 4.04 0 01-5.12.47l-1.45 1.45a.75.75 0 01-1.06-1.06l1.45-1.45a4.04 4.04 0 01.48-5.12l.3-.3a1.49 1.49 0 012-.1l1.27-1.28c.3-.3.77-.3 1.06 0z",
    fill: primaryFill
  }));
};

export const PlugDisconnected20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugDisconnected20FilledIcon, 'PlugDisconnected20Filled');

const PlugDisconnected20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.85 2.15c.2.2.2.5 0 .7L16.2 4.52a4.04 4.04 0 01-.34 5.33l-.3.3-.3.31c-.42.41-1.08.41-1.5 0L9.55 6.24a1.05 1.05 0 010-1.48l.6-.61a4.04 4.04 0 015.34-.34l1.67-1.66c.2-.2.5-.2.7 0zm-2.71 2.7a3.04 3.04 0 00-4.29 0l-.3.3c-.19.2-.19.5 0 .7l3.6 3.6c.2.19.5.19.7 0l.3-.3a3.04 3.04 0 000-4.29l-.01-.01zm-5.79 3.8c.2.2.2.5 0 .7L7.71 11 9 12.3l1.65-1.65a.5.5 0 01.7.7L9.71 13l.44.45c.59.58.59 1.52 0 2.1l-.3.3a4.04 4.04 0 01-5.33.34l-1.67 1.66a.5.5 0 01-.7-.7l1.66-1.67a4.04 4.04 0 01.34-5.33l.3-.3a1.49 1.49 0 012.1 0l.45.44 1.65-1.64c.2-.2.5-.2.7 0zm-4.5 6.5a3.04 3.04 0 004.3 0l.3-.3c.19-.2.19-.5 0-.7l-3.6-3.6c-.2-.19-.5-.19-.7 0l-.3.3a3.04 3.04 0 000 4.3z",
    fill: primaryFill
  }));
};

export const PlugDisconnected20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugDisconnected20RegularIcon, 'PlugDisconnected20Regular');

const PlugDisconnected24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.7 3.7a1 1 0 00-1.4-1.4l-1.8 1.79a4.25 4.25 0 00-5.26.6l-1.06 1.07c-.69.69-.69 1.8 0 2.48l3.58 3.58c.69.69 1.8.69 2.48 0l1.07-1.06a4.25 4.25 0 00.6-5.26l1.8-1.8zm-11 8a1 1 0 00-1.4-1.4l-1.48 1.46-.29-.29a.75.75 0 00-1.06 0l-1.78 1.77a4.25 4.25 0 00-.6 5.26l-1.8 1.8a1 1 0 101.42 1.4l1.8-1.79a4.25 4.25 0 005.25-.6l1.77-1.78c.3-.3.3-.77 0-1.06l-.3-.3 1.48-1.46a1 1 0 00-1.42-1.42l-1.47 1.47-1.58-1.58 1.47-1.47z",
    fill: primaryFill
  }));
};

export const PlugDisconnected24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugDisconnected24FilledIcon, 'PlugDisconnected24Filled');

const PlugDisconnected24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.78 3.28a.75.75 0 00-1.06-1.06l-2.01 2.01a4.25 4.25 0 00-5.47.46l-1.06 1.07c-.69.69-.69 1.8 0 2.48l3.58 3.58c.69.69 1.8.69 2.48 0l1.07-1.06a4.25 4.25 0 00.46-5.47l2.01-2.01zm-3.59 2.48l.03.02.02.03a2.75 2.75 0 010 3.88l-1.06 1.07c-.1.1-.26.1-.36 0l-3.58-3.58a.25.25 0 010-.36l1.07-1.06a2.75 2.75 0 013.88 0zm-7.41 5.52a.75.75 0 10-1.06-1.06L8 11.94l-.47-.47a.75.75 0 00-1.06 0l-1.78 1.77a4.25 4.25 0 00-.46 5.47l-2.01 2.01a.75.75 0 101.06 1.06l2.01-2.01a4.25 4.25 0 005.47-.46l1.77-1.78c.3-.3.3-.77 0-1.06l-.47-.47 1.72-1.72a.75.75 0 10-1.06-1.06L11 14.94 9.06 13l1.72-1.72zm-3.31 2.25l3 3 .47.47-1.25 1.24a2.75 2.75 0 01-3.88 0l-.05-.05a2.75 2.75 0 010-3.88L7 13.06l.47.47z",
    fill: primaryFill
  }));
};

export const PlugDisconnected24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugDisconnected24RegularIcon, 'PlugDisconnected24Regular');

const PlugDisconnected28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22.74 6.33a5.5 5.5 0 01-.5 7.2l-1.94 1.95c-.3.3-.77.3-1.06 0l-6.72-6.71a.75.75 0 010-1.06l1.95-1.95a5.5 5.5 0 017.21-.5l3.04-3.04a.75.75 0 011.07 1.06l-3.05 3.05zm-9.96 5.95a.75.75 0 00-1.06-1.06l-2.13 2.12-.82-.82a.75.75 0 00-1.06 0l-1.95 1.94a5.5 5.5 0 00-.5 7.22l-3.04 3.04a.75.75 0 101.07 1.06l3.04-3.04a5.5 5.5 0 007.21-.5l1.95-1.94c.29-.3.29-.77 0-1.06l-.83-.83 2.12-2.13a.75.75 0 10-1.06-1.06l-2.12 2.13-2.95-2.95 2.13-2.12z",
    fill: primaryFill
  }));
};

export const PlugDisconnected28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugDisconnected28FilledIcon, 'PlugDisconnected28Filled');

const PlugDisconnected28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22.74 6.33a5.5 5.5 0 01-.5 7.2l-1.94 1.95c-.3.3-.77.3-1.06 0l-6.72-6.71a.75.75 0 010-1.06l1.95-1.95a5.5 5.5 0 017.21-.5l3.04-3.04a.75.75 0 011.07 1.06l-3.05 3.05zm-2.97 7.56l1.42-1.41a4 4 0 10-5.66-5.66L14.1 8.24l5.66 5.65zm-7-2.68c.3.3.3.77 0 1.07l-2.12 2.12 2.95 2.95 2.12-2.13a.75.75 0 111.06 1.06l-2.12 2.13.83.83c.29.29.29.76 0 1.06l-1.95 1.94a5.5 5.5 0 01-7.21.5l-3.04 3.04a.75.75 0 01-1.07-1.06l3.05-3.04a5.5 5.5 0 01.5-7.22l1.94-1.94c.3-.3.77-.3 1.06 0l.82.82 2.13-2.13c.3-.29.77-.29 1.06 0zM6.84 21.2a4 4 0 005.65 0l1.42-1.42-5.66-5.66-1.42 1.41a4 4 0 000 5.65v.01h.01z",
    fill: primaryFill
  }));
};

export const PlugDisconnected28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlugDisconnected28RegularIcon, 'PlugDisconnected28Regular');

const PointScan20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2.5a.5.5 0 00-1 0v4.02A5 5 0 003.52 11H8V6.52a5.07 5.07 0 011 0V2.5zM2.5 11h1.02a5.06 5.06 0 000 1H2.5a.5.5 0 010-1zM8 17.5v-1.02a5.07 5.07 0 001 0v1.02a.5.5 0 01-1 0zm5.48-5.5h4.02a.5.5 0 000-1h-4.02a5.07 5.07 0 010 1H9v4.48A5 5 0 0013.48 12zM8 16.48A5 5 0 013.52 12H8v4.48zM9 11h4.48A5 5 0 009 6.52V11z",
    fill: primaryFill
  }));
};

export const PointScan20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PointScan20FilledIcon, 'PointScan20Filled');

const PointScan20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 2c.28 0 .5.22.5.5v4.02A5 5 0 0113.48 11h4.02a.5.5 0 010 1h-4.02A5 5 0 019 16.48v1.02a.5.5 0 01-1 0v-1.02A5 5 0 013.52 12H2.5a.5.5 0 010-1h1.02A5 5 0 018 6.52V2.5c0-.28.22-.5.5-.5zM4.53 12A4 4 0 008 15.47V12H4.53zM8 11V7.53A4 4 0 004.53 11H8zm1 1v3.47A4 4 0 0012.47 12H9zm3.47-1A4 4 0 009 7.53V11h3.47z",
    fill: primaryFill
  }));
};

export const PointScan20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PointScan20RegularIcon, 'PointScan20Regular');

const PointScan24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.25 2c.38 0 .7.28.74.65l.01.1v4.8A6.25 6.25 0 0116.46 13h4.79a.75.75 0 01.1 1.5H16.45A6.25 6.25 0 0111 19.96v1.29a.75.75 0 01-1.5.1V19.95a6.25 6.25 0 01-5.46-5.45H2.75a.75.75 0 01-.1-1.5H4.05A6.25 6.25 0 019.5 7.54V2.75c0-.41.34-.75.75-.75zm0 5.5c-.25 0-.5.01-.75.04V13H4.04a6.31 6.31 0 000 1.5H9.5v5.46a6.3 6.3 0 001.5 0V14.5h5.46a6.31 6.31 0 000-1.5H11V7.54c-.25-.03-.5-.04-.75-.04z",
    fill: primaryFill
  }));
};

export const PointScan24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PointScan24FilledIcon, 'PointScan24Filled');

const PointScan24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.25 2c.38 0 .7.28.74.65l.01.1v4.8A6.25 6.25 0 0116.46 13h4.79a.75.75 0 01.1 1.5H16.45A6.25 6.25 0 0111 19.96v1.29a.75.75 0 01-1.5.1V19.95a6.25 6.25 0 01-5.46-5.45H2.75a.75.75 0 01-.1-1.5H4.05A6.25 6.25 0 019.5 7.54V2.75c0-.41.34-.75.75-.75zM9.5 14.5H5.56a4.75 4.75 0 003.94 3.94V14.5zm5.44 0H11v3.94a4.75 4.75 0 003.94-3.94zM9.5 9.06A4.75 4.75 0 005.56 13H9.5V9.06zm1.5 0V13h3.94a4.75 4.75 0 00-3.72-3.9L11 9.06z",
    fill: primaryFill
  }));
};

export const PointScan24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PointScan24RegularIcon, 'PointScan24Regular');

const Poll16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a2 2 0 114 0v10a2 2 0 11-4 0V3zM1 9a2 2 0 114 0v4a2 2 0 11-4 0V9zm10-2a2 2 0 114 0v6a2 2 0 11-4 0V7z",
    fill: primaryFill
  }));
};

export const Poll16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Poll16FilledIcon, 'Poll16Filled');

const Poll16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 1a2 2 0 00-2 2v10a2 2 0 104 0V3a2 2 0 00-2-2zm1 2v10a1 1 0 11-2 0V3a1 1 0 012 0zM3 7a2 2 0 00-2 2v4a2 2 0 104 0V9a2 2 0 00-2-2zm1 6a1 1 0 11-2 0V9a1 1 0 012 0v4zm7-6a2 2 0 114 0v6a2 2 0 11-4 0V7zm3 0a1 1 0 10-2 0v6a1 1 0 102 0V7z",
    fill: primaryFill
  }));
};

export const Poll16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Poll16RegularIcon, 'Poll16Regular');

const Poll20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a2 2 0 00-2 2v12a2 2 0 104 0V4a2 2 0 00-2-2zm-6 8a2 2 0 00-2 2v4a2 2 0 104 0v-4a2 2 0 00-2-2zm12-4a2 2 0 00-2 2v8a2 2 0 104 0V8a2 2 0 00-2-2z",
    fill: primaryFill
  }));
};

export const Poll20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Poll20FilledIcon, 'Poll20Filled');

const Poll20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 4a2 2 0 114 0v12a2 2 0 11-4 0V4zm2-1a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm-8 9a2 2 0 114 0v4a2 2 0 11-4 0v-4zm2-1a1 1 0 00-1 1v4a1 1 0 102 0v-4a1 1 0 00-1-1zm12-5a2 2 0 00-2 2v8a2 2 0 104 0V8a2 2 0 00-2-2zm-1 2a1 1 0 112 0v8a1 1 0 11-2 0V8z",
    fill: primaryFill
  }));
};

export const Poll20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Poll20RegularIcon, 'Poll20Regular');

const Poll24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.75 2a2.75 2.75 0 012.75 2.75v14.5a2.75 2.75 0 11-5.5 0V4.75A2.75 2.75 0 0111.75 2zm7 5a2.75 2.75 0 012.75 2.75v9.5a2.75 2.75 0 11-5.5 0v-9.5A2.75 2.75 0 0118.75 7zm-14 5a2.75 2.75 0 012.75 2.75v4.5a2.75 2.75 0 01-5.5 0v-4.5A2.75 2.75 0 014.75 12z",
    fill: primaryFill
  }));
};

export const Poll24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Poll24FilledIcon, 'Poll24Filled');

const Poll24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.75 2a2.75 2.75 0 012.75 2.75v14.5a2.75 2.75 0 11-5.5 0V4.75A2.75 2.75 0 0111.75 2zm7 5a2.75 2.75 0 012.75 2.75v9.5a2.75 2.75 0 11-5.5 0v-9.5A2.75 2.75 0 0118.75 7zm-14 5a2.75 2.75 0 012.75 2.75v4.5a2.75 2.75 0 01-5.5 0v-4.5A2.75 2.75 0 014.75 12zm7-8.5c-.69 0-1.25.56-1.25 1.25v14.5a1.25 1.25 0 002.5 0V4.75c0-.69-.56-1.25-1.25-1.25zm7 5c-.69 0-1.25.56-1.25 1.25v9.5a1.25 1.25 0 002.5 0v-9.5c0-.69-.56-1.25-1.25-1.25zm-14 5c-.69 0-1.25.56-1.25 1.25v4.5a1.25 1.25 0 102.5 0v-4.5c0-.69-.56-1.25-1.25-1.25z",
    fill: primaryFill
  }));
};

export const Poll24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Poll24RegularIcon, 'Poll24Regular');

const PortHdmi20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.85 7.44A1.5 1.5 0 015.91 7h8.18c.4 0 .78.16 1.06.44l2.41 2.41c.28.28.44.67.44 1.06v.59c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 012 11.5v-.59c0-.4.16-.78.44-1.06l2.41-2.41zM6.5 9.5a.5.5 0 000 1h7a.5.5 0 000-1h-7z",
    fill: primaryFill
  }));
};

export const PortHdmi20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortHdmi20FilledIcon, 'PortHdmi20Filled');

const PortHdmi20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.85 7.44A1.5 1.5 0 015.91 7h8.18c.4 0 .78.16 1.06.44l2.41 2.41c.28.28.44.67.44 1.06v.59c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 012 11.5v-.59c0-.4.16-.78.44-1.06l2.41-2.41zM5.91 8a.5.5 0 00-.35.15l-2.41 2.41a.5.5 0 00-.15.35v.59c0 .28.22.5.5.5h13a.5.5 0 00.5-.5v-.59a.5.5 0 00-.15-.35l-2.41-2.41a.5.5 0 00-.35-.15H5.9zM6 10c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7A.5.5 0 016 10z",
    fill: primaryFill
  }));
};

export const PortHdmi20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortHdmi20RegularIcon, 'PortHdmi20Regular');

const PortHdmi24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.41 11.41l-2.82-2.82A2 2 0 0017.17 8H6.83a2 2 0 00-1.42.59l-2.82 2.82A2 2 0 002 12.83V14a2 2 0 002 2h16a2 2 0 002-2v-1.17a2 2 0 00-.59-1.42zM17 12a.75.75 0 01-.75.75h-8.5a.75.75 0 110-1.5h8.5A.76.76 0 0117 12z",
    fill: primaryFill
  }));
};

export const PortHdmi24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortHdmi24FilledIcon, 'PortHdmi24Filled');

const PortHdmi24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.41 11.41L18.6 8.6A2 2 0 0017.17 8H6.83a2 2 0 00-1.42.59L2.6 11.4A2 2 0 002 12.83V14a2 2 0 002 2h16a2 2 0 002-2v-1.17a2 2 0 00-.59-1.42zM20.5 14a.5.5 0 01-.5.5H4a.5.5 0 01-.5-.5v-1.17a.5.5 0 01.15-.36l2.82-2.82a.5.5 0 01.36-.15h10.34a.5.5 0 01.36.15l2.82 2.82a.5.5 0 01.15.36V14zm-4.25-2.75h-8.5a.75.75 0 100 1.5h8.5a.75.75 0 100-1.5z",
    fill: primaryFill
  }));
};

export const PortHdmi24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortHdmi24RegularIcon, 'PortHdmi24Regular');

const PortMicroUsb20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.43 8.3c.26-.2.58-.3.9-.3h5.34c.32 0 .64.1.9.3l1.33 1A1.5 1.5 0 0114 12H6a1.5 1.5 0 01-.9-2.7l1.33-1z",
    fill: primaryFill
  }));
};

export const PortMicroUsb20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortMicroUsb20FilledIcon, 'PortMicroUsb20Filled');

const PortMicroUsb20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.43 8.3c.26-.2.58-.3.9-.3h5.34c.32 0 .64.1.9.3l1.33 1A1.5 1.5 0 0114 12H6a1.5 1.5 0 01-.9-2.7l1.33-1zm.9.7a.5.5 0 00-.3.1l-1.33 1a.5.5 0 00.3.9h8a.5.5 0 00.3-.9l-1.33-1a.5.5 0 00-.3-.1H7.33z",
    fill: primaryFill
  }));
};

export const PortMicroUsb20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortMicroUsb20RegularIcon, 'PortMicroUsb20Regular');

const PortMicroUsb24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 12.83V13a2 2 0 01-2 2H7a2 2 0 01-2-2v-.17a2 2 0 01.59-1.42l1.82-1.82A2 2 0 018.83 9h6.34a2 2 0 011.42.59l1.82 1.82a2 2 0 01.59 1.42z",
    fill: primaryFill
  }));
};

export const PortMicroUsb24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortMicroUsb24FilledIcon, 'PortMicroUsb24Filled');

const PortMicroUsb24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.17 10.5a.5.5 0 01.36.15l1.82 1.82a.5.5 0 01.15.36V13a.5.5 0 01-.5.5H7a.5.5 0 01-.5-.5v-.17a.5.5 0 01.15-.36l1.82-1.82a.5.5 0 01.36-.15h6.34zm0-1.5H8.83a2 2 0 00-1.42.59L5.6 11.4A2 2 0 005 12.83V13a2 2 0 002 2h10a2 2 0 002-2v-.17a2 2 0 00-.59-1.42L16.6 9.6A2 2 0 0015.17 9z",
    fill: primaryFill
  }));
};

export const PortMicroUsb24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortMicroUsb24RegularIcon, 'PortMicroUsb24Regular');

const PortUsbA20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 7C3.67 7 3 7.67 3 8.5v3c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-11zm0 1.5h11V10h-11V8.5z",
    fill: primaryFill
  }));
};

export const PortUsbA20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortUsbA20FilledIcon, 'PortUsbA20Filled');

const PortUsbA20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 7C3.67 7 3 7.67 3 8.5v3c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-11zM4 8.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5V10H4V8.5z",
    fill: primaryFill
  }));
};

export const PortUsbA20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortUsbA20RegularIcon, 'PortUsbA20Regular');

const PortUsbA24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 8H6a2 2 0 00-2 2v4a2 2 0 002 2h12a2 2 0 002-2v-4a2 2 0 00-2-2zM6 10h12v2H6v-2z",
    fill: primaryFill
  }));
};

export const PortUsbA24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortUsbA24FilledIcon, 'PortUsbA24Filled');

const PortUsbA24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 8H6a2 2 0 00-2 2v4a2 2 0 002 2h12a2 2 0 002-2v-4a2 2 0 00-2-2zM5.5 10a.5.5 0 01.5-.5h12a.5.5 0 01.5.5v2h-13v-2z",
    fill: primaryFill
  }));
};

export const PortUsbA24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortUsbA24RegularIcon, 'PortUsbA24Regular');

const PortUsbC20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 10c0-1.1.9-2 2-2h7a2 2 0 110 4h-7a2 2 0 01-2-2z",
    fill: primaryFill
  }));
};

export const PortUsbC20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortUsbC20FilledIcon, 'PortUsbC20Filled');

const PortUsbC20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 10c0-1.1.9-2 2-2h7a2 2 0 110 4h-7a2 2 0 01-2-2zm2-1a1 1 0 000 2h7a1 1 0 100-2h-7z",
    fill: primaryFill
  }));
};

export const PortUsbC20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortUsbC20RegularIcon, 'PortUsbC20Regular');

const PortUsbC24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 12a3 3 0 01-3 3H8a3 3 0 010-6h8a3 3 0 013 3z",
    fill: primaryFill
  }));
};

export const PortUsbC24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortUsbC24FilledIcon, 'PortUsbC24Filled');

const PortUsbC24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 10.5a1.5 1.5 0 110 3H8a1.5 1.5 0 110-3h8zM16 9H8a3 3 0 100 6h8a3 3 0 000-6z",
    fill: primaryFill
  }));
};

export const PortUsbC24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PortUsbC24RegularIcon, 'PortUsbC24Regular');

const PositionBackward20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.5A2.5 2.5 0 014.5 2h6A2.5 2.5 0 0113 4.5V6H9.5A3.5 3.5 0 006 9.5V13H4.5A2.5 2.5 0 012 10.5v-6zM9.5 7A2.5 2.5 0 007 9.5v6A2.5 2.5 0 009.5 18h6a2.5 2.5 0 002.5-2.5v-6A2.5 2.5 0 0015.5 7h-6zM8 9.5C8 8.67 8.67 8 9.5 8h6c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 018 15.5v-6z",
    fill: primaryFill
  }));
};

export const PositionBackward20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionBackward20FilledIcon, 'PositionBackward20Filled');

const PositionBackward20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 002 4.5v6A2.5 2.5 0 004.5 13H6v-1.7l-.7.7h-.8a1.5 1.5 0 01-.65-.15L6 9.71V9.5c0-.57.14-1.11.38-1.59l-3.23 3.24A1.5 1.5 0 013 10.5v-.94L9.56 3h.94c.23 0 .45.05.65.15L7.9 6.38A3.49 3.49 0 019.5 6h.2l2.15-2.15c.1.2.15.42.15.65v.8l-.7.7H13V4.5A2.5 2.5 0 0010.5 2h-6zM3 4.5C3 3.67 3.67 3 4.5 3h.65L3 5.15V4.5zm0 2.06L6.56 3h1.59L3 8.15V6.56zM7 9.5A2.5 2.5 0 019.5 7h6A2.5 2.5 0 0118 9.5v6a2.5 2.5 0 01-2.5 2.5h-6A2.5 2.5 0 017 15.5v-6zM9.5 8C8.67 8 8 8.67 8 9.5v6c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5h-6z",
    fill: primaryFill
  }));
};

export const PositionBackward20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionBackward20RegularIcon, 'PositionBackward20Regular');

const PositionBackward24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.5 6.5h-5.75a4.25 4.25 0 00-4.25 4.25v5.75H5.25A3.25 3.25 0 012 13.25v-8C2 3.45 3.46 2 5.25 2h8c1.8 0 3.25 1.46 3.25 3.25V6.5zM22 18.75c0 1.8-1.46 3.25-3.25 3.25h-8a3.25 3.25 0 01-3.25-3.25v-8c0-1.8 1.46-3.25 3.25-3.25h8c1.8 0 3.25 1.46 3.25 3.25v8zm-3.25 1.75c.97 0 1.75-.78 1.75-1.75v-8c0-.97-.78-1.75-1.75-1.75h-8C9.78 9 9 9.78 9 10.75v8c0 .97.78 1.75 1.75 1.75h8z",
    fill: primaryFill
  }));
};

export const PositionBackward24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionBackward24FilledIcon, 'PositionBackward24Filled');

const PositionBackward24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 16.5H5.25A3.25 3.25 0 012 13.25v-8C2 3.45 3.46 2 5.25 2h8c1.8 0 3.25 1.46 3.25 3.25V6.5h-1.65l.15-.15v-1.1c0-.23-.04-.45-.13-.65l-1.9 1.9h-2.12l2.92-2.92a1.75 1.75 0 00-.52-.08h-1.28L3.5 11.97v1.28c0 .18.03.36.08.52l2.92-2.92v2.12l-1.9 1.9c.2.09.42.13.65.13h1.1l.15-.15v1.65zm3.35-13H7.97L3.5 7.97v1.88L9.85 3.5zm-4 0h-.6c-.97 0-1.75.78-1.75 1.75v.6L5.85 3.5zM22 18.75c0 1.8-1.46 3.25-3.25 3.25h-8a3.25 3.25 0 01-3.25-3.25v-8c0-1.8 1.46-3.25 3.25-3.25h8c1.8 0 3.25 1.46 3.25 3.25v8zm-3.25 1.75c.97 0 1.75-.78 1.75-1.75v-8c0-.97-.78-1.75-1.75-1.75h-8C9.78 9 9 9.78 9 10.75v8c0 .97.78 1.75 1.75 1.75h8z",
    fill: primaryFill
  }));
};

export const PositionBackward24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionBackward24RegularIcon, 'PositionBackward24Regular');

const PositionForward20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 14v1.5A2.5 2.5 0 009.5 18h6a2.5 2.5 0 002.5-2.5v-6A2.5 2.5 0 0015.5 7H14v1h1.5c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 018 15.5V14H7zM2 4.5A2.5 2.5 0 014.5 2h6A2.5 2.5 0 0113 4.5v6a2.5 2.5 0 01-2.5 2.5h-6A2.5 2.5 0 012 10.5v-6z",
    fill: primaryFill
  }));
};

export const PositionForward20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionForward20FilledIcon, 'PositionForward20Filled');

const PositionForward20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 14v1.5A2.5 2.5 0 009.5 18h6a2.5 2.5 0 002.5-2.5v-6A2.5 2.5 0 0015.5 7H14v1h1.5c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 018 15.5V14H7zM2 4.5A2.5 2.5 0 014.5 2h6A2.5 2.5 0 0113 4.5v6a2.5 2.5 0 01-2.5 2.5h-6A2.5 2.5 0 012 10.5v-6zM4.5 3C3.67 3 3 3.67 3 4.5v.65L5.15 3H4.5zm2.06 0L3 6.56v1.59L8.15 3H6.56zM3 10.5c0 .23.05.45.15.65l8-8A1.5 1.5 0 0010.5 3h-.94L3 9.56v.94zM4.5 12h.8L12 5.3v-.8c0-.23-.05-.45-.15-.65l-8 8c.2.1.42.15.65.15zm5.2 0h.8c.83 0 1.5-.67 1.5-1.5v-.8L9.7 12zm-1.4 0L12 8.3V6.7L6.7 12h1.6z",
    fill: primaryFill
  }));
};

export const PositionForward20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionForward20RegularIcon, 'PositionForward20Regular');

const PositionForward24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.25 16.5c1.8 0 3.25-1.46 3.25-3.25v-8c0-1.8-1.46-3.25-3.25-3.25h-8A3.25 3.25 0 002 5.25v8c0 1.8 1.46 3.25 3.25 3.25h8zm-5.75 1H9v1.25c0 .97.78 1.75 1.75 1.75h8c.97 0 1.75-.78 1.75-1.75v-8c0-.97-.78-1.75-1.75-1.75H17.5V7.5h1.25c1.8 0 3.25 1.46 3.25 3.25v8c0 1.8-1.46 3.25-3.25 3.25h-8a3.25 3.25 0 01-3.25-3.25V17.5z",
    fill: primaryFill
  }));
};

export const PositionForward24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionForward24FilledIcon, 'PositionForward24Filled');

const PositionForward24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.75 22c1.8 0 3.25-1.46 3.25-3.25v-8c0-1.8-1.46-3.25-3.25-3.25H17.5V9h1.25c.97 0 1.75.78 1.75 1.75v8c0 .97-.78 1.75-1.75 1.75h-8c-.97 0-1.75-.78-1.75-1.75V17.5H7.5v1.25c0 1.8 1.46 3.25 3.25 3.25h8zm-5.5-5.5c1.8 0 3.25-1.46 3.25-3.25v-8c0-1.8-1.46-3.25-3.25-3.25h-8A3.25 3.25 0 002 5.25v8c0 1.8 1.46 3.25 3.25 3.25h8zM15 13.25c0 .97-.78 1.75-1.75 1.75h-.78L15 12.47v.78zm0-2.78L10.47 15h-2L15 8.47v2zM6.35 15h-1.1c-.23 0-.45-.04-.65-.13L14.87 4.6c.09.2.13.42.13.65v1.1L6.35 15zm-2.77-1.23a1.75 1.75 0 01-.08-.52v-1.28l8.47-8.47h1.28c.18 0 .36.03.52.08L3.57 13.77zM3.5 9.85V7.97L7.97 3.5h1.88L3.5 9.85zm0-4v-.6c0-.97.78-1.75 1.75-1.75h.6L3.5 5.85z",
    fill: primaryFill
  }));
};

export const PositionForward24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionForward24RegularIcon, 'PositionForward24Regular');

const PositionToBack20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 14c0-1.1.9-2 2-2h3a2 2 0 012 2v3a2 2 0 01-2 2h-3a2 2 0 01-2-2v-3zm2-1a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-1-1h-3zM5 9h1.3C7.8 9 9 7.8 9 6.3V5h3.5A2.5 2.5 0 0115 7.5V11h-1.3a2.7 2.7 0 00-2.7 2.7V15H7.5A2.5 2.5 0 015 12.5V9zM1 3c0-1.1.9-2 2-2h3a2 2 0 012 2v3a2 2 0 01-2 2H3a2 2 0 01-2-2V3zm2-1a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V3a1 1 0 00-1-1H3z",
    fill: primaryFill
  }));
};

export const PositionToBack20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionToBack20FilledIcon, 'PositionToBack20Filled');

const PositionToBack20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 14c0-1.1.9-2 2-2h3a2 2 0 012 2v3a2 2 0 01-2 2h-3a2 2 0 01-2-2v-3zm2-1a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-1-1h-3zM5 9v3.5A2.5 2.5 0 007.5 15H11v-1H9.7l1.67-1.66c.23-.4.57-.74.97-.97L14 9.7V11h1V7.5A2.5 2.5 0 0012.5 5H9v1h1.3L8.62 7.66c-.23.4-.57.74-.97.97L6 10.3V9H5zm6.7-3h.8c.23 0 .45.05.65.15l-7 7A1.5 1.5 0 016 12.5v-.8L11.7 6zm-4.2 8a1.5 1.5 0 01-.65-.15l7-7c.1.2.15.42.15.65v.8L8.3 14h-.8zM1 3c0-1.1.9-2 2-2h3a2 2 0 012 2v3a2 2 0 01-2 2H3a2 2 0 01-2-2V3zm2-1a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V3a1 1 0 00-1-1H3z",
    fill: primaryFill
  }));
};

export const PositionToBack20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionToBack20RegularIcon, 'PositionToBack20Regular');

const PositionToBack24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 11h1.25A3.75 3.75 0 0011 7.25V6h3.75C16.55 6 18 7.46 18 9.25V13h-1.25A3.75 3.75 0 0013 16.75V18H9.25A3.25 3.25 0 016 14.75V11zM1 3.75A2.75 2.75 0 013.75 1h3.5A2.75 2.75 0 0110 3.75v3.5A2.75 2.75 0 017.25 10h-3.5A2.75 2.75 0 011 7.25v-3.5zM3.75 2.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25h-3.5zM14 16.75A2.75 2.75 0 0116.75 14h3.5A2.75 2.75 0 0123 16.75v3.5A2.75 2.75 0 0120.25 23h-3.5A2.75 2.75 0 0114 20.25v-3.5zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25h-3.5z",
    fill: primaryFill
  }));
};

export const PositionToBack24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionToBack24FilledIcon, 'PositionToBack24Filled');

const PositionToBack24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 16.75A2.75 2.75 0 0116.75 14h3.5A2.75 2.75 0 0123 16.75v3.5A2.75 2.75 0 0120.25 23h-3.5A2.75 2.75 0 0114 20.25v-3.5zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25h-3.5zM6 11v3.75C6 16.55 7.46 18 9.25 18H13v-1.25-.25h-.32l.37-.37a3.75 3.75 0 013.08-3.08l.37-.37v.33l.25-.01H18V9.25C18 7.45 16.54 6 14.75 6H11v1.5h.56l-.68.68a3.76 3.76 0 01-2.7 2.7l-.68.68V11l-.25.01H6zm7.68-3.5h1.07c.24 0 .47.05.68.14l-7.8 7.79c-.08-.21-.13-.44-.13-.68v-1.07l6.18-6.18zm-4.43 9c-.17 0-.34-.02-.5-.07l7.68-7.68c.05.16.07.33.07.5v1.31l-5.94 5.94H9.25zM1 3.75A2.75 2.75 0 013.75 1h3.5A2.75 2.75 0 0110 3.75v3.5A2.75 2.75 0 017.25 10h-3.5A2.75 2.75 0 011 7.25v-3.5zM3.75 2.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25h-3.5z",
    fill: primaryFill
  }));
};

export const PositionToBack24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionToBack24RegularIcon, 'PositionToBack24Regular');

const PositionToFront20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 3c0-1.1.9-2 2-2h3a2 2 0 012 2v1h-.5c-.17 0-.34.01-.5.04V3a1 1 0 00-1-1H3a1 1 0 00-1 1v3a1 1 0 001 1h1.04C4 7.16 4 7.33 4 7.5V8H3a2 2 0 01-2-2V3zm11 13v1c0 1.1.9 2 2 2h3a2 2 0 002-2v-3a2 2 0 00-2-2h-1v.5c0 .17-.01.34-.04.5H17a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1.04c-.16.03-.33.04-.5.04H12zM5 7.5A2.5 2.5 0 017.5 5h5A2.5 2.5 0 0115 7.5v5a2.5 2.5 0 01-2.5 2.5h-5A2.5 2.5 0 015 12.5v-5z",
    fill: primaryFill
  }));
};

export const PositionToFront20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionToFront20FilledIcon, 'PositionToFront20Filled');

const PositionToFront20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 1a2 2 0 00-2 2v3c0 1.1.9 2 2 2h1v-.5c0-.17.01-.34.04-.5H3a1 1 0 01-1-1V3a1 1 0 011-1h3a1 1 0 011 1v1.04C7.16 4 7.33 4 7.5 4H8V3a2 2 0 00-2-2H3zm9 16v-1h.5c.17 0 .34-.01.5-.04V17a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-1-1h-1.04c.03-.16.04-.33.04-.5V12h1a2 2 0 012 2v3a2 2 0 01-2 2h-3a2 2 0 01-2-2zM5 7.5A2.5 2.5 0 017.5 5h5A2.5 2.5 0 0115 7.5v5a2.5 2.5 0 01-2.5 2.5h-5A2.5 2.5 0 015 12.5v-5zm2.28-1.48a1.5 1.5 0 00-1.26 1.26l1.26-1.26zM6 10.29L10.3 6H8.7L6 8.7v1.6zM11.7 6L6 11.7v.8c0 .23.05.45.15.65l7-7A1.5 1.5 0 0012.5 6h-.8zm-4.2 8h.8L14 8.3v-.8c0-.23-.05-.45-.15-.65l-7 7c.2.1.42.15.65.15zm2.2 0h1.6l2.7-2.7V9.7L9.7 14zm3.02-.02a1.5 1.5 0 001.26-1.26l-1.26 1.26z",
    fill: primaryFill
  }));
};

export const PositionToFront20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionToFront20RegularIcon, 'PositionToFront20Regular');

const PositionToFront24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 3.75A2.75 2.75 0 013.75 1h3.5A2.75 2.75 0 0110 3.75V5h-.75c-.26 0-.5.02-.75.07V3.75c0-.69-.56-1.25-1.25-1.25h-3.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h1.32c-.05.24-.07.5-.07.75V10H3.75A2.75 2.75 0 011 7.25v-3.5zM14 19v1.25A2.75 2.75 0 0016.75 23h3.5A2.75 2.75 0 0023 20.25v-3.5A2.75 2.75 0 0020.25 14H19v.75c0 .26-.02.5-.07.75h1.32c.69 0 1.25.56 1.25 1.25v3.5c0 .69-.56 1.25-1.25 1.25h-3.5c-.69 0-1.25-.56-1.25-1.25v-1.32c-.24.05-.5.07-.75.07H14zM6 9.25C6 7.45 7.46 6 9.25 6h5.5C16.55 6 18 7.46 18 9.25v5.5c0 1.8-1.46 3.25-3.25 3.25h-5.5A3.25 3.25 0 016 14.75v-5.5z",
    fill: primaryFill
  }));
};

export const PositionToFront24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionToFront24FilledIcon, 'PositionToFront24Filled');

const PositionToFront24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 3.75A2.75 2.75 0 013.75 1h3.5A2.75 2.75 0 0110 3.75V5h-.75c-.26 0-.5.02-.75.07V3.75c0-.69-.56-1.25-1.25-1.25h-3.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h1.32c-.05.24-.07.5-.07.75V10H3.75A2.75 2.75 0 011 7.25v-3.5zM14 19v1.25A2.75 2.75 0 0016.75 23h3.5A2.75 2.75 0 0023 20.25v-3.5A2.75 2.75 0 0020.25 14H19v.75c0 .26-.02.5-.07.75h1.32c.69 0 1.25.56 1.25 1.25v3.5c0 .69-.56 1.25-1.25 1.25h-3.5c-.69 0-1.25-.56-1.25-1.25v-1.32c-.24.05-.5.07-.75.07H14zM9.25 6A3.25 3.25 0 006 9.25v5.5C6 16.55 7.46 18 9.25 18h5.5c1.8 0 3.25-1.46 3.25-3.25v-5.5C18 7.45 16.54 6 14.75 6h-5.5zm2.31 1.5L7.5 11.56V9.68L9.68 7.5h1.88zM7.5 13.68l6.18-6.18h1.07c.24 0 .47.05.68.14l-7.8 7.79c-.08-.21-.13-.44-.13-.68v-1.07zm1.25 2.75l7.68-7.68c.05.16.07.33.07.5v1.31l-5.94 5.94H9.25c-.17 0-.34-.02-.5-.07zm5.94.07h-2l3.81-3.82v2.07l-.03-.03-1.78 1.78z",
    fill: primaryFill
  }));
};

export const PositionToFront24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PositionToFront24RegularIcon, 'PositionToFront24Regular');

const Power20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.75 2.5a.75.75 0 00-1.5 0v6a.75.75 0 001.5 0v-6zm3 1.5a.75.75 0 10-.76 1.3A6 6 0 117 5.3.75.75 0 106.25 4a7.5 7.5 0 107.5 0z",
    fill: primaryFill
  }));
};

export const Power20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Power20FilledIcon, 'Power20Filled');

const Power20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 2.5a.5.5 0 00-1 0v6a.5.5 0 001 0v-6zM13.74 4a.5.5 0 10-.5.87 6.5 6.5 0 11-6.49 0 .5.5 0 10-.5-.87 7.5 7.5 0 107.5 0z",
    fill: primaryFill
  }));
};

export const Power20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Power20RegularIcon, 'Power20Regular');

const Power24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.2 4.84a1 1 0 01.85 1.82 7 7 0 105.92 0 1 1 0 01.84-1.8 9 9 0 11-7.6-.02zM12 2a1 1 0 011 .88V10a1 1 0 01-2 .12V3a1 1 0 011-1z",
    fill: primaryFill
  }));
};

export const Power24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Power24FilledIcon, 'Power24Filled');

const Power24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.2 4.82a.75.75 0 01.64 1.36 7.51 7.51 0 106.34 0 .75.75 0 11.63-1.35 9 9 0 11-7.6-.01zM12 2.5c.38 0 .7.28.74.64v7.6a.75.75 0 01-1.48.1l-.01-.1v-7.5c0-.4.33-.74.75-.74z",
    fill: primaryFill
  }));
};

export const Power24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Power24RegularIcon, 'Power24Regular');

const Power28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 3a1 1 0 10-2 0v9a1 1 0 102 0V3zm-4.6 3.75a1 1 0 10-.8-1.83 11 11 0 108.8 0 1 1 0 00-.8 1.83 9 9 0 11-7.2 0z",
    fill: primaryFill
  }));
};

export const Power28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Power28FilledIcon, 'Power28Filled');

const Power28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.69 5.27a.75.75 0 01-.4.98 9.5 9.5 0 107.42 0 .75.75 0 01.58-1.38 11 11 0 11-8.58 0c.38-.16.82.02.98.4zM14 2c.41 0 .75.34.75.75v9.5a.75.75 0 01-1.5 0v-9.5c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const Power28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Power28RegularIcon, 'Power28Regular');

const Predictions20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 1c.28 0 .5.22.5.5 0 .46.07 1.22.47 1.84.38.6 1.08 1.14 2.53 1.14a.5.5 0 110 1 3.5 3.5 0 00-1.82.73A2.77 2.77 0 0015 8.45a.5.5 0 01-.5.5.5.5 0 01-.5-.5c0-.5-.16-1.26-.6-1.88-.44-.6-1.16-1.1-2.4-1.1a.5.5 0 01-.5-.5c0-.27.22-.5.5-.5.51 0 1.25 0 1.87-.36.57-.33 1.13-1 1.13-2.61 0-.28.22-.5.5-.5zM6.15 12.17l-.94 3.4c-.17.61.08 1.34.74 1.63 1.64.73 4.65 1.35 7.97.01a1.43 1.43 0 00.82-1.75l-.98-3.23a6.5 6.5 0 01-7.61-.06zm6.77-9.84c-.04.22-.1.38-.16.5a.97.97 0 01-.4.42c-.34.2-.82.23-1.36.23a1.5 1.5 0 100 2.98c.91 0 1.34.35 1.58.7.3.4.42.95.42 1.3a1.5 1.5 0 001.61 1.48A5.5 5.5 0 014.5 6.96a5.48 5.48 0 018.42-4.63z",
    fill: primaryFill
  }));
};

export const Predictions20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Predictions20FilledIcon, 'Predictions20Filled');

const Predictions20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 1c.28 0 .5.22.5.5 0 .46.07 1.22.47 1.84.38.6 1.08 1.14 2.53 1.14a.5.5 0 110 1 3.5 3.5 0 00-1.82.73A2.77 2.77 0 0015 8.45a.5.5 0 01-.5.5.5.5 0 01-.5-.5c0-.5-.16-1.26-.6-1.88-.44-.6-1.16-1.1-2.4-1.1a.5.5 0 01-.5-.5c0-.27.22-.5.5-.5.51 0 1.25 0 1.87-.36.57-.33 1.13-1 1.13-2.61 0-.28.22-.5.5-.5zm.04 2.73a2.95 2.95 0 01-1.33 1.33 3.53 3.53 0 011.33 1.48 4.2 4.2 0 011.52-1.44 3.22 3.22 0 01-1.52-1.37zm-7.26 6.8A4.46 4.46 0 0110 2.5c.9 0 1.74.26 2.44.72a.99.99 0 00.32-.38c.06-.12.12-.28.16-.5A5.5 5.5 0 004.5 6.96c0 1.67.75 3.16 1.93 4.16l-1.22 4.44c-.17.62.08 1.35.74 1.64 1.64.73 4.65 1.35 7.97.01a1.43 1.43 0 00.82-1.75l-1.26-4.17a.49.49 0 00-.03-.07c.45-.36.85-.8 1.16-1.28a1.53 1.53 0 01-1.01-.3 4.5 4.5 0 01-6.32.89zm5.3 1.26l1.2 3.96c.07.24-.05.46-.23.54a9.36 9.36 0 01-7.19 0c-.14-.06-.24-.24-.18-.47l1.12-4.1a5.5 5.5 0 005.28.07z",
    fill: primaryFill
  }));
};

export const Predictions20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Predictions20RegularIcon, 'Predictions20Regular');

const Predictions24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.68 14.93l1.29 3.85c.26.8-.08 1.67-.81 2.08-1.37.77-3.1 1.14-5.16 1.14s-3.79-.37-5.16-1.14a1.75 1.75 0 01-.8-2.08l1.28-3.85a7.72 7.72 0 009.36 0zM12 2c1.34 0 2.58.39 3.63 1.06-.08.31-.2.54-.37.7-.25.26-.68.42-1.32.47l-.22.02h-.38c-2.17.16-2.12 3.5.16 3.5.89 0 1.46.18 1.76.49.26.25.42.68.47 1.32l.02.22v.38c.1 1.32 1.36 1.81 2.34 1.5A6.75 6.75 0 1112 2zm6.25 0c0 1.15.27 1.96.78 2.47.47.47 1.2.74 2.21.78h.26c.96 0 1 1.38.12 1.5h-.12c-1.15 0-1.96.27-2.47.78-.47.47-.74 1.2-.78 2.21V10c0 1-1.5 1-1.5 0 0-1.15-.27-1.96-.78-2.47-.47-.47-1.2-.74-2.21-.78h-.26c-.96 0-1-1.38-.12-1.5h.12c1.15 0 1.96-.27 2.47-.78.51-.51.78-1.32.78-2.47 0-1 1.5-1 1.5 0z",
    fill: primaryFill
  }));
};

export const Predictions24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Predictions24FilledIcon, 'Predictions24Filled');

const Predictions24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 2c1.15 0 2.24.29 3.19.8-.08.45-.23.76-.43.96-.1.11-.25.2-.43.28A5.25 5.25 0 1011.77 14L12 14a5.28 5.28 0 004.38-2.35c.64.22 1.4.08 1.9-.4a6.76 6.76 0 01-1.93 2.67l1.62 4.86c.26.8-.08 1.67-.81 2.08-1.37.77-3.1 1.14-5.16 1.14s-3.79-.37-5.16-1.14a1.75 1.75 0 01-.8-2.08l1.61-4.86A6.74 6.74 0 0112 2zm3.06 12.8l-.36.14h-.02c-.73.32-1.52.51-2.35.55H12.24l-.24.01h-.33a6.68 6.68 0 01-2.35-.55l-.02-.01-.36-.15-1.48 4.46c-.04.12 0 .24.11.3 1.13.63 2.6.95 4.43.95 1.83 0 3.3-.32 4.43-.95.1-.06.15-.18.11-.3l-1.48-4.46zm-3.37.7H12h-.31zm6.3-13.62L18 2c0 1.15.27 1.96.78 2.47.47.47 1.2.74 2.21.78h.26c.96 0 1 1.38.12 1.5h-.12c-1.15 0-1.96.27-2.47.78-.47.47-.74 1.2-.78 2.21V10c0 1-1.5 1-1.5 0 0-1.15-.27-1.96-.78-2.47-.47-.47-1.2-.74-2.21-.78h-.26c-.96 0-1-1.38-.12-1.5h.12c1.15 0 1.96-.27 2.47-.78.51-.51.78-1.32.78-2.47 0-.96 1.38-1 1.5-.12zm-.74 3.07l-.14.2a3.6 3.6 0 01-.9.85 3.64 3.64 0 011.04 1.05A3.64 3.64 0 0118.3 6a3.64 3.64 0 01-.9-.84l-.15-.2z",
    fill: primaryFill
  }));
};

export const Predictions24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Predictions24RegularIcon, 'Predictions24Regular');

const Premium12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 1h1.05L3 4H1.2l1.35-2.72A.5.5 0 013 1zM1.23 5l3.01 4.69L2.97 5H1.23zM4 5l1.53 5.65a.48.48 0 00.92 0L8 5H4zm5.02 0L7.76 9.69 10.77 5H9.03zm1.78-1H9L7.96 1H9c.19 0 .36.1.45.28L10.8 4zM7.95 4h-3.9l1.06-3H6.9l1.05 3z",
    fill: primaryFill
  }));
};

export const Premium12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Premium12FilledIcon, 'Premium12Filled');

const Premium12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.99 1H5 3a.5.5 0 00-.45.28l-1.5 3a.5.5 0 00.05.52l4.5 6a.49.49 0 00.22.16.5.5 0 00.59-.17L10.9 4.8a.5.5 0 00.05-.52l-1.5-3A.5.5 0 009 1H7.01 7zm-.35 1l.67 2H4.69l.67-2h1.28zm1.72 2l-.67-2h1l1 2H8.36zM7.31 5L6 8.92 4.7 5h2.6zm.14 2.74L8.36 5H9.5L7.45 7.74zm-2.9 0L2.5 5h1.14l.91 2.74zM3.64 4H2.31l1-2h1l-.67 2z",
    fill: primaryFill
  }));
};

export const Premium12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Premium12RegularIcon, 'Premium12Regular');

const Premium16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.75 2a.75.75 0 00-.66.4l-2 3.75a.75.75 0 00.07.81l6.25 8a.75.75 0 001.18 0l6.25-8a.75.75 0 00.07-.81l-2-3.75a.75.75 0 00-.66-.4h-8.5zm-.88 4L4.2 3.5h1.28L4.85 6H2.87zm.61 1.5h1.55l1.03 3.3-2.58-3.3zm3.12 0h2.8L8 11.99 6.6 7.5zm4.37 0h1.55l-2.58 3.3 1.03-3.3zM13.13 6h-1.98l-.63-2.5h1.28L13.13 6zM9.6 6H6.4l.62-2.5h1.96L9.6 6z",
    fill: primaryFill
  }));
};

export const Premium16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Premium16FilledIcon, 'Premium16Filled');

const Premium16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 2a.5.5 0 00-.45.28l-2 4a.5.5 0 00.06.54l6.5 8a.5.5 0 00.78 0l6.5-8a.5.5 0 00.06-.54l-2-4A.5.5 0 0012.5 2h-9zM2.3 6l1.5-3h2.06l-.75 3h-2.8zm.25 1h2.58l1.62 5.16L2.55 7zm3.63 0h3.64L8 12.82 6.18 7zm4.69 0h2.58l-4.2 5.16L10.87 7zm2.82-1h-2.8l-.75-3h2.05l1.5 3zM9.86 6H6.14l.75-3h2.22l.75 3z",
    fill: primaryFill
  }));
};

export const Premium16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Premium16RegularIcon, 'Premium16Regular');

const Premium20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2.75a.75.75 0 00-.66.39l-2.75 5c-.15.27-.11.6.08.84l7.25 8.75a.75.75 0 001.16 0l7.25-8.75c.2-.24.23-.57.08-.84l-2.75-5a.75.75 0 00-.66-.39h-9zM4.16 7.5l1.78-3.25h1.5L6.31 7.5H4.16zM6.14 9l1.93 4.75L4.14 9h2zM10 14.48L7.76 9h4.39l-2.16 5.48zM7.89 7.5l1.14-3.25h1.95l1.2 3.25H7.88zm5.88 0l-1.2-3.25h1.49l1.78 3.25h-2.07zm0 1.5h2.1l-4.01 4.83L13.76 9z",
    fill: primaryFill
  }));
};

export const Premium20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Premium20FilledIcon, 'Premium20Filled');

const Premium20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 3a.5.5 0 00-.43.24l-3 5a.5.5 0 00.05.58l7.5 9a.5.5 0 00.76 0l7.5-9a.5.5 0 00.05-.58l-3-5A.5.5 0 0014.5 3h-9zM3.38 8l2.4-4h1.98l-1.6 4H3.38zm2.78 1l2.26 5.83L3.57 9h2.59zM10 16.12L7.23 9h5.54L10 16.12zM7.24 8l1.6-4h2.32l1.6 4H7.24zm6.6 0l-1.6-4h1.98l2.4 4h-2.78zm0 1h2.6l-4.86 5.83L13.84 9z",
    fill: primaryFill
  }));
};

export const Premium20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Premium20RegularIcon, 'Premium20Regular');

const Premium24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 3a1 1 0 01.83.44l.06.11 3 6a1 1 0 01-.06 1.01l-.09.1-8.97 9.98a.99.99 0 01-.89.35l-.1-.02a.98.98 0 01-.54-.32l-8.98-9.98a1 1 0 01-.2-1l.05-.12 3-6a1 1 0 01.77-.54L6 3h12zm-3.42 8H9.42L12 17.34 14.58 11zm4.17 0h-2.02l-1.66 4.09L18.75 11zM7.26 11H5.25l3.67 4.09L7.26 11zm1.36-6h-2l-2 4h2.7l1.3-4zm4.65 0h-2.54l-1.3 4h5.14l-1.3-4zm4.11 0h-2l1.3 4h2.7l-2-4z",
    fill: primaryFill
  }));
};

export const Premium24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Premium24FilledIcon, 'Premium24Filled');

const Premium24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 3c.24 0 .46.12.6.3l.06.1 3.26 6.02.04.1.01.03.02.1v.1c0 .07 0 .14-.02.2l-.05.13-.03.06a.76.76 0 01-.08.1l.06-.07-.02.03-9.25 10.5a.72.72 0 01-.3.24l-.1.03-.08.02L12 21h-.1l-.12-.03a.72.72 0 01-.17-.08h-.01a.67.67 0 01-.13-.1l-9.3-10.55-.02-.04-.04-.06a.74.74 0 01-.1-.3L2 9.75v-.07l.02-.08.02-.1.02-.05.03-.06 3.25-6a.75.75 0 01.56-.38L6 3h12zm-3 7.5H9l3 7.69 3-7.69zm-7.61 0H4.4l5.35 6.07-2.37-6.07zm12.2 0H16.6l-2.37 6.07 5.35-6.07zm-10.62-6H6.44L4.01 9h3.52l1.44-4.5zm4.48 0h-2.9L9.1 9h5.79l-1.44-4.5zm4.1 0h-2.52L16.47 9h3.52l-2.44-4.5z",
    fill: primaryFill
  }));
};

export const Premium24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Premium24RegularIcon, 'Premium24Regular');

const Premium28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.75 3c.3 0 .6.14.78.37l.07.11 4.25 7a1 1 0 01-.01 1.06l-.08.1-11 13a1 1 0 01-1.44.1l-.08-.1-11-13a1 1 0 01-.15-1.05l.06-.1 4.25-7A1 1 0 017.12 3L7.25 3h13.5zm-3.23 9h-7.04L14 20.67 17.52 12zm5.32 0h-3.17l-2.91 7.2 6.08-7.2zM8.33 12H5.16l6.08 7.2L8.33 12zm1.34-7H7.81l-3.03 5h3.46l1.43-5zm6.58 0h-4.5l-1.43 5h7.36l-1.43-5zm3.94 0h-1.87l1.43 5h3.47L20.2 5z",
    fill: primaryFill
  }));
};

export const Premium28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Premium28FilledIcon, 'Premium28Filled');

const Premium28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.25 3c.24 0 .47.12.6.31l.06.09 4.01 7.51.04.1.01.04.02.08.01.09v.1-.07c0 .1-.02.2-.06.3l-.03.06-.04.06-.05.07L14.6 24.7a.73.73 0 01-.38.27l-.06.01-.1.02h-.16l-.08-.02-.1-.04h-.03a.7.7 0 01-.25-.19L2.17 11.73l-.06-.1-.05-.08-.03-.1-.03-.13v-.13l.02-.1v-.04l.04-.1.03-.05 4-7.5a.75.75 0 01.56-.4h14.6zm-3.34 9h-7.82L14 22.16 17.9 12zm-9.42 0h-4.1l7.37 8.52L8.5 12zm15.12 0h-4.1l-3.27 8.51L23.61 12zM10.03 4.5H7.2l-3.2 6h4.42l1.6-6zm6.4 0h-4.85l-1.6 6h8.04l-1.6-6zm4.37 0h-2.82l1.6 6H24l-3.2-6z",
    fill: primaryFill
  }));
};

export const Premium28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Premium28RegularIcon, 'Premium28Regular');

const Premium32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 4c-.48 0-.92.27-1.13.7l-3.75 7.76c-.2.43-.15.95.16 1.33l12.75 15.75a1.25 1.25 0 001.94 0l12.75-15.75c.3-.38.37-.9.16-1.33L26.13 4.7C25.92 4.27 25.48 4 25 4H7zm-1.64 7.5l2.42-5h3.7l-1.57 5H5.36zm.3 2.5h4.1l2.87 8.6L5.67 14zm6.74 0h7.2L16 24.8 12.4 14zm9.83 0h4.1l-6.96 8.6 2.86-8.6zm4.4-2.5H22.1l-1.56-5h3.69l2.42 5zm-7.16 0h-6.94l1.56-5h3.82l1.56 5z",
    fill: primaryFill
  }));
};

export const Premium32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Premium32FilledIcon, 'Premium32Filled');

const Premium32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 4a1 1 0 00-.9.55l-4 8a1 1 0 00.12 1.08l13 16a1 1 0 001.56 0l13-16a1 1 0 00.11-1.08l-4-8A1 1 0 0025 4H7zm-2.38 8l3-6h4.1l-1.5 6h-5.6zm.48 2h5.17l3.22 10.33L5.1 14zm7.26 0h7.28L16 25.65 12.36 14zm9.38 0h5.16l-8.4 10.33L21.75 14zm5.64-2h-5.6l-1.5-6h4.1l3 6zm-7.66 0h-7.44l1.5-6h4.44l1.5 6z",
    fill: primaryFill
  }));
};

export const Premium32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Premium32RegularIcon, 'Premium32Regular');

const PremiumPerson16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.75 2a.75.75 0 00-.66.4l-2 3.75a.75.75 0 00.07.81l4.93 6.32c-.06-.26-.09-.52-.09-.78 0-1 .6-1.87 1.45-2.27L6.6 7.5h.94c.1-.57.35-1.09.72-1.5H6.4l.62-2.5h1.96l.42 1.7a3 3 0 011.5-.17l-.38-1.53h1.28L13.13 6h-.4a2.99 2.99 0 01.65 2.83l1.46-1.87a.75.75 0 00.07-.81l-2-3.75a.75.75 0 00-.66-.4h-8.5zm-.88 4L4.2 3.5h1.28L4.85 6H2.87zm.61 1.5h1.55l1.03 3.3-2.58-3.3zm9.02.5a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S7 13.75 7 12.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const PremiumPerson16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PremiumPerson16FilledIcon, 'PremiumPerson16Filled');

const PremiumPerson16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 2a.5.5 0 00-.45.28l-2 4a.5.5 0 00.06.54l4.9 6.03a2.5 2.5 0 01.19-1.35L2.56 7h2.58l1.29 4.11c.2-.3.48-.57.8-.76L6.19 7h1.5a3 3 0 01.58-1H6.14l.75-3h2.22l.53 2.12a3 3 0 011-.12l-.5-2h2.05l1.5 3h-.95a3 3 0 01.59 1h.12l-.09.1a3 3 0 01.08 1.5l1.45-1.78a.5.5 0 00.06-.54l-2-4A.5.5 0 0012.5 2h-9zM2.3 6l1.5-3h2.06l-.75 3h-2.8zm10.2 2a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S7 13.75 7 12.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const PremiumPerson16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PremiumPerson16RegularIcon, 'PremiumPerson16Regular');

const PremiumPerson20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2.75a.75.75 0 00-.66.39l-2.75 5c-.15.27-.11.6.08.84l7.25 8.75a.75.75 0 001.16 0l.48-.59a3.27 3.27 0 01-.06-.64c0-1.3 1-2.38 2.27-2.49a2.99 2.99 0 01.17-4.19l.32-.82h4.05l.02-.02c.2-.24.23-.57.08-.84l-2.75-5a.75.75 0 00-.66-.39h-9zM4.16 7.5l1.78-3.25h1.5L6.31 7.5H4.16zM6.14 9l1.93 4.75L4.14 9h2zM10 14.48L7.76 9h4.39l-2.16 5.48zM7.89 7.5l1.14-3.25h1.95l1.2 3.25H7.88zm5.88 0l-1.2-3.25h1.49l1.78 3.25h-2.07zM17.5 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const PremiumPerson20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PremiumPerson20FilledIcon, 'PremiumPerson20Filled');

const PremiumPerson20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 3a.5.5 0 00-.43.24l-3 5a.5.5 0 00.05.58l7.49 9a.5.5 0 00.86-.13L13.84 9h3.9l.14-.18a.5.5 0 00.05-.58l-3-5A.5.5 0 0014.5 3h-9zm7.27 6L10 16.12 7.23 9h5.54zM3.38 8l2.4-4h1.98l-1.6 4H3.38zm2.78 1l2.26 5.83L3.57 9h2.59zm1.08-1l1.6-4h2.32l1.6 4H7.24zm6.6 0l-1.6-4h1.98l2.4 4h-2.78zm1.66 6a2 2 0 100-4 2 2 0 000 4zm0 5c2.5 0 3.5-1.25 3.5-2.5 0-.83-.67-1.5-1.5-1.5h-4c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5z",
    fill: primaryFill
  }));
};

export const PremiumPerson20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PremiumPerson20RegularIcon, 'PremiumPerson20Regular');

const PremiumPerson24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.83 3.44A1 1 0 0018 3H5.88a1 1 0 00-.77.55l-3 6-.06.13a1 1 0 00.2.99l8.99 9.98c.14.17.33.28.53.32l.11.02a1 1 0 00.89-.35l.26-.29a3.79 3.79 0 01-.03-.48v-.1A2.77 2.77 0 0115.77 17h.28a3.49 3.49 0 012.45-6c.85 0 1.62.3 2.23.8l1.01-1.13.09-.1a1 1 0 00.06-1.02l-3-6-.06-.1zM9.43 11h5.15L12 17.34 9.42 11zm-4.18 0h2.01l1.66 4.09L5.25 11zm1.37-6h2l-1.3 4h-2.7l2-4zm4.1 0h2.55l1.3 4H9.43l1.3-4zm4.66 0h2l2 4h-2.7l-1.3-4zM21 14.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77v.1z",
    fill: primaryFill
  }));
};

export const PremiumPerson24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PremiumPerson24FilledIcon, 'PremiumPerson24Filled');

const PremiumPerson24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 3c.24 0 .46.12.6.3l.06.1 3.26 6.02.04.1.01.03.02.1v.1c0 .07 0 .14-.02.2l-.05.13-.03.06a.8.8 0 01-.04.06.75.75 0 01-.04.05l.02-.03-1.27 1.45c-.43-.31-.92-.53-1.46-.62l.49-.55H16.6L12.7 20.52c-.12.3-.4.48-.7.48h-.1a.74.74 0 01-.1-.03h-.02a.72.72 0 01-.17-.08h-.01a.67.67 0 01-.13-.1l-9.3-10.55-.02-.04-.04-.06a.74.74 0 01-.1-.3L2 9.75v-.07l.02-.08.02-.1.02-.05.03-.06 3.25-6a.75.75 0 01.56-.38L6 3h12zm-3 7.5H9l3 7.69 3-7.69zm-7.61 0H4.4l5.35 6.07-2.37-6.07zm1.58-6H6.44L4.01 9h3.52l1.44-4.5zm4.48 0h-2.9L9.1 9h5.79l-1.44-4.5zm4.1 0h-2.52L16.47 9h3.52l-2.44-4.5zm3.45 10a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77v.1z",
    fill: primaryFill
  }));
};

export const PremiumPerson24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PremiumPerson24RegularIcon, 'PremiumPerson24Regular');

const PresenceAvailable10FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 10A5 5 0 105 0a5 5 0 000 10zm2.1-5.9L4.85 6.35a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 1.9-1.9a.5.5 0 01.7.71z",
    fill: primaryFill
  }));
};

export const PresenceAvailable10Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAvailable10FilledIcon, 'PresenceAvailable10Filled');

const PresenceAvailable10RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 0a5 5 0 100 10A5 5 0 005 0zM1 5a4 4 0 118 0 4 4 0 01-8 0zm6.1-1.6c.2.2.2.5 0 .7L4.85 6.35a.5.5 0 01-.7 0l-1-1a.5.5 0 11.7-.7l.65.64 1.9-1.9c.2-.19.5-.19.7 0z",
    fill: primaryFill
  }));
};

export const PresenceAvailable10Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAvailable10RegularIcon, 'PresenceAvailable10Regular');

const PresenceAvailable12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 12A6 6 0 106 0a6 6 0 000 12zm2.53-6.72L5.78 8.03c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 011.06-1.06l.47.47 2.22-2.22a.75.75 0 011.06 1.06z",
    fill: primaryFill
  }));
};

export const PresenceAvailable12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAvailable12FilledIcon, 'PresenceAvailable12Filled');

const PresenceAvailable12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 0a6 6 0 100 12A6 6 0 006 0zM1.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm7.03-1.78c.3.3.3.77 0 1.06L5.78 8.03c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 011.06-1.06l.47.47 2.22-2.22c.3-.3.77-.3 1.06 0z",
    fill: primaryFill
  }));
};

export const PresenceAvailable12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAvailable12RegularIcon, 'PresenceAvailable12Regular');

const PresenceAvailable16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 16A8 8 0 108 0a8 8 0 000 16zm3.7-9.3l-4 4a1 1 0 01-1.41 0l-2-2a1 1 0 111.42-1.4L7 8.58l3.3-3.3a1 1 0 011.4 1.42z",
    fill: primaryFill
  }));
};

export const PresenceAvailable16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAvailable16FilledIcon, 'PresenceAvailable16Filled');

const PresenceAvailable16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.7 6.7a1 1 0 00-1.4-1.4L7 8.58l-1.3-1.3a1 1 0 00-1.4 1.42l2 2a1 1 0 001.4 0l4-4zM0 8a8 8 0 1116 0A8 8 0 010 8zm8-6a6 6 0 100 12A6 6 0 008 2z",
    fill: primaryFill
  }));
};

export const PresenceAvailable16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAvailable16RegularIcon, 'PresenceAvailable16Regular');

const PresenceAvailable20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 20a10 10 0 100-20 10 10 0 000 20zm4.2-11.8l-4.5 4.5a1 1 0 01-1.4 0l-2-2a1 1 0 111.4-1.4L9 10.58l3.8-3.8a1 1 0 111.4 1.42z",
    fill: primaryFill
  }));
};

export const PresenceAvailable20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAvailable20FilledIcon, 'PresenceAvailable20Filled');

const PresenceAvailable20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 0a10 10 0 100 20 10 10 0 000-20zM2 10a8 8 0 1116 0 8 8 0 01-16 0zm12.2-3.2a1 1 0 010 1.4l-4.5 4.5a1 1 0 01-1.4 0l-2-2a1 1 0 011.4-1.4L9 10.58l3.8-3.8a1 1 0 011.4 0z",
    fill: primaryFill
  }));
};

export const PresenceAvailable20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAvailable20RegularIcon, 'PresenceAvailable20Regular');

const PresenceAvailable24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 24a12 12 0 100-24 12 12 0 000 24zm5.06-13.44l-5.5 5.5a1.5 1.5 0 01-2.12 0l-2-2a1.5 1.5 0 012.12-2.12l.94.94 4.44-4.44a1.5 1.5 0 012.12 2.12z",
    fill: primaryFill
  }));
};

export const PresenceAvailable24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAvailable24FilledIcon, 'PresenceAvailable24Filled');

const PresenceAvailable24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 0a12 12 0 100 24 12 12 0 000-24zM3 12a9 9 0 1118 0 9 9 0 01-18 0zm14.06-3.56a1.5 1.5 0 010 2.12l-5.5 5.5a1.5 1.5 0 01-2.12 0l-2-2a1.5 1.5 0 012.12-2.12l.94.94 4.44-4.44a1.5 1.5 0 012.12 0z",
    fill: primaryFill
  }));
};

export const PresenceAvailable24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAvailable24RegularIcon, 'PresenceAvailable24Regular');

const PresenceAway10FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 10A5 5 0 105 0a5 5 0 000 10zm0-7v1.8l1.35 1.35a.5.5 0 11-.7.7l-1.5-1.5A.5.5 0 014 5V3a.5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const PresenceAway10Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAway10FilledIcon, 'PresenceAway10Filled');

const PresenceAway12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 12A6 6 0 106 0a6 6 0 000 12zm.5-8.75v2.4l1.49 1.28A.75.75 0 117 8.07l-1.75-1.5A.75.75 0 015 6V3.25a.75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const PresenceAway12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAway12FilledIcon, 'PresenceAway12Filled');

const PresenceAway16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 16A8 8 0 108 0a8 8 0 000 16zm.5-11.5v3.02l2.12 1.7a1 1 0 11-1.24 1.56l-2.5-2A1 1 0 016.5 8V4.5a1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const PresenceAway16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAway16FilledIcon, 'PresenceAway16Filled');

const PresenceAway20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 20a10 10 0 100-20 10 10 0 000 20zm0-14V9.6l2.7 2.7a1 1 0 01-1.4 1.42l-3-3A1 1 0 018 10V6a1 1 0 112 0z",
    fill: primaryFill
  }));
};

export const PresenceAway20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAway20FilledIcon, 'PresenceAway20Filled');

const PresenceAway24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 24a12 12 0 100-24 12 12 0 000 24zm1-17.5v4.81l2.98 2.55a1.5 1.5 0 01-1.96 2.28l-3.5-3A1.5 1.5 0 0110 12V6.5a1.5 1.5 0 013 0z",
    fill: primaryFill
  }));
};

export const PresenceAway24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceAway24FilledIcon, 'PresenceAway24Filled');

const PresenceBlocked10RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5A5 5 0 100 5a5 5 0 0010 0zM9 5a4 4 0 01-6.45 3.16l5.61-5.61C8.69 3.22 9 4.08 9 5zM7.45 1.84L1.84 7.45a4 4 0 015.61-5.61z",
    fill: primaryFill
  }));
};

export const PresenceBlocked10Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceBlocked10RegularIcon, 'PresenceBlocked10Regular');

const PresenceBlocked12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 6A6 6 0 110 6a6 6 0 0112 0zm-1.5 0c0-.97-.3-1.87-.83-2.6L3.39 9.66A4.5 4.5 0 0010.5 6zM8.6 2.33a4.5 4.5 0 00-6.28 6.28l6.29-6.28z",
    fill: primaryFill
  }));
};

export const PresenceBlocked12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceBlocked12RegularIcon, 'PresenceBlocked12Regular');

const PresenceBlocked16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-2 0c0-1.3-.41-2.5-1.1-3.48L4.51 12.9A6 6 0 0014 8zm-2.52-4.9a6 6 0 00-8.37 8.37l8.37-8.36z",
    fill: primaryFill
  }));
};

export const PresenceBlocked16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceBlocked16RegularIcon, 'PresenceBlocked16Regular');

const PresenceBlocked20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20 10a10 10 0 10-20 0 10 10 0 0020 0zm-2 0a8 8 0 01-12.9 6.32L16.31 5.09A7.97 7.97 0 0118 10zm-3.1-6.32L3.69 14.91A8 8 0 0114.91 3.68z",
    fill: primaryFill
  }));
};

export const PresenceBlocked20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceBlocked20RegularIcon, 'PresenceBlocked20Regular');

const PresenceBlocked24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 12a12 12 0 11-24 0 12 12 0 0124 0zm-3 0c0-1.94-.62-3.74-1.66-5.21L6.79 19.34A9 9 0 0021 12zm-3.79-7.34A9 9 0 004.66 17.21L17.21 4.66z",
    fill: primaryFill
  }));
};

export const PresenceBlocked24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceBlocked24RegularIcon, 'PresenceBlocked24Regular');

const PresenceBusy10FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5A5 5 0 110 5a5 5 0 0110 0z",
    fill: primaryFill
  }));
};

export const PresenceBusy10Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceBusy10FilledIcon, 'PresenceBusy10Filled');

const PresenceBusy12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 6A6 6 0 110 6a6 6 0 0112 0z",
    fill: primaryFill
  }));
};

export const PresenceBusy12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceBusy12FilledIcon, 'PresenceBusy12Filled');

const PresenceBusy16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0z",
    fill: primaryFill
  }));
};

export const PresenceBusy16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceBusy16FilledIcon, 'PresenceBusy16Filled');

const PresenceBusy20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20 10a10 10 0 11-20 0 10 10 0 0120 0z",
    fill: primaryFill
  }));
};

export const PresenceBusy20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceBusy20FilledIcon, 'PresenceBusy20Filled');

const PresenceBusy24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 12a12 12 0 11-24 0 12 12 0 0124 0z",
    fill: primaryFill
  }));
};

export const PresenceBusy24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceBusy24FilledIcon, 'PresenceBusy24Filled');

const PresenceDnd10FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 10A5 5 0 105 0a5 5 0 000 10zM3.5 4.5h3a.5.5 0 010 1h-3a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const PresenceDnd10Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceDnd10FilledIcon, 'PresenceDnd10Filled');

const PresenceDnd10RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 0a5 5 0 100 10A5 5 0 005 0zM1 5a4 4 0 118 0 4 4 0 01-8 0zm2 0c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3A.5.5 0 013 5z",
    fill: primaryFill
  }));
};

export const PresenceDnd10Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceDnd10RegularIcon, 'PresenceDnd10Regular');

const PresenceDnd12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 12A6 6 0 106 0a6 6 0 000 12zM3.75 5.25h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const PresenceDnd12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceDnd12FilledIcon, 'PresenceDnd12Filled');

const PresenceDnd12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 0a6 6 0 100 12A6 6 0 006 0zM1.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3 6c0-.41.34-.75.75-.75h4.5a.75.75 0 010 1.5h-4.5A.75.75 0 013 6z",
    fill: primaryFill
  }));
};

export const PresenceDnd12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceDnd12RegularIcon, 'PresenceDnd12Regular');

const PresenceDnd16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 16A8 8 0 108 0a8 8 0 000 16zM5.25 7h5.5a1 1 0 110 2h-5.5a1 1 0 110-2z",
    fill: primaryFill
  }));
};

export const PresenceDnd16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceDnd16FilledIcon, 'PresenceDnd16Filled');

const PresenceDnd16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 7a1 1 0 000 2h5.5a1 1 0 100-2h-5.5zM0 8a8 8 0 1116 0A8 8 0 010 8zm8-6a6 6 0 100 12A6 6 0 008 2z",
    fill: primaryFill
  }));
};

export const PresenceDnd16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceDnd16RegularIcon, 'PresenceDnd16Regular');

const PresenceDnd20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 20a10 10 0 100-20 10 10 0 000 20zM7 9h6a1 1 0 110 2H7a1 1 0 110-2z",
    fill: primaryFill
  }));
};

export const PresenceDnd20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceDnd20FilledIcon, 'PresenceDnd20Filled');

const PresenceDnd20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 0a10 10 0 100 20 10 10 0 000-20zM2 10a8 8 0 1116 0 8 8 0 01-16 0zm4 0a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1z",
    fill: primaryFill
  }));
};

export const PresenceDnd20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceDnd20RegularIcon, 'PresenceDnd20Regular');

const PresenceDnd24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 24a12 12 0 100-24 12 12 0 000 24zM7.5 10.5h9a1.5 1.5 0 010 3h-9a1.5 1.5 0 010-3z",
    fill: primaryFill
  }));
};

export const PresenceDnd24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceDnd24FilledIcon, 'PresenceDnd24Filled');

const PresenceDnd24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 0a12 12 0 100 24 12 12 0 000-24zM3 12a9 9 0 1118 0 9 9 0 01-18 0zm3 0c0-.83.67-1.5 1.5-1.5h9a1.5 1.5 0 010 3h-9A1.5 1.5 0 016 12z",
    fill: primaryFill
  }));
};

export const PresenceDnd24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceDnd24RegularIcon, 'PresenceDnd24Regular');

const PresenceOffline10RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.85 3.15c.2.2.2.5 0 .7L5.71 5l1.14 1.15a.5.5 0 11-.7.7L5 5.71 3.85 6.85a.5.5 0 11-.7-.7L4.29 5 3.15 3.85a.5.5 0 11.7-.7L5 4.29l1.15-1.14c.2-.2.5-.2.7 0zM0 5a5 5 0 1110 0A5 5 0 010 5zm5-4a4 4 0 100 8 4 4 0 000-8z",
    fill: primaryFill
  }));
};

export const PresenceOffline10Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceOffline10RegularIcon, 'PresenceOffline10Regular');

const PresenceOffline12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.03 3.97c.3.3.3.77 0 1.06L7.06 6l.97.97a.75.75 0 01-1.06 1.06L6 7.06l-.97.97a.75.75 0 01-1.06-1.06L4.94 6l-.97-.97a.75.75 0 011.06-1.06l.97.97.97-.97c.3-.3.77-.3 1.06 0zM0 6a6 6 0 1112 0A6 6 0 010 6zm6-4.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9z",
    fill: primaryFill
  }));
};

export const PresenceOffline12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceOffline12RegularIcon, 'PresenceOffline12Regular');

const PresenceOffline16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.7 5.3a1 1 0 010 1.4L9.42 8l1.3 1.3a1 1 0 01-1.42 1.4L8 9.42l-1.3 1.3a1 1 0 01-1.4-1.42L6.58 8l-1.3-1.3a1 1 0 011.42-1.4L8 6.58l1.3-1.3a1 1 0 011.4 0zM0 8a8 8 0 1116 0A8 8 0 010 8zm8-6a6 6 0 100 12A6 6 0 008 2z",
    fill: primaryFill
  }));
};

export const PresenceOffline16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceOffline16RegularIcon, 'PresenceOffline16Regular');

const PresenceOffline20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.7 6.3a1 1 0 010 1.4L11.42 10l2.3 2.3a1 1 0 01-1.42 1.4L10 11.42l-2.3 2.3a1 1 0 01-1.4-1.42L8.58 10l-2.3-2.3a1 1 0 011.42-1.4L10 8.58l2.3-2.3a1 1 0 011.4 0zM0 10a10 10 0 1120 0 10 10 0 01-20 0zm10-8a8 8 0 100 16 8 8 0 000-16z",
    fill: primaryFill
  }));
};

export const PresenceOffline20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceOffline20RegularIcon, 'PresenceOffline20Regular');

const PresenceOffline24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.06 7.94a1.5 1.5 0 010 2.12L14.12 12l1.94 1.94a1.5 1.5 0 01-2.12 2.12L12 14.12l-1.94 1.94a1.5 1.5 0 01-2.12-2.12L9.88 12l-1.94-1.94a1.5 1.5 0 112.12-2.12L12 9.88l1.94-1.94a1.5 1.5 0 012.12 0zM0 12a12 12 0 1124 0 12 12 0 01-24 0zm12-9a9 9 0 100 18 9 9 0 000-18z",
    fill: primaryFill
  }));
};

export const PresenceOffline24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceOffline24RegularIcon, 'PresenceOffline24Regular');

const PresenceOof10RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.35 3.85a.5.5 0 10-.7-.7l-1.5 1.5a.5.5 0 000 .7l1.5 1.5a.5.5 0 10.7-.7L4.7 5.5h1.8a.5.5 0 100-1H4.7l.65-.65zM5 0a5 5 0 100 10A5 5 0 005 0zM1 5a4 4 0 118 0 4 4 0 01-8 0z",
    fill: primaryFill
  }));
};

export const PresenceOof10Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceOof10RegularIcon, 'PresenceOof10Regular');

const PresenceOof12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.28 4.53a.75.75 0 00-1.06-1.06l-2 2c-.3.3-.3.77 0 1.06l2 2a.75.75 0 001.06-1.06l-.72-.72h2.69a.75.75 0 100-1.5h-2.7l.73-.72zM6 0a6 6 0 100 12A6 6 0 006 0zM1.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0z",
    fill: primaryFill
  }));
};

export const PresenceOof12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceOof12RegularIcon, 'PresenceOof12Regular');

const PresenceOof16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.2 6.2a1 1 0 10-1.4-1.4L4.3 7.3a1 1 0 000 1.4l2.5 2.5a1 1 0 001.4-1.4L7.42 9H11a1 1 0 100-2H7.41l.8-.8zM8 0a8 8 0 100 16A8 8 0 008 0zM2 8a6 6 0 1112 0A6 6 0 012 8z",
    fill: primaryFill
  }));
};

export const PresenceOof16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceOof16RegularIcon, 'PresenceOof16Regular');

const PresenceOof20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.7 7.7A1 1 0 109.28 6.3l-3 3a1 1 0 000 1.41l3 3a1 1 0 101.42-1.41l-1.3-1.3H13a1 1 0 100-2H9.4l1.3-1.29zM10 0a10 10 0 100 20 10 10 0 000-20zM2 10a8 8 0 1116 0 8 8 0 01-16 0z",
    fill: primaryFill
  }));
};

export const PresenceOof20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceOof20RegularIcon, 'PresenceOof20Regular');

const PresenceOof24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.56 9.06a1.5 1.5 0 00-2.12-2.12l-4 4a1.5 1.5 0 000 2.12l4 4a1.5 1.5 0 002.12-2.12l-1.44-1.44h5.38a1.5 1.5 0 100-3h-5.38l1.44-1.44zM12 0a12 12 0 100 24 12 12 0 000-24zM3 12a9 9 0 1118 0 9 9 0 01-18 0z",
    fill: primaryFill
  }));
};

export const PresenceOof24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceOof24RegularIcon, 'PresenceOof24Regular');

const PresenceUnknown10RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 1a4 4 0 100 8 4 4 0 000-8zM0 5a5 5 0 1110 0A5 5 0 010 5z",
    fill: primaryFill
  }));
};

export const PresenceUnknown10Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceUnknown10RegularIcon, 'PresenceUnknown10Regular');

const PresenceUnknown12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 1.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zM0 6a6 6 0 1112 0A6 6 0 010 6z",
    fill: primaryFill
  }));
};

export const PresenceUnknown12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceUnknown12RegularIcon, 'PresenceUnknown12Regular');

const PresenceUnknown16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 2a6 6 0 100 12A6 6 0 008 2zM0 8a8 8 0 1116 0A8 8 0 010 8z",
    fill: primaryFill
  }));
};

export const PresenceUnknown16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceUnknown16RegularIcon, 'PresenceUnknown16Regular');

const PresenceUnknown20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a8 8 0 100 16 8 8 0 000-16zM0 10a10 10 0 1120 0 10 10 0 01-20 0z",
    fill: primaryFill
  }));
};

export const PresenceUnknown20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceUnknown20RegularIcon, 'PresenceUnknown20Regular');

const PresenceUnknown24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 3a9 9 0 100 18 9 9 0 000-18zM0 12a12 12 0 1124 0 12 12 0 01-24 0z",
    fill: primaryFill
  }));
};

export const PresenceUnknown24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenceUnknown24RegularIcon, 'PresenceUnknown24Regular');

const Presenter20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 4a2 2 0 11-4 0 2 2 0 014 0zM7 14.78v1.72c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1.72a.5.5 0 01.15-.36l3.7-3.56a.5.5 0 00-.34-.86H3.49a.5.5 0 00-.35.86l3.7 3.56c.1.1.16.23.16.36zM8.5 7C7.67 7 7 7.67 7 8.5V9h6v-.5c0-.83-.67-1.5-1.5-1.5h-3z",
    fill: primaryFill
  }));
};

export const Presenter20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Presenter20FilledIcon, 'Presenter20Filled');

const Presenter20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6a2 2 0 100-4 2 2 0 000 4zm0-1a1 1 0 110-2 1 1 0 010 2zM8.5 8a.5.5 0 00-.5.5V9H7v-.5C7 7.67 7.67 7 8.5 7h3c.83 0 1.5.67 1.5 1.5V9h-1v-.5a.5.5 0 00-.5-.5h-3zM7 14.78v1.72c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1.72a.5.5 0 01.15-.36l3.7-3.56a.5.5 0 00-.34-.86H3.49a.5.5 0 00-.35.86l3.7 3.56c.1.1.16.23.16.36zm1 1.72v-1.72c0-.4-.17-.8-.46-1.08L4.74 11h10.53l-2.81 2.7c-.3.29-.46.68-.46 1.08v1.72a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const Presenter20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Presenter20RegularIcon, 'Presenter20Regular');

const Presenter24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.24 13c.71 0 1.03.89.47 1.33L16 18.11v1.64C16 21 14.99 22 13.75 22h-3.5C9.01 22 8 21 8 19.75v-1.64l-4.72-3.78A.75.75 0 013.75 13h16.5zM8.75 9h6.5c.91 0 1.67.7 1.74 1.6V12H7v-1.25c0-.92.7-1.67 1.6-1.74L8.76 9h6.5-6.5zM12 2a3 3 0 110 6 3 3 0 010-6z",
    fill: primaryFill
  }));
};

export const Presenter24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Presenter24FilledIcon, 'Presenter24Filled');

const Presenter24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.24 13c.71 0 1.03.89.47 1.33L16 18.11v1.64C16 21 14.99 22 13.75 22h-3.5C9.01 22 8 21 8 19.75v-1.64l-4.72-3.78A.75.75 0 013.75 13h16.5zm-2.13 1.5H5.89l3.33 2.66c.18.15.28.36.28.59v2c0 .42.34.75.75.75h3.5c.41 0 .75-.33.75-.75v-2c0-.23.1-.44.28-.59l3.33-2.66zM8.75 9h6.5c.91 0 1.67.7 1.74 1.6V12h-1.5v-1.25a.25.25 0 00-.19-.24l-.05-.01h-6.5a.25.25 0 00-.24.2l-.01.05V12H7v-1.25c0-.92.7-1.67 1.6-1.74L8.76 9h6.5-6.5zM12 2a3 3 0 110 6 3 3 0 010-6zm0 1.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const Presenter24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Presenter24RegularIcon, 'Presenter24Regular');

const PresenterOff20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.15 7.85c-.1.2-.15.42-.15.65V9h1.3l1 1H3.5a.5.5 0 00-.36.86l3.7 3.56c.1.1.16.23.16.36v1.72c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1.72a.5.5 0 01.15-.36l.29-.27 3.7 3.7a.5.5 0 00.71-.7l-10-10-5-5a.5.5 0 10-.7.7l5 5zm9.7 3.01l-1.97 1.9L12.12 10h4.39a.5.5 0 01.35.86zM13 9h-1.88l-2-2h2.38c.83 0 1.5.67 1.5 1.5V9zm-3-3a2 2 0 100-4 2 2 0 000 4z",
    fill: primaryFill
  }));
};

export const PresenterOff20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenterOff20FilledIcon, 'PresenterOff20Filled');

const PresenterOff20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 8.5c0-.23.05-.45.15-.65l-5-5a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-3.71-3.7-.29.27a.5.5 0 00-.15.36v1.72c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 017 16.5v-1.72a.5.5 0 00-.15-.36l-3.7-3.56a.5.5 0 01.34-.86h5.8l-1-1H7v-.5zm3.3 2.5H4.72l2.81 2.7c.3.29.46.68.46 1.08v1.72c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-1.72c0-.4.17-.8.46-1.08l.27-.26L10.3 11zM12 4a2 2 0 11-4 0 2 2 0 014 0zm-1 0a1 1 0 10-2 0 1 1 0 002 0zm-.88 4h1.38c.28 0 .5.22.5.5V9h1v-.5c0-.83-.67-1.5-1.5-1.5H9.12l1 1zm4.76 4.76l-.7-.7L15.26 11h-2.15l-1-1h4.39a.5.5 0 01.35.86l-1.98 1.9z",
    fill: primaryFill
  }));
};

export const PresenterOff20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenterOff20RegularIcon, 'PresenterOff20Regular');

const PresenterOff24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 10-1.06 1.06l5.85 5.86C7.44 9.4 7 10.02 7 10.75V12h3.94l1 1h-8.2c-.7 0-1.01.89-.46 1.33L8 18.11v1.64C8 21 9 22 10.25 22h3.5c1.24 0 2.25-1 2.25-2.25v-1.64l.58-.47 4.14 4.14a.75.75 0 001.06-1.06L3.28 2.22zM16.18 13l2.76 2.76 1.77-1.43a.75.75 0 00-.47-1.33h-4.06zm-4-4l3 3H17V10.61C16.92 9.7 16.16 9 15.24 9h-3.06zM12 8a3 3 0 01-.98-.16L9.16 5.98A3 3 0 1112 8z",
    fill: primaryFill
  }));
};

export const PresenterOff24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenterOff24FilledIcon, 'PresenterOff24Filled');

const PresenterOff24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 10-1.06 1.06l5.85 5.86C7.44 9.4 7 10.02 7 10.75V12h1.5v-1.31c.03-.1.13-.19.25-.19h.69l2.5 2.5h-8.2c-.7 0-1.01.89-.46 1.33L8 18.11v1.64C8 21 9 22 10.25 22h3.5c1.24 0 2.25-1 2.25-2.25v-1.64l.58-.47 4.14 4.14a.75.75 0 001.06-1.06L3.28 2.22zm12.23 14.35l-.73.6a.75.75 0 00-.28.58v2c0 .42-.34.75-.75.75h-3.5a.75.75 0 01-.75-.75v-2c0-.23-.1-.44-.28-.59L5.89 14.5h7.55l2.07 2.07zM12 8a3 3 0 01-.98-.16L9.16 5.98A3 3 0 1112 8zm0-4.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm8.24 9.5h-4.06l2.76 2.76 1.77-1.43a.75.75 0 00-.47-1.33zm-6.56-2.5L12.18 9h3.06c.92 0 1.68.7 1.75 1.6V12h-1.5v-1.25a.25.25 0 00-.19-.24l-.06-.01h-1.56z",
    fill: primaryFill
  }));
};

export const PresenterOff24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PresenterOff24RegularIcon, 'PresenterOff24Regular');

const PreviewLink16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5v1h8V5H4zm6 4v2h2V9h-2zM1 4.75A2.75 2.75 0 013.75 2h8.5A2.75 2.75 0 0115 4.75v6.5A2.75 2.75 0 0112.25 14h-8.5A2.75 2.75 0 011 11.25v-6.5zm2-.25v2c0 .28.22.5.5.5h9a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5zm6 4v3c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5zm-5.5 0a.5.5 0 000 1h4a.5.5 0 000-1h-4zM3 11c0 .28.22.5.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PreviewLink16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PreviewLink16FilledIcon, 'PreviewLink16Filled');

const PreviewLink16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-2zM4 5v1h8V5H4zm5.5 3a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3zm.5 3V9h2v2h-2zM3 9c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4A.5.5 0 013 9zm.5 1.5a.5.5 0 000 1h4a.5.5 0 100-1h-4zM1 4.5A2.5 2.5 0 013.5 2h9A2.5 2.5 0 0115 4.5v7a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 011 11.5v-7zM3.5 3C2.67 3 2 3.67 2 4.5v7c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-9z",
    fill: primaryFill
  }));
};

export const PreviewLink16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PreviewLink16RegularIcon, 'PreviewLink16Regular');

const PreviewLink20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 6v2h10V6H5zm7 5v3h3v-3h-3zM2 5.75A2.75 2.75 0 014.75 3h10.5A2.75 2.75 0 0118 5.75v8.5A2.75 2.75 0 0115.25 17H4.75A2.75 2.75 0 012 14.25v-8.5zm2-.25v3c0 .27.22.5.5.5h11a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5zm7 5v4c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5zm-6.5 0a.5.5 0 000 1h5a.5.5 0 000-1h-5zM4 14c0 .28.22.5.5.5h5a.5.5 0 000-1h-5a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const PreviewLink20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PreviewLink20FilledIcon, 'PreviewLink20Filled');

const PreviewLink20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-3zM5 6v2h10V6H5zm6.5 4a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-4zm.5 4v-3h3v3h-3zm-8-3c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5A.5.5 0 014 11zm.5 2.5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM2 5.5A2.5 2.5 0 014.5 3h11A2.5 2.5 0 0118 5.5v9a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 14.5v-9zM4.5 4C3.67 4 3 4.67 3 5.5v9c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-11z",
    fill: primaryFill
  }));
};

export const PreviewLink20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PreviewLink20RegularIcon, 'PreviewLink20Regular');

const PreviewLink24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.02 7v2h11.96V7H6.02zm8.96 6.48v3h3v-3h-3zM2 5.75A2.75 2.75 0 014.75 3h14.5A2.75 2.75 0 0122 5.75v12.5A2.75 2.75 0 0119.25 21H4.75A2.75 2.75 0 012 18.25V5.75zm2.52.5v3.5c0 .41.34.75.75.75h13.46c.41 0 .75-.34.75-.75v-3.5a.75.75 0 00-.75-.75H5.27a.75.75 0 00-.75.75zm8.96 6.48v4.5c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75v-4.5a.75.75 0 00-.75-.75h-4.5a.75.75 0 00-.75.75zm-8.2-.23a.75.75 0 000 1.5h5.97a.75.75 0 000-1.5H5.27zm-.76 4.25c0 .41.34.75.75.75h5.98a.75.75 0 000-1.5H5.27a.75.75 0 00-.75.75z",
    fill: primaryFill
  }));
};

export const PreviewLink24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PreviewLink24FilledIcon, 'PreviewLink24Filled');

const PreviewLink24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.52 6.25c0-.41.34-.75.75-.75h13.46c.41 0 .75.34.75.75v3.5c0 .41-.34.75-.75.75H5.27a.75.75 0 01-.75-.75v-3.5zm1.5.75v2h11.96V7H6.02zm8.21 4.98a.75.75 0 00-.75.75v4.5c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75v-4.5a.75.75 0 00-.75-.75h-4.5zm.75 4.5v-3h3v3h-3zM4.52 13.25c0-.41.34-.75.75-.75h5.98a.75.75 0 010 1.5H5.27a.75.75 0 01-.75-.75zM5.27 16a.75.75 0 000 1.5h5.98a.75.75 0 000-1.5H5.27zM2 5.75A2.75 2.75 0 014.75 3h14.5A2.75 2.75 0 0122 5.75v12.5A2.75 2.75 0 0119.25 21H4.75A2.75 2.75 0 012 18.25V5.75zM4.75 4.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25V5.75c0-.69-.56-1.25-1.25-1.25H4.75z",
    fill: primaryFill
  }));
};

export const PreviewLink24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PreviewLink24RegularIcon, 'PreviewLink24Regular');

const Previous16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 3a1 1 0 00-1.58-.81l-7 4.96a1 1 0 000 1.63l7 5.03a1 1 0 001.58-.8V3zM2 2.5a.5.5 0 011 0v11a.5.5 0 01-1 0v-11z",
    fill: primaryFill
  }));
};

export const Previous16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Previous16FilledIcon, 'Previous16Filled');

const Previous16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 2.5a.5.5 0 011 0v11a.5.5 0 01-1 0v-11zM14 3a1 1 0 00-1.58-.81l-7 4.96a1 1 0 000 1.63l7 5.03a1 1 0 001.58-.8V3zM6 7.96L13 3v10L6 7.96z",
    fill: primaryFill
  }));
};

export const Previous16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Previous16RegularIcon, 'Previous16Regular');

const Previous20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 4.25c0-1-1.12-1.6-1.95-1.04l-8.5 5.71c-.73.5-.73 1.57 0 2.07l8.5 5.8c.83.56 1.95-.03 1.95-1.04V4.25zM3 3.5a.5.5 0 011 0v13a.5.5 0 01-1 0v-13z",
    fill: primaryFill
  }));
};

export const Previous20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Previous20FilledIcon, 'Previous20Filled');

const Previous20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 3.5a.5.5 0 011 0v13a.5.5 0 01-1 0v-13zm14 .75c0-1-1.12-1.6-1.95-1.04l-8.5 5.71c-.73.5-.73 1.57 0 2.07l8.5 5.8c.83.56 1.95-.03 1.95-1.04V4.25zm-1.39-.2c.17-.12.39 0 .39.2v11.5c0 .2-.22.32-.4.2l-8.49-5.78a.25.25 0 010-.42l8.5-5.7z",
    fill: primaryFill
  }));
};

export const Previous20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Previous20RegularIcon, 'Previous20Regular');

const Previous24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 3.75a.75.75 0 011.5 0v16.5a.75.75 0 01-1.5 0V3.75zm18 1c0-1.4-1.58-2.24-2.74-1.44l-10.5 7.2a1.75 1.75 0 000 2.87l10.5 7.3c1.15.81 2.74-.02 2.74-1.43V4.75z",
    fill: primaryFill
  }));
};

export const Previous24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Previous24FilledIcon, 'Previous24Filled');

const Previous24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 4.75c0-1.4-1.58-2.24-2.74-1.44l-10.5 7.2a1.75 1.75 0 000 2.87l10.5 7.3c1.15.81 2.74-.02 2.74-1.43V4.75zm-1.9-.2c.17-.12.4 0 .4.2v14.5c0 .2-.23.32-.4.2l-10.5-7.3a.25.25 0 01.01-.41l10.5-7.2zM3 3.75a.75.75 0 011.5 0v16.5a.75.75 0 01-1.5 0V3.75z",
    fill: primaryFill
  }));
};

export const Previous24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Previous24RegularIcon, 'Previous24Regular');

const Previous28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3.75a.75.75 0 00-1.5 0v20.5a.75.75 0 001.5 0V3.75zM25 5.25a2.25 2.25 0 00-3.53-1.84l-12.5 8.68a2.25 2.25 0 00-.02 3.68l12.5 8.81A2.25 2.25 0 0025 22.75V5.25z",
    fill: primaryFill
  }));
};

export const Previous28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Previous28FilledIcon, 'Previous28Filled');

const Previous28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3.75a.75.75 0 00-1.5 0v20.5a.75.75 0 001.5 0V3.75zM25 5.25a2.25 2.25 0 00-3.53-1.84l-12.5 8.68a2.25 2.25 0 00-.02 3.68l12.5 8.81A2.25 2.25 0 0025 22.75V5.25zm-2.68-.61a.75.75 0 011.18.61v17.5c0 .6-.69.96-1.18.6l-12.5-8.8a.75.75 0 010-1.23l12.5-8.68z",
    fill: primaryFill
  }));
};

export const Previous28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Previous28RegularIcon, 'Previous28Regular');

const Previous32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 5a1 1 0 00-2 0v22a1 1 0 102 0V5zm22 1.5c0-2-2.23-3.19-3.9-2.07l-14 9.43A2.5 2.5 0 0010.1 18l14 9.56A2.5 2.5 0 0028 25.5v-19z",
    fill: primaryFill
  }));
};

export const Previous32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Previous32FilledIcon, 'Previous32Filled');

const Previous32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 5a1 1 0 00-2 0v22a1 1 0 102 0V5zm22 1.5c0-2-2.23-3.19-3.9-2.07l-14 9.43A2.5 2.5 0 0010.1 18l14 9.56A2.5 2.5 0 0028 25.5v-19zm-2.78-.41a.5.5 0 01.78.41v19a.5.5 0 01-.78.4l-14-9.55a.5.5 0 010-.83l14-9.43z",
    fill: primaryFill
  }));
};

export const Previous32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Previous32RegularIcon, 'Previous32Regular');

const Previous48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.25 6c.69 0 1.25.56 1.25 1.25v33.5a1.25 1.25 0 11-2.5 0V7.25C6 6.56 6.56 6 7.25 6zM42 9.26a3.25 3.25 0 00-5.09-2.68l-21.5 14.74a3.25 3.25 0 000 5.36l21.5 14.74A3.25 3.25 0 0042 38.74V9.26z",
    fill: primaryFill
  }));
};

export const Previous48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Previous48FilledIcon, 'Previous48Filled');